import React, { PureComponent } from "react";
import _ from "lodash";
import request from "superagent";
import { Tabs, Tab, Button, FormControl, InputGroup, FormGroup, ControlLabel } from "react-bootstrap";
import Modal from "react-responsive-modal";
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from "react-sortable-hoc";

import InlineFilePicker from "../inlineFilePicker";
import DriveWrapper from "../driveWrapper";
import JsonEditor from "./jsonEditor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ImageEditorModal from "../../shared/imageEditorModal";
import DriveMetadataEditorModal, {
	MAX_METADATA_TITLE_CHARS,
	MAX_METADATA_DESCRIPTION_CHARS,
	MAX_METADATA_TRANSCRIPT_CHARS,
	MAX_METADATA_TRANSCRIPT_VTT_CHARS,
	TRANSCRIPT_PROVIDER_OPENAI,
	TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE,
	TAGS_PROVIDER_OPENAI,
	TAGS_PROVIDER_REKOGNITION
} from "../../shared/driveMetadataEditorModal";
import { showError, showSuccess } from "../../../actions/alertActions";
import { getJwtToken } from "../../../actions/user";
import env from "../../../constants/env";
import {
	getDriveObject,
	getUrlForExternalResource,
	getFullObjectPath,
	listDriveForSelectedFolderSilently,
	setActiveTreeCursorForDriveGuid,
	uploadFile,
	moveFile
} from "../../../actions/drive";
import { fetchAllFileObjectsForFolder, getDriveItemByGuid } from "../../../drive/driveTreeBuilder";
import { refreshCredentials } from "../../../utils/securityUtil";
import { getOrgId } from "../../../actions/orgsActions";
import { getMediaType } from "../../../utils/mediaUtils";
import {
	getAudioTranscriptionsLambda,
	getAwsTranscribeLambda,
	getImageDescriptionsLambda,
	getPdfResponsesLambda,
	getRekognitionTagsLambda,
	getResponsesCreateLambda
} from "../../../ai/aiAssistant";
import { getClient2 } from "../../../search/algolia";
import {
	AUTHORING_VISUAL_STORAGE_MODE,
	AUTHORING_COLLECTION_CANDIDATES,
	collectGenericMapperCandidates,
	getDatasourcePathCandidateDisplay,
	getGenericDatasourceRows,
	isCanonicalAuthoringDatasourceDocument,
	updateMappedRowVisuals
} from "../../../utils/datasourceVisualOverlay";

const DEFAULT_JSON_CONTENT = `{
    "prop": "value"
}`;
const IMAGE_FIELD_KEYS = ["image", "imageDriveGuid", "imageDrivePath", "imageDriveUrl"];
const SWATCH_FIELD_KEYS = ["swatchColor", "hex", "hexColor", "colorHex"];
const PICKER_STORAGE_MODE_ARRAY = "array";
const PICKER_STORAGE_MODE_MAP = "map";
const PICKER_STORAGE_MODE_BOTH = "both";
const OPTION_VALUE_AUTO_FORMATS = [
	{ value: "dashed", label: "dashed (kebab-case)" },
	{ value: "camel", label: "camelCase" },
	{ value: "pascal", label: "PascalCase" },
	{ value: "snake", label: "underscores (snake_case)" }
];
const MANAGED_FAMILY_KEYS = ["id", "label", "column", "items", "allKeys", "commonKeys", "itemCount"];
const MANAGED_OPTION_KEYS = ["label", "value", "rowNumber", "isSelectable", "isBold", "isHeader", "isSpacer", ...IMAGE_FIELD_KEYS, ...SWATCH_FIELD_KEYS];
const CUSTOM_FIELD_TYPE_STRING = "string";
const CUSTOM_FIELD_TYPE_NUMBER = "number";
const CUSTOM_FIELD_TYPE_BOOLEAN = "boolean";
const CUSTOM_FIELD_TYPE_NULL = "null";
const CUSTOM_FIELD_TYPE_JSON = "json";
const CUSTOM_FIELD_TYPES = [
	CUSTOM_FIELD_TYPE_STRING,
	CUSTOM_FIELD_TYPE_NUMBER,
	CUSTOM_FIELD_TYPE_BOOLEAN,
	CUSTOM_FIELD_TYPE_NULL,
	CUSTOM_FIELD_TYPE_JSON
];
const AUTHORING_ENTITY_FIELD_CONFIGS = {
	"collections.selectionGroupsById": [
		{ key: "id", label: "Entity ID", required: true, placeholder: "exterior-colors" },
		{ key: "label", label: "Label", placeholder: "Exterior Colors" },
		{ key: "column", label: "Column", placeholder: "Exterior" }
	],
	"collections.selectionOptionsById": [
		{ key: "id", label: "Entity ID", required: true, placeholder: "exterior-color-alabaster" },
		{ key: "label", label: "Label", placeholder: "Alabaster" },
		{ key: "value", label: "Value", placeholder: "alabaster" },
		{ key: "groupIds", label: "Selection Group IDs", type: "multiValue", placeholder: "exterior-colors, interior-colors" },
		{ key: "isSelectable", label: "Selectable", type: "boolean", defaultValue: true },
		{ key: "isBold", label: "Bold", type: "boolean", defaultValue: false },
		{ key: "isHeader", label: "Header Row", type: "boolean", defaultValue: false },
		{ key: "isSpacer", label: "Spacer Row", type: "boolean", defaultValue: false }
	],
	"collections.communitiesById": [
		{ key: "id", label: "Entity ID", required: true, placeholder: "forest-edge" },
		{ key: "value", label: "Display Name", placeholder: "Forest Edge" },
		{ key: "county", label: "County", placeholder: "BUTLER" }
	],
	"collections.pricingVariantsById": [
		{ key: "id", label: "Entity ID", required: true, placeholder: "forest-edge-phase-1" },
		{ key: "value", label: "Display Name", placeholder: "Forest Edge - Phase 1" },
		{ key: "communityId", label: "Community ID", placeholder: "forest-edge" },
		{ key: "phaseOrLotLabel", label: "Phase / Lot Label", placeholder: "Phase 1" },
		{ key: "county", label: "County", placeholder: "BUTLER" }
	],
	"collections.modelsById": [
		{ key: "id", label: "Entity ID", required: true, placeholder: "georgetown" },
		{ key: "modelName", label: "Model Name", placeholder: "GEORGETOWN" },
		{ key: "value", label: "Display Value", placeholder: "GEORGETOWN" },
		{ key: "squareFeet", label: "Square Feet", type: "number", placeholder: "2870" },
		{ key: "unit", label: "Unit", placeholder: "sq ft", defaultValue: "sq ft" },
		{ key: "pricingVariantId", label: "Pricing Variant ID", placeholder: "forest-edge-f" },
		{ key: "basePrice", label: "Base Price", type: "number", placeholder: "992000" }
	],
	"collections.lotsById": [
		{ key: "id", label: "Entity ID", required: true, placeholder: "forest-edge::lot-101" },
		{ key: "value", label: "Display Value", placeholder: "Lot 101" },
		{ key: "lotNumber", label: "Lot Number", type: "number", placeholder: "101" },
		{ key: "address", label: "Address", placeholder: "103 MORNINGSIDE DRIVE ..." },
		{ key: "pricingVariantId", label: "Pricing Variant ID", placeholder: "forest-edge-f" },
		{ key: "lotPrice", label: "Lot Price", type: "number", placeholder: "180000" },
		{ key: "lotPremium", label: "Lot Premium", type: "number", placeholder: "0" },
		{ key: "garage", label: "Garage", placeholder: "LEFT" },
		{ key: "walkout", label: "Walkout", placeholder: "BASEMENT" }
	]
};
const AUTHORING_ORDER_PATHS_BY_COLLECTION = {
	"collections.selectionGroupsById": ["orders.selectionGroupIds"],
	"collections.communitiesById": ["orders.communityIds", "orders.communityPricingVariantLookupIds"],
	"collections.pricingVariantsById": ["orders.pricingVariantIds", "orders.pricingVariantLotLookupIds", "orders.pricingVariantModelLookupIds"],
	"collections.modelsById": ["orders.modelIds"],
	"collections.lotsById": ["orders.lotIds"]
};

const DragHandle = SortableHandle(() => (
	<div style={{ cursor: "ns-resize", color: "#7b8794", padding: "4px 6px" }}>
		<FontAwesomeIcon icon="sort" />
	</div>
)); // eslint-disable-line no-unused-vars

function normalizeContent(content) {
	if (!content || _.isEmpty(content)) {
		return DEFAULT_JSON_CONTENT;
	}

	if (_.isString(content)) {
		return content;
	}

	return JSON.stringify(content, null, 4);
}

function tryParseJson(rawContent) {
	try {
		return {
			valid: true,
			parsed: JSON.parse(rawContent),
			error: null
		};
	} catch (error) {
		return {
			valid: false,
			parsed: null,
			error
		};
	}
}

function isPickerDatasourceDocument(parsedContent) {
	return !!(
		parsedContent &&
		_.isPlainObject(parsedContent) &&
		(
			(_.isPlainObject(parsedContent.pickersById) && _.keys(parsedContent.pickersById).length > 0) ||
			(_.isArray(parsedContent.pickers) && parsedContent.pickers.length > 0)
		)
	);
}

function getGenericMapperCandidates(parsedContent) {
	if (!parsedContent || !_.isPlainObject(parsedContent)) {
		return [];
	}
	return collectGenericMapperCandidates(parsedContent).filter((candidate) => candidate.supportsMapper);
}

function getMapperMode(parsedContent, genericCandidates = null) {
	if (isPickerDatasourceDocument(parsedContent)) {
		return "picker";
	}
	if (isCanonicalAuthoringDatasourceDocument(parsedContent)) {
		return "generic";
	}
	const candidates = _.isArray(genericCandidates) ? genericCandidates : getGenericMapperCandidates(parsedContent);
	return candidates.length > 0 ? "generic" : null;
}

function getGenericCandidateSummary(parsedContent, sourcePath) {
	const rows = getGenericDatasourceRows(parsedContent, sourcePath).rows;
	const matched = rows.filter((row) => hasVisualAssignment(row)).length;
	return {
		total: rows.length,
		matched,
		unmatched: rows.length - matched
	};
}

function getGenericRowDisplayLabel(row, candidate = null) {
	if (candidate && candidate.labelKey) {
		const explicitLabel = _.get(row, candidate.labelKey, "");
		if (!_.isNil(explicitLabel) && `${explicitLabel}`.trim() !== "") {
			return `${explicitLabel}`;
		}
	}
	return getOptionDisplayLabel(row);
}

function getGenericRowValueLabel(row, candidate = null) {
	if (candidate && candidate.valueKey) {
		const explicitValue = _.get(row, candidate.valueKey, "");
		if (!_.isNil(explicitValue) && `${explicitValue}`.trim() !== "") {
			return `${explicitValue}`;
		}
	}
	if (!_.isNil(row.__rowId) && `${row.__rowId}`.trim() !== "") {
		return `${row.__rowId}`;
	}
	return "";
}

function getAuthoringEntityFieldConfigs(candidate = null) {
	return _.get(AUTHORING_ENTITY_FIELD_CONFIGS, _.get(candidate, "path", ""), []);
}

function buildInitialAuthoringEntityDraft(candidate = null) {
	return getAuthoringEntityFieldConfigs(candidate).reduce((draft, field) => ({
		...draft,
		[field.key]: _.has(field, "defaultValue") ? field.defaultValue : ""
	}), {});
}

function getAuthoringCollectionKeyFromPath(path = "") {
	return `${path || ""}`.replace(/^collections\./, "");
}

function getAvailableAuthoringCollectionCandidates(parsedContent) {
	const collections = _.get(parsedContent, "collections", {});
	return AUTHORING_COLLECTION_CANDIDATES.filter((candidate) => !_.has(collections, getAuthoringCollectionKeyFromPath(candidate.path)));
}

function trimDraftValue(value) {
	return _.isString(value) ? value.trim() : value;
}

function appendUniqueItem(list = [], value) {
	if (_.isNil(value) || `${value}`.trim() === "") {
		return _.isArray(list) ? [...list] : [];
	}
	const nextList = _.isArray(list) ? [...list] : [];
	if (!nextList.includes(value)) {
		nextList.push(value);
	}
	return nextList;
}

function removeItem(list = [], value) {
	if (!_.isArray(list) || _.isNil(value) || `${value}`.trim() === "") {
		return _.isArray(list) ? [...list] : [];
	}
	return list.filter((entry) => entry !== value);
}

function parseMultiValueDraft(value) {
	if (_.isArray(value)) {
		return _.uniq(value.map((entry) => `${entry || ""}`.trim()).filter(Boolean));
	}
	if (!_.isString(value)) {
		return [];
	}
	return _.uniq(
		value
			.split(/[\n,]+/)
			.map((entry) => entry.trim())
			.filter(Boolean)
	);
}

function getSelectionOptionGroupIds(row = null, parsedContent = null) {
	if (!_.isPlainObject(row)) {
		return [];
	}
	const entityGroupIds = [
		...parseMultiValueDraft(_.get(row, "groupIds", [])),
		...parseMultiValueDraft(_.get(row, "groupId", ""))
	];
	if (!parsedContent || !_.isPlainObject(parsedContent)) {
		return _.uniq(entityGroupIds);
	}
	const optionId = row.__rowId || row.id;
	const relationshipMemberships = _.entries(_.get(parsedContent, "relationships.selectionGroupItemIdsByGroupId", {}))
		.filter(([, itemIds]) => _.isArray(itemIds) && itemIds.includes(optionId))
		.map(([groupId]) => groupId);
	return _.uniq([...entityGroupIds, ...relationshipMemberships]);
}

function syncSelectionGroupItemMetadata(nextContent, groupId) {
	if (!groupId) {
		return;
	}
	const nextItemIds = _.uniq(_.get(nextContent, ["relationships", "selectionGroupItemIdsByGroupId", groupId], []));
	_.set(nextContent, ["relationships", "selectionGroupItemIdsByGroupId", groupId], nextItemIds);
	if (_.has(nextContent, ["collections", "selectionGroupsById", groupId])) {
		_.set(nextContent, ["collections", "selectionGroupsById", groupId, "itemIds"], nextItemIds);
		_.set(nextContent, ["collections", "selectionGroupsById", groupId, "itemCount"], nextItemIds.length);
	}
}

function updateSelectionOptionMemberships(nextContent, optionId, nextGroupIdsInput = [], previousGroupIdsInput = []) {
	const nextGroupIds = _.uniq(parseMultiValueDraft(nextGroupIdsInput));
	const previousGroupIds = _.uniq(parseMultiValueDraft(previousGroupIdsInput));

	previousGroupIds
		.filter((groupId) => !nextGroupIds.includes(groupId))
		.forEach((groupId) => {
			const relationshipPath = ["relationships", "selectionGroupItemIdsByGroupId", groupId];
			_.set(nextContent, relationshipPath, removeItem(_.get(nextContent, relationshipPath, []), optionId));
			syncSelectionGroupItemMetadata(nextContent, groupId);
		});

	nextGroupIds.forEach((groupId) => {
		const relationshipPath = ["relationships", "selectionGroupItemIdsByGroupId", groupId];
		_.set(nextContent, relationshipPath, appendUniqueItem(_.get(nextContent, relationshipPath, []), optionId));
		syncSelectionGroupItemMetadata(nextContent, groupId);
	});

	if (_.has(nextContent, ["collections", "selectionOptionsById", optionId])) {
		_.set(nextContent, ["collections", "selectionOptionsById", optionId, "groupIds"], nextGroupIds);
		if (nextGroupIds.length > 0) {
			_.set(nextContent, ["collections", "selectionOptionsById", optionId, "groupId"], nextGroupIds[0]);
		} else {
			_.unset(nextContent, ["collections", "selectionOptionsById", optionId, "groupId"]);
		}
	}
}

function parseOptionalNumber(value) {
	if (_.isNil(value)) {
		return undefined;
	}
	const normalized = _.isString(value) ? value.trim().replace(/,/g, "") : value;
	if (normalized === "") {
		return undefined;
	}
	const parsed = Number(normalized);
	return Number.isFinite(parsed) ? parsed : undefined;
}

function applyOptionalField(entity = {}, key = "", value = undefined) {
	if (_.isNil(value) || value === "") {
		return entity;
	}
	entity[key] = value;
	return entity;
}

function inferDisplayNameFromId(id = "") {
	return _.startCase(`${id || ""}`.replace(/[-_]+/g, " "));
}

function buildAuthoringEntityPayload(parsedContent, candidate = null, draft = {}) {
	const path = _.get(candidate, "path", "");
	const entityId = trimDraftValue(draft.id);
	if (!entityId) {
		return { error: "Entity ID is required." };
	}

	const communitiesById = _.get(parsedContent, "collections.communitiesById", {});
	const pricingVariantsById = _.get(parsedContent, "collections.pricingVariantsById", {});
	const linkedCommunity = draft.communityId ? communitiesById[draft.communityId] : null;
	const linkedPricingVariant = draft.pricingVariantId ? pricingVariantsById[draft.pricingVariantId] : null;

	if (path === "collections.pricingVariantsById" && draft.communityId && !linkedCommunity) {
		return { error: `Community "${draft.communityId}" does not exist.` };
	}
	if (path === "collections.modelsById" && draft.pricingVariantId && !linkedPricingVariant) {
		return { error: `Pricing variant "${draft.pricingVariantId}" does not exist.` };
	}
	if (path === "collections.lotsById" && draft.pricingVariantId && !linkedPricingVariant) {
		return { error: `Pricing variant "${draft.pricingVariantId}" does not exist.` };
	}
	if (path === "collections.selectionOptionsById") {
		const missingGroupIds = parseMultiValueDraft(draft.groupIds || draft.groupId).filter(
			(groupId) => !_.has(parsedContent, ["collections", "selectionGroupsById", groupId])
		);
		if (missingGroupIds.length > 0) {
			return { error: `Selection group "${missingGroupIds[0]}" does not exist.` };
		}
	}

	let entity = { id: entityId };

	switch (path) {
		case "collections.selectionGroupsById": {
			entity = {
				id: entityId,
				label: trimDraftValue(draft.label) || inferDisplayNameFromId(entityId),
				column: trimDraftValue(draft.column) || undefined,
				itemIds: [],
				itemCount: 0
			};
			break;
		}
			case "collections.selectionOptionsById": {
				const groupIds = parseMultiValueDraft(draft.groupIds || draft.groupId);
				entity = {
					id: entityId,
					groupIds,
					groupId: groupIds[0] || undefined,
					label: trimDraftValue(draft.label) || inferDisplayNameFromId(entityId),
					value: trimDraftValue(draft.value) || trimDraftValue(draft.label) || entityId,
					isSelectable: draft.isSelectable !== false,
					isBold: !!draft.isBold,
					isHeader: !!draft.isHeader,
				isSpacer: !!draft.isSpacer
			};
			break;
		}
		case "collections.communitiesById": {
			entity = {
				id: entityId,
				key: entityId,
				value: trimDraftValue(draft.value) || inferDisplayNameFromId(entityId)
			};
			applyOptionalField(entity, "county", trimDraftValue(draft.county));
			break;
		}
		case "collections.pricingVariantsById": {
			const communityId = trimDraftValue(draft.communityId);
			const communityName = trimDraftValue(_.get(linkedCommunity, "value", ""));
			entity = {
				id: entityId,
				key: entityId,
				value: trimDraftValue(draft.value) || inferDisplayNameFromId(entityId)
			};
			applyOptionalField(entity, "communityId", communityId);
			applyOptionalField(entity, "communityName", communityName);
			applyOptionalField(entity, "lotCommunityId", communityId);
			applyOptionalField(entity, "lotCommunityName", communityName);
			applyOptionalField(entity, "pricingCommunityId", communityId);
			applyOptionalField(entity, "pricingCommunityName", communityName);
			applyOptionalField(entity, "masterCommunity", communityName);
			applyOptionalField(entity, "phaseOrLotLabel", trimDraftValue(draft.phaseOrLotLabel));
			applyOptionalField(entity, "county", trimDraftValue(draft.county) || _.get(linkedCommunity, "county"));
			break;
		}
		case "collections.modelsById": {
			const modelName = trimDraftValue(draft.modelName) || trimDraftValue(draft.value) || inferDisplayNameFromId(entityId);
			entity = {
				id: entityId,
				key: entityId,
				value: trimDraftValue(draft.value) || modelName,
				modelName
			};
			applyOptionalField(entity, "squareFeet", parseOptionalNumber(draft.squareFeet));
			applyOptionalField(entity, "unit", trimDraftValue(draft.unit) || "sq ft");
			break;
		}
		case "collections.lotsById": {
			const linkedVariantCommunityId = _.get(linkedPricingVariant, "communityId");
			const linkedVariantCommunityName = _.get(linkedPricingVariant, "communityName");
			const linkedVariantLotCommunityId = _.get(linkedPricingVariant, "lotCommunityId") || linkedVariantCommunityId;
			const linkedVariantLotCommunityName = _.get(linkedPricingVariant, "lotCommunityName") || linkedVariantCommunityName;
			const lotNumber = parseOptionalNumber(draft.lotNumber);
			entity = {
				id: entityId,
				key: entityId,
				value: trimDraftValue(draft.value) || (lotNumber ? `Lot ${lotNumber}` : inferDisplayNameFromId(entityId))
			};
			applyOptionalField(entity, "lotNumber", lotNumber);
			applyOptionalField(entity, "address", trimDraftValue(draft.address));
			applyOptionalField(entity, "communityId", linkedVariantCommunityId);
			applyOptionalField(entity, "communityName", linkedVariantCommunityName);
			applyOptionalField(entity, "lotCommunityId", linkedVariantLotCommunityId);
			applyOptionalField(entity, "lotCommunityName", linkedVariantLotCommunityName);
			applyOptionalField(entity, "county", _.get(linkedPricingVariant, "county"));
			applyOptionalField(entity, "lotPrice", parseOptionalNumber(draft.lotPrice));
			applyOptionalField(entity, "lotPremium", parseOptionalNumber(draft.lotPremium));
			applyOptionalField(entity, "garage", trimDraftValue(draft.garage));
			applyOptionalField(entity, "walkout", trimDraftValue(draft.walkout));
			break;
		}
		default: {
			entity = {
				id: entityId,
				key: entityId,
				value: trimDraftValue(draft.value) || inferDisplayNameFromId(entityId)
			};
		}
	}

	return { entityId, entity };
}

function addAuthoringEntityToDocument(parsedContent, candidate = null, draft = {}) {
	const path = _.get(candidate, "path", "");
	if (!path) {
		return { error: "Choose a canonical collection before adding an entity." };
	}
	const nextContent = _.cloneDeep(parsedContent || {});
	const collection = _.get(nextContent, path);
	if (!_.isPlainObject(collection)) {
		return { error: `Collection "${path}" is not editable.` };
	}

	const built = buildAuthoringEntityPayload(nextContent, candidate, draft);
	if (built.error) {
		return built;
	}
	const { entityId, entity } = built;
	if (_.has(collection, entityId)) {
		return { error: `Entity "${entityId}" already exists in this collection.` };
	}

	collection[entityId] = entity;

	(_.get(AUTHORING_ORDER_PATHS_BY_COLLECTION, path, []) || []).forEach((orderPath) => {
		_.set(nextContent, orderPath, appendUniqueItem(_.get(nextContent, orderPath, []), entityId));
	});

	if (path === "collections.selectionOptionsById") {
		updateSelectionOptionMemberships(nextContent, entityId, entity.groupIds || entity.groupId || []);
	}

	if (path === "collections.pricingVariantsById" && entity.communityId) {
		const relationshipPath = `relationships.communityPricingVariantIdsByCommunityId.${entity.communityId}`;
		_.set(nextContent, relationshipPath, appendUniqueItem(_.get(nextContent, relationshipPath, []), entityId));
		_.set(
			nextContent,
			"orders.communityPricingVariantLookupIds",
			appendUniqueItem(_.get(nextContent, "orders.communityPricingVariantLookupIds", []), entity.communityId)
		);
	}

	if (path === "collections.modelsById" && draft.pricingVariantId) {
		const relationshipPath = `relationships.pricingVariantModelRefsByPricingVariantId.${draft.pricingVariantId}`;
		const existingRefs = _.get(nextContent, relationshipPath, []);
		const nextRefs = _.isArray(existingRefs) ? [...existingRefs] : [];
		nextRefs.push({
			modelId: entityId,
			order: nextRefs.length,
			basePrice: parseOptionalNumber(draft.basePrice),
			availableInSfCommunityIds: _.get(nextContent, ["collections", "pricingVariantsById", draft.pricingVariantId, "communityId"])
				? [_.get(nextContent, ["collections", "pricingVariantsById", draft.pricingVariantId, "communityId"])]
				: []
		});
		_.set(nextContent, relationshipPath, nextRefs);
		_.set(
			nextContent,
			"orders.pricingVariantModelLookupIds",
			appendUniqueItem(_.get(nextContent, "orders.pricingVariantModelLookupIds", []), draft.pricingVariantId)
		);
	}

	if (path === "collections.lotsById" && draft.pricingVariantId) {
		const relationshipPath = `relationships.pricingVariantLotIdsByPricingVariantId.${draft.pricingVariantId}`;
		_.set(nextContent, relationshipPath, appendUniqueItem(_.get(nextContent, relationshipPath, []), entityId));
		_.set(
			nextContent,
			"orders.pricingVariantLotLookupIds",
			appendUniqueItem(_.get(nextContent, "orders.pricingVariantLotLookupIds", []), draft.pricingVariantId)
		);
	}

	return {
		content: nextContent,
		entityId,
		rowIdentity: `row:${entityId}`
	};
}

function addAuthoringCollectionToDocument(parsedContent, candidate = null) {
	if (!candidate?.path) {
		return { error: "Choose a collection to add." };
	}
	const nextContent = _.cloneDeep(parsedContent || {});
	if (!_.isPlainObject(nextContent.collections)) {
		nextContent.collections = {};
	}
	const collectionKey = getAuthoringCollectionKeyFromPath(candidate.path);
	if (!collectionKey) {
		return { error: "Invalid collection path." };
	}
	if (_.has(nextContent.collections, collectionKey)) {
		return { error: `Collection "${collectionKey}" already exists.` };
	}
	nextContent.collections[collectionKey] = {};
	if (!_.isPlainObject(nextContent.relationships)) {
		nextContent.relationships = {};
	}
	if (!_.isPlainObject(nextContent.orders)) {
		nextContent.orders = {};
	}
	return {
		content: nextContent,
		path: candidate.path
	};
}

function getAuthoringRelatedEntityGroups(parsedContent, candidate = null, row = null) {
	if (!isCanonicalAuthoringDatasourceDocument(parsedContent) || !candidate || !row) {
		return [];
	}

	const buildRowsById = (path) => {
		const rows = getGenericDatasourceRows(parsedContent, path).rows;
		return {
			rows,
			byId: _.keyBy(rows, "__rowId")
		};
	};

	const groups = [];
	const rowId = row.__rowId || row.id;

	if (candidate.path === "collections.selectionGroupsById") {
		const optionIds = _.get(parsedContent, ["relationships", "selectionGroupItemIdsByGroupId", rowId], _.get(row, "itemIds", []));
		const selection = buildRowsById("collections.selectionOptionsById");
		const relatedRows = optionIds.map((id) => selection.byId[id]).filter(Boolean);
		const linkableRows = selection.rows.filter((optionRow) => !optionIds.includes(optionRow.__rowId));
		groups.push({
			title: "Child Options",
			description: "These are the actual selectable options. Attach swatches or images to these child options.",
			path: "collections.selectionOptionsById",
			rows: relatedRows,
			addAction: {
				label: "Add Child Option",
				targetPath: "collections.selectionOptionsById",
				draftOverrides: {
					groupIds: rowId
				}
			},
			linkAction: {
				label: "Link Existing Option",
				parentId: rowId,
				targetPath: "collections.selectionOptionsById",
				options: linkableRows.map((optionRow) => ({
					id: optionRow.__rowId,
					label: getGenericRowDisplayLabel(optionRow),
					description: getGenericRowValueLabel(optionRow)
				}))
			},
			unlinkAction: {
				label: "Unlink",
				fixedGroupId: rowId,
				keepSelection: {
					selectedGenericPath: "collections.selectionGroupsById",
					selectedGenericRowIdentity: rowId
				}
			}
		});
	}

	if (candidate.path === "collections.selectionOptionsById") {
		const groupIds = getSelectionOptionGroupIds(row, parsedContent);
		const selection = buildRowsById("collections.selectionGroupsById");
		groups.push({
			title: "Parent Groups",
			description: "This option can be reused across multiple picker families.",
			path: "collections.selectionGroupsById",
			rows: groupIds.map((groupId) => selection.byId[groupId]).filter(Boolean),
			unlinkAction: {
				label: "Unlink",
				fixedOptionId: rowId,
				keepSelection: {
					selectedGenericPath: "collections.selectionOptionsById",
					selectedGenericRowIdentity: rowId
				}
			}
		});
	}

	if (candidate.path === "collections.communitiesById") {
		const variantIds = _.get(parsedContent, ["relationships", "communityPricingVariantIdsByCommunityId", rowId], []);
		const selection = buildRowsById("collections.pricingVariantsById");
		groups.push({
			title: "Pricing Variants",
			description: "These pricing variants belong to this community.",
			path: "collections.pricingVariantsById",
			rows: variantIds.map((id) => selection.byId[id]).filter(Boolean),
			addAction: {
				label: "Add Pricing Variant",
				targetPath: "collections.pricingVariantsById",
				draftOverrides: {
					communityId: rowId,
					county: _.get(row, "county", "")
				}
			}
		});
	}

	if (candidate.path === "collections.pricingVariantsById") {
		const communityId = _.get(row, "communityId");
		const communitySelection = buildRowsById("collections.communitiesById");
		const modelSelection = buildRowsById("collections.modelsById");
		const lotSelection = buildRowsById("collections.lotsById");
		const modelRefs = _.get(parsedContent, ["relationships", "pricingVariantModelRefsByPricingVariantId", rowId], []);
		const lotIds = _.get(parsedContent, ["relationships", "pricingVariantLotIdsByPricingVariantId", rowId], []);
		groups.push({
			title: "Parent Community",
			description: "This pricing variant belongs to the community below.",
			path: "collections.communitiesById",
			rows: communityId && communitySelection.byId[communityId] ? [communitySelection.byId[communityId]] : []
		});
		groups.push({
			title: "Linked Models",
			description: "These models compile into this pricing variant.",
			path: "collections.modelsById",
			rows: modelRefs.map((ref) => modelSelection.byId[ref.modelId]).filter(Boolean),
			addAction: {
				label: "Add Model",
				targetPath: "collections.modelsById",
				draftOverrides: {
					pricingVariantId: rowId
				}
			}
		});
		groups.push({
			title: "Linked Lots",
			description: "These lots compile into this pricing variant.",
			path: "collections.lotsById",
			rows: lotIds.map((id) => lotSelection.byId[id]).filter(Boolean),
			addAction: {
				label: "Add Lot",
				targetPath: "collections.lotsById",
				draftOverrides: {
					pricingVariantId: rowId
				}
			}
		});
	}

	if (candidate.path === "collections.modelsById") {
		const variantSelection = buildRowsById("collections.pricingVariantsById");
		const matchingVariantIds = _.chain(_.get(parsedContent, "relationships.pricingVariantModelRefsByPricingVariantId", {}))
			.toPairs()
			.filter(([, refs]) => _.some(refs, (ref) => ref.modelId === rowId))
			.map(([variantId]) => variantId)
			.value();
		groups.push({
			title: "Pricing Variants",
			description: "This model is linked into these pricing variants.",
			path: "collections.pricingVariantsById",
			rows: matchingVariantIds.map((id) => variantSelection.byId[id]).filter(Boolean)
		});
	}

	if (candidate.path === "collections.lotsById") {
		const variantSelection = buildRowsById("collections.pricingVariantsById");
		const matchingVariantIds = _.chain(_.get(parsedContent, "relationships.pricingVariantLotIdsByPricingVariantId", {}))
			.toPairs()
			.filter(([, lotIds]) => _.includes(lotIds, rowId))
			.map(([variantId]) => variantId)
			.value();
		groups.push({
			title: "Pricing Variants",
			description: "This lot is linked into these pricing variants.",
			path: "collections.pricingVariantsById",
			rows: matchingVariantIds.map((id) => variantSelection.byId[id]).filter(Boolean)
		});
	}

	return groups.filter((group) => group.rows.length > 0 || group.description);
}

function resolveDocumentSelections(parsedContent, previousState = {}, selectionOverrides = {}) {
	const genericMapperCandidates = getGenericMapperCandidates(parsedContent);
	const mapperMode = getMapperMode(parsedContent, genericMapperCandidates);

	let selectedPickerId = null;
	let selectedOptionIdentity = null;
	let selectedGenericPath = null;
	let selectedGenericRowIdentity = null;
	let selectedVisualTarget = null;

	if (mapperMode === "picker") {
		const pickerIds = getPickerIds(parsedContent);
		selectedPickerId = selectionOverrides.selectedPickerId || previousState.selectedPickerId;
		if (!selectedPickerId || !pickerIds.includes(selectedPickerId)) {
			selectedPickerId = pickerIds[0] || null;
		}
		const options = selectedPickerId ? getPickerOptions(parsedContent, selectedPickerId) : [];
		if (_.isNumber(selectionOverrides.selectedOptionIndex)) {
			selectedOptionIdentity = options[selectionOverrides.selectedOptionIndex]
				? options[selectionOverrides.selectedOptionIndex].__optionIdentity
				: null;
		} else {
			selectedOptionIdentity = selectionOverrides.selectedOptionIdentity || previousState.selectedOptionIdentity;
		}
		if (!selectedOptionIdentity || !options.find((option) => option.__optionIdentity === selectedOptionIdentity)) {
			selectedOptionIdentity = options[0] ? options[0].__optionIdentity : null;
		}
		selectedVisualTarget = options.find((option) => option.__optionIdentity === selectedOptionIdentity) || null;
	}

	if (mapperMode === "generic") {
		selectedGenericPath = selectionOverrides.selectedGenericPath || previousState.selectedGenericPath;
		if (!selectedGenericPath || !genericMapperCandidates.find((candidate) => candidate.path === selectedGenericPath)) {
			selectedGenericPath = genericMapperCandidates[0] ? genericMapperCandidates[0].path : null;
		}
		const rows = selectedGenericPath ? getGenericDatasourceRows(parsedContent, selectedGenericPath).rows : [];
		if (_.isNumber(selectionOverrides.selectedGenericRowIndex)) {
			selectedGenericRowIdentity = rows[selectionOverrides.selectedGenericRowIndex]
				? rows[selectionOverrides.selectedGenericRowIndex].__rowIdentity
				: null;
		} else {
			selectedGenericRowIdentity = selectionOverrides.selectedGenericRowIdentity || previousState.selectedGenericRowIdentity;
		}
		if (!selectedGenericRowIdentity || !rows.find((row) => row.__rowIdentity === selectedGenericRowIdentity)) {
			selectedGenericRowIdentity = rows[0] ? rows[0].__rowIdentity : null;
		}
		selectedVisualTarget = rows.find((row) => row.__rowIdentity === selectedGenericRowIdentity) || null;
	}

	return {
		mapperMode,
		genericMapperCandidates,
		selectedPickerId,
		selectedOptionIdentity,
		selectedGenericPath,
		selectedGenericRowIdentity,
		selectedVisualTarget
	};
}

function buildValidity(valid, error = null) {
	return {
		valid,
		error
	};
}

function getPickerIds(parsedContent) {
	if (!isPickerDatasourceDocument(parsedContent)) {
		return [];
	}

	const orderedIds = [];
	const arrayPickers = _.get(parsedContent, "pickers", []);
	arrayPickers.forEach((picker) => {
		const pickerId = _.get(picker, "id", "");
		if (pickerId && !orderedIds.includes(pickerId)) {
			orderedIds.push(pickerId);
		}
	});

	_.keys(_.get(parsedContent, "pickersById", {})).forEach((pickerId) => {
		if (!orderedIds.includes(pickerId)) {
			orderedIds.push(pickerId);
		}
	});

	return orderedIds;
}

function getPickerEntry(parsedContent, pickerId) {
	return _.get(parsedContent, ["pickersById", pickerId], null);
}

function getArrayPickerEntry(parsedContent, pickerId) {
	return _.find(_.get(parsedContent, "pickers", []), (picker) => _.get(picker, "id") === pickerId) || null;
}

function getPickerStorageMode(parsedContent, pickerId) {
	const hasMap = _.has(_.get(parsedContent, "pickersById", {}), pickerId);
	const hasArray = !!getArrayPickerEntry(parsedContent, pickerId);
	if (hasMap && hasArray) {
		return PICKER_STORAGE_MODE_BOTH;
	}
	if (hasMap) {
		return PICKER_STORAGE_MODE_MAP;
	}
	if (hasArray) {
		return PICKER_STORAGE_MODE_ARRAY;
	}
	return PICKER_STORAGE_MODE_BOTH;
}

function getPickerItemsValue(picker) {
	if (_.isArray(picker)) {
		return picker;
	}

	if (_.isPlainObject(picker) && _.isArray(picker.items)) {
		return picker.items;
	}

	return [];
}

function normalizeOptionValueAutoFormat(format = "dashed") {
	let normalized = _.isString(format) ? _.trim(format).toLowerCase() : "dashed";
	if (normalized === "kebab") {
		normalized = "dashed";
	} else if (normalized === "underscore") {
		normalized = "snake";
	}
	return _.find(OPTION_VALUE_AUTO_FORMATS, item => item.value === normalized) ? normalized : "dashed";
}

function tokenizeOptionLabel(label = "") {
	const base = _.isString(label) ? label : `${label || ""}`;
	return base
		.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
		.replace(/[^A-Za-z0-9]+/g, " ")
		.trim()
		.split(/\s+/)
		.filter(Boolean);
}

function buildAutoOptionValue(label = "", format = "dashed") {
	const words = tokenizeOptionLabel(label);
	if (words.length === 0) {
		return "";
	}
	if (format === "camel") {
		return words
			.map((word, idx) => {
				const lower = word.toLowerCase();
				if (idx === 0) {
					return lower;
				}
				return `${lower.substring(0, 1).toUpperCase()}${lower.substring(1)}`;
			})
			.join("");
	}
	if (format === "pascal") {
		return words
			.map((word) => {
				const lower = word.toLowerCase();
				return `${lower.substring(0, 1).toUpperCase()}${lower.substring(1)}`;
			})
			.join("");
	}
	if (format === "snake") {
		return words.map(word => word.toLowerCase()).join("_");
	}
	return words.map(word => word.toLowerCase()).join("-");
}

function buildAutoCustomFieldKey(key = "", format = "dashed") {
	return buildAutoOptionValue(key, format);
}

function getAutoGeneratedKeyCandidates(sourceValue = "") {
	return _.uniq(
		OPTION_VALUE_AUTO_FORMATS
			.map((formatOption) => buildAutoCustomFieldKey(sourceValue, formatOption.value))
			.filter(Boolean)
	);
}

function isAutoGeneratedKeyForSource(currentValue = "", sourceValue = "") {
	if (!currentValue) {
		return true;
	}
	return getAutoGeneratedKeyCandidates(sourceValue).includes(currentValue);
}

function getOptionIdentity(option, index = 0) {
	if (_.has(option, "value") && !_.isNil(option.value)) {
		return `value:${String(option.value)}`;
	}
	if (_.has(option, "label") && !_.isNil(option.label)) {
		return `label:${String(option.label)}`;
	}
	if (_.has(option, "rowNumber") && !_.isNil(option.rowNumber)) {
		return `row:${String(option.rowNumber)}`;
	}
	return `index:${index}`;
}

function getPickerOptions(parsedContent, pickerId) {
	const picker = getPickerEntry(parsedContent, pickerId);
	const items = getPickerItemsValue(picker);

	return _.map(items, (item, index) => ({
		...item,
		__optionIdentity: getOptionIdentity(item, index),
		__index: index
	}));
}

function computePickerKeys(items = []) {
	const allKeys = [];
	let commonKeys = null;

	items.forEach((item) => {
		const keys = _.keys(item);
		keys.forEach((key) => {
			if (!allKeys.includes(key)) {
				allKeys.push(key);
			}
		});

		if (commonKeys === null) {
			commonKeys = [...keys];
		} else {
			commonKeys = commonKeys.filter((key) => keys.includes(key));
		}
	});

	return {
		allKeys,
		commonKeys: commonKeys || []
	};
}

function applyPickerMetadata(picker) {
	if (!picker || _.isArray(picker) || !_.isArray(picker.items)) {
		return picker;
	}

	const nextPicker = { ...picker };
	const { allKeys, commonKeys } = computePickerKeys(nextPicker.items);
	nextPicker.allKeys = allKeys;
	nextPicker.commonKeys = commonKeys;
	nextPicker.itemCount = nextPicker.items.length;
	return nextPicker;
}

function createMapPickerFamily(label = "New Picker Family") {
	return applyPickerMetadata({
		label,
		items: []
	});
}

function createArrayPickerFamily(id, label = "New Picker Family") {
	return applyPickerMetadata({
		id,
		label,
		items: []
	});
}

function buildUniquePickerId(parsedContent, baseId = "new-picker-family", format = "dashed", excludedIds = []) {
	const normalizedFormat = normalizeOptionValueAutoFormat(format);
	const fallbackBaseId = normalizedFormat === "pascal"
		? "NewPickerFamily"
		: normalizedFormat === "camel"
			? "newPickerFamily"
			: normalizedFormat === "dashed"
				? "new-picker-family"
				: "new_picker_family";
	const normalizedBaseId = buildAutoCustomFieldKey(baseId || fallbackBaseId, normalizedFormat) || fallbackBaseId;
	const existingIds = new Set(getPickerIds(parsedContent));
	excludedIds.forEach((id) => {
		if (_.isString(id) && id !== "") {
			existingIds.delete(id);
		}
	});
	if (!existingIds.has(normalizedBaseId)) {
		return normalizedBaseId;
	}
	let counter = 2;
	let candidate = normalizedBaseId;
	while (existingIds.has(candidate)) {
		const suffix = normalizedFormat === "snake"
			? `_${counter}`
			: normalizedFormat === "dashed"
				? `-${counter}`
				: `${counter}`;
		candidate = `${normalizedBaseId}${suffix}`;
		counter += 1;
	}
	return candidate;
}

function renamePickerFamilyId(parsedContent, selectedPickerId, nextId) {
	const nextContent = _.cloneDeep(parsedContent);
	if (_.has(nextContent.pickersById, selectedPickerId)) {
		nextContent.pickersById[nextId] = nextContent.pickersById[selectedPickerId];
		delete nextContent.pickersById[selectedPickerId];
	}
	if (_.isArray(nextContent.pickers)) {
		nextContent.pickers = nextContent.pickers.map((picker) => _.get(picker, "id") === selectedPickerId ? { ...picker, id: nextId } : picker);
	}
	return nextContent;
}

function buildDefaultOption(items = [], autoValueFormat = "dashed") {
	const normalizedFormat = normalizeOptionValueAutoFormat(autoValueFormat);
	const defaultLabel = "New Option";
	const defaultValueBase = buildAutoOptionValue(defaultLabel, normalizedFormat) || "new_option";
	const existingValues = new Set(items.map((item) => `${_.get(item, "value", "")}`.toLowerCase()).filter(Boolean));
	let nextValue = defaultValueBase;
	let counter = 2;
	while (existingValues.has(nextValue.toLowerCase())) {
		const suffix = normalizedFormat === "snake" ? `_${counter}` : normalizedFormat === "camel" || normalizedFormat === "pascal" ? `${counter}` : `-${counter}`;
		nextValue = `${defaultValueBase}${suffix}`;
		counter += 1;
	}

	return {
		label: defaultLabel,
		value: nextValue,
		isBold: false,
		isHeader: false,
		isSpacer: false,
		isSelectable: true
	};
}

function updatePickerFamilyEntries(parsedContent, pickerId, updater) {
	const nextContent = _.cloneDeep(parsedContent);

	const byIdPicker = _.get(nextContent, ["pickersById", pickerId], null);
	if (!_.isNil(byIdPicker)) {
		const updatedByIdPicker = updater(_.cloneDeep(byIdPicker), PICKER_STORAGE_MODE_MAP);
		if (_.isArray(updatedByIdPicker)) {
			nextContent.pickersById[pickerId] = updatedByIdPicker;
		} else if (_.isPlainObject(updatedByIdPicker)) {
			nextContent.pickersById[pickerId] = applyPickerMetadata(updatedByIdPicker);
		} else {
			delete nextContent.pickersById[pickerId];
		}
	}

	const pickers = _.get(nextContent, "pickers", []);
	const pickerIndex = _.findIndex(pickers, (picker) => _.get(picker, "id") === pickerId);
	if (pickerIndex > -1) {
		const updatedArrayPicker = updater(_.cloneDeep(pickers[pickerIndex]), PICKER_STORAGE_MODE_ARRAY);
		if (updatedArrayPicker) {
			pickers[pickerIndex] = applyPickerMetadata(updatedArrayPicker);
		} else {
			pickers.splice(pickerIndex, 1);
		}
		nextContent.pickers = pickers;
	}

	return nextContent;
}

function addPickerFamily(parsedContent, { id, label, storageMode }) {
	const nextContent = _.cloneDeep(parsedContent);
	if (!_.isPlainObject(nextContent.pickersById)) {
		nextContent.pickersById = {};
	}
	if (!_.isArray(nextContent.pickers)) {
		nextContent.pickers = [];
	}

	if (storageMode === PICKER_STORAGE_MODE_MAP || storageMode === PICKER_STORAGE_MODE_BOTH) {
		nextContent.pickersById[id] = createMapPickerFamily(label);
	}
	if (storageMode === PICKER_STORAGE_MODE_ARRAY || storageMode === PICKER_STORAGE_MODE_BOTH) {
		nextContent.pickers.push(createArrayPickerFamily(id, label));
	}

	return nextContent;
}

function deletePickerFamily(parsedContent, pickerId) {
	const nextContent = _.cloneDeep(parsedContent);
	if (_.isPlainObject(nextContent.pickersById)) {
		delete nextContent.pickersById[pickerId];
	}
	if (_.isArray(nextContent.pickers)) {
		nextContent.pickers = nextContent.pickers.filter((picker) => _.get(picker, "id") !== pickerId);
	}
	return nextContent;
}

function reorderPickerFamilies(parsedContent, orderedIds = []) {
	const nextContent = _.cloneDeep(parsedContent);
	const ids = orderedIds.filter(Boolean);

	if (_.isArray(nextContent.pickers)) {
		const pickerMap = new Map(nextContent.pickers.map((picker) => [_.get(picker, "id"), picker]));
		nextContent.pickers = ids
			.filter((id) => pickerMap.has(id))
			.map((id) => pickerMap.get(id));
	}

	if (_.isPlainObject(nextContent.pickersById)) {
		const reordered = {};
		ids.forEach((id) => {
			if (_.has(nextContent.pickersById, id)) {
				reordered[id] = nextContent.pickersById[id];
			}
		});
		_.keys(nextContent.pickersById).forEach((id) => {
			if (!_.has(reordered, id)) {
				reordered[id] = nextContent.pickersById[id];
			}
		});
		nextContent.pickersById = reordered;
	}

	return nextContent;
}

function updatePickerOptionItems(items, selectedOption, payload = {}, keysToClear = []) {
	return _.map(items, (item, index) => {
		if (getOptionIdentity(item, index) !== selectedOption.__optionIdentity) {
			return item;
		}

		const nextItem = { ...item };
		keysToClear.forEach((key) => {
			delete nextItem[key];
		});

		_.forEach(payload, (value, key) => {
			if (!_.isNil(value) && value !== "") {
				nextItem[key] = value;
			}
		});

		return nextItem;
	});
}

function updatePickerOptionPayload(parsedContent, pickerId, selectedOption, payload = {}, keysToClear = []) {
	const nextContent = _.cloneDeep(parsedContent);
	const byIdPicker = _.get(nextContent, ["pickersById", pickerId], null);
	if (_.isArray(byIdPicker)) {
		nextContent.pickersById[pickerId] = updatePickerOptionItems(byIdPicker, selectedOption, payload, keysToClear);
	} else if (byIdPicker && _.isArray(byIdPicker.items)) {
		byIdPicker.items = updatePickerOptionItems(byIdPicker.items, selectedOption, payload, keysToClear);
		nextContent.pickersById[pickerId] = applyPickerMetadata(byIdPicker);
	}

	const pickers = _.get(nextContent, "pickers", []);
	const pickerIndex = _.findIndex(pickers, (picker) => _.get(picker, "id") === pickerId);
	if (pickerIndex > -1) {
		const arrayPicker = { ...pickers[pickerIndex] };
		arrayPicker.items = updatePickerOptionItems(_.get(arrayPicker, "items", []), selectedOption, payload, keysToClear);
		pickers[pickerIndex] = applyPickerMetadata(arrayPicker);
		nextContent.pickers = pickers;
	}

	return nextContent;
}

function addPickerOption(parsedContent, pickerId, option = null) {
	const nextContent = _.cloneDeep(parsedContent);
	const defaultOption = option || buildDefaultOption(getPickerOptions(parsedContent, pickerId));

	return updatePickerFamilyEntries(nextContent, pickerId, (picker, storageType) => {
		if (storageType === PICKER_STORAGE_MODE_MAP) {
			if (_.isArray(picker)) {
				return [...picker, defaultOption];
			}
			const nextPicker = { ...picker };
			nextPicker.items = [...getPickerItemsValue(nextPicker), defaultOption];
			return nextPicker;
		}

		const nextPicker = { ...picker };
		nextPicker.items = [...getPickerItemsValue(nextPicker), defaultOption];
		return nextPicker;
	});
}

function deletePickerOption(parsedContent, pickerId, selectedOptionIdentity) {
	return updatePickerFamilyEntries(parsedContent, pickerId, (picker, storageType) => {
		const items = getPickerItemsValue(picker).filter((item, index) => getOptionIdentity(item, index) !== selectedOptionIdentity);
		if (storageType === PICKER_STORAGE_MODE_MAP && _.isArray(picker)) {
			return items;
		}
		return {
			...picker,
			items
		};
	});
}

function reorderPickerOptions(parsedContent, pickerId, oldIndex, newIndex) {
	return updatePickerFamilyEntries(parsedContent, pickerId, (picker, storageType) => {
		const items = arrayMove(getPickerItemsValue(picker), oldIndex, newIndex);
		if (storageType === PICKER_STORAGE_MODE_MAP && _.isArray(picker)) {
			return items;
		}
		return {
			...picker,
			items
		};
	});
}

function updatePickerFamilyMeta(parsedContent, pickerId, nextMeta = {}) {
	return updatePickerFamilyEntries(parsedContent, pickerId, (picker, storageType) => {
		if (storageType === PICKER_STORAGE_MODE_MAP && _.isArray(picker)) {
			const nextPicker = createMapPickerFamily(nextMeta.label || getPickerLabel(parsedContent, pickerId));
			nextPicker.items = picker;
			return nextPicker;
		}

		return {
			...picker,
			...nextMeta
		};
	});
}

function setPickerFamilyStorageMode(parsedContent, pickerId, nextMode) {
	const nextContent = _.cloneDeep(parsedContent);
	const currentLabel = getPickerLabel(parsedContent, pickerId);
	const currentItems = getPickerOptions(parsedContent, pickerId).map((option) => _.omit(option, ["__optionIdentity", "__index"]));

	if (!_.isPlainObject(nextContent.pickersById)) {
		nextContent.pickersById = {};
	}
	if (!_.isArray(nextContent.pickers)) {
		nextContent.pickers = [];
	}

	if (nextMode === PICKER_STORAGE_MODE_MAP || nextMode === PICKER_STORAGE_MODE_BOTH) {
		nextContent.pickersById[pickerId] = applyPickerMetadata({
			label: currentLabel,
			items: currentItems
		});
	} else {
		delete nextContent.pickersById[pickerId];
	}

	const existingArrayIndex = _.findIndex(nextContent.pickers, (picker) => _.get(picker, "id") === pickerId);
	if (nextMode === PICKER_STORAGE_MODE_ARRAY || nextMode === PICKER_STORAGE_MODE_BOTH) {
		const nextArrayPicker = applyPickerMetadata({
			...(existingArrayIndex > -1 ? nextContent.pickers[existingArrayIndex] : {}),
			id: pickerId,
			label: currentLabel,
			column: _.get(existingArrayIndex > -1 ? nextContent.pickers[existingArrayIndex] : {}, "column", "H"),
			items: currentItems
		});
		if (existingArrayIndex > -1) {
			nextContent.pickers[existingArrayIndex] = nextArrayPicker;
		} else {
			nextContent.pickers.push(nextArrayPicker);
		}
	} else if (existingArrayIndex > -1) {
		nextContent.pickers.splice(existingArrayIndex, 1);
	}

	return nextContent;
}

function updatePickerOptionField(parsedContent, pickerId, selectedOption, field, value) {
	const shouldClear = _.isNil(value) || value === "";
	return updatePickerOptionPayload(
		parsedContent,
		pickerId,
		selectedOption,
		shouldClear ? {} : { [field]: value },
		shouldClear ? [field] : []
	);
}

function getCurrentImageUrl(option) {
	if (!option) {
		return "";
	}

	if (_.isString(option.imageDriveUrl) && option.imageDriveUrl !== "") {
		return option.imageDriveUrl;
	}

	if (_.isString(option.image) && option.image !== "") {
		return option.image;
	}

	if (_.isString(option.imageDriveGuid) && option.imageDriveGuid !== "") {
		const driveObject = getDriveObject(option.imageDriveGuid);
		if (driveObject) {
			return getUrlForExternalResource(driveObject);
		}
	}

	return "";
}

function getCurrentSwatchColor(option) {
	if (!option) {
		return "";
	}

	for (let i = 0; i < SWATCH_FIELD_KEYS.length; i += 1) {
		const value = _.get(option, SWATCH_FIELD_KEYS[i], "");
		if (_.isString(value) && value.trim() !== "") {
			return value.trim();
		}
	}

	return "";
}

function hasVisualAssignment(option) {
	return !!getCurrentImageUrl(option) || !!getCurrentSwatchColor(option);
}

function getVisualAssignmentLabel(option) {
	const hasImage = !!getCurrentImageUrl(option);
	const hasSwatch = !!getCurrentSwatchColor(option);
	if (hasImage && hasSwatch) {
		return "Image + swatch assigned";
	}
	if (hasImage) {
		return "Image assigned";
	}
	if (hasSwatch) {
		return "Swatch assigned";
	}
	return "No visual assigned";
}

function getVisualAssignmentColor(option) {
	if (hasVisualAssignment(option)) {
		return "#3c763d";
	}
	return "#9a6700";
}

function isHeaderOption(option) {
	return !!_.get(option, "isHeader", false);
}

function isSpacerOption(option) {
	return !!_.get(option, "isSpacer", false);
}

function isStructuralOption(option) {
	return isHeaderOption(option) || isSpacerOption(option);
}

function getStructuralOptionLabel(option) {
	const isHeader = isHeaderOption(option);
	const isSpacer = isSpacerOption(option);
	if (isHeader && isSpacer) {
		return "Header + spacer row";
	}
	if (isHeader) {
		return "Header row";
	}
	if (isSpacer) {
		return "Spacer row";
	}
	return "";
}

function getOptionStatusLine(option) {
	const structuralLabel = getStructuralOptionLabel(option);
	const visualLabel = getVisualAssignmentLabel(option);
	if (structuralLabel && hasVisualAssignment(option)) {
		return `${structuralLabel} • ${visualLabel}`;
	}
	if (structuralLabel) {
		return structuralLabel;
	}
	return visualLabel;
}

function normalizeHexColorForInput(value) {
	const raw = `${value || ""}`.trim();
	if (/^#[0-9a-fA-F]{6}$/.test(raw)) {
		return raw.toLowerCase();
	}
	if (/^#[0-9a-fA-F]{3}$/.test(raw)) {
		const [r, g, b] = raw.slice(1).split("");
		return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
	}
	return "#cccccc";
}

function buildUniqueOptionValue(items = [], baseValue = "new_option") {
	const normalizedBaseValue = `${baseValue || "new_option"}`
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "_")
		.replace(/^_+|_+$/g, "") || "new_option";
	const existingValues = new Set(items.map((item) => `${_.get(item, "value", "")}`.toLowerCase()).filter(Boolean));
	if (!existingValues.has(normalizedBaseValue)) {
		return normalizedBaseValue;
	}
	let counter = 2;
	while (existingValues.has(`${normalizedBaseValue}_${counter}`)) {
		counter += 1;
	}
	return `${normalizedBaseValue}_${counter}`;
}

function duplicatePickerFamily(parsedContent, pickerId, nextId, nextLabel) {
	const nextContent = _.cloneDeep(parsedContent);
	const storageMode = getPickerStorageMode(parsedContent, pickerId);
	const sourceByIdPicker = _.get(parsedContent, ["pickersById", pickerId], null);
	const sourceArrayPicker = getArrayPickerEntry(parsedContent, pickerId);

	if (!_.isPlainObject(nextContent.pickersById)) {
		nextContent.pickersById = {};
	}
	if (!_.isArray(nextContent.pickers)) {
		nextContent.pickers = [];
	}

	if ((storageMode === PICKER_STORAGE_MODE_MAP || storageMode === PICKER_STORAGE_MODE_BOTH) && !_.isNil(sourceByIdPicker)) {
		let clonedByIdPicker = _.cloneDeep(sourceByIdPicker);
		if (_.isArray(clonedByIdPicker)) {
			clonedByIdPicker = createMapPickerFamily(nextLabel);
			clonedByIdPicker.items = _.cloneDeep(getPickerItemsValue(sourceByIdPicker));
		} else {
			clonedByIdPicker.label = nextLabel;
		}
		nextContent.pickersById[nextId] = applyPickerMetadata(clonedByIdPicker);
	}

	if ((storageMode === PICKER_STORAGE_MODE_ARRAY || storageMode === PICKER_STORAGE_MODE_BOTH) && sourceArrayPicker) {
		const clonedArrayPicker = applyPickerMetadata({
			..._.cloneDeep(sourceArrayPicker),
			id: nextId,
			label: nextLabel
		});
		nextContent.pickers.push(clonedArrayPicker);
	}

	return nextContent;
}

function duplicatePickerOption(parsedContent, pickerId, selectedOption) {
	const currentOptions = getPickerOptions(parsedContent, pickerId);
	const sourceOption = _.omit(selectedOption || {}, ["__optionIdentity", "__index"]);
	const nextOption = _.cloneDeep(sourceOption);
	const baseLabel = getOptionDisplayLabel(selectedOption);
	nextOption.label = `${baseLabel} Copy`;
	nextOption.value = buildUniqueOptionValue(currentOptions, `${_.get(selectedOption, "value", "new_option")}_copy`);
	delete nextOption.rowNumber;
	return addPickerOption(parsedContent, pickerId, nextOption);
}

function getCustomFieldEntries(source = {}, managedKeys = []) {
	return _.keys(source)
		.filter((key) => !managedKeys.includes(key) && !key.startsWith("__"))
		.sort((a, b) => a.localeCompare(b))
		.map((key) => ({ key, value: source[key] }));
}

function inferCustomFieldType(value) {
	if (_.isNil(value)) {
		return CUSTOM_FIELD_TYPE_NULL;
	}
	if (_.isBoolean(value)) {
		return CUSTOM_FIELD_TYPE_BOOLEAN;
	}
	if (_.isNumber(value)) {
		return CUSTOM_FIELD_TYPE_NUMBER;
	}
	if (_.isPlainObject(value) || _.isArray(value)) {
		return CUSTOM_FIELD_TYPE_JSON;
	}
	return CUSTOM_FIELD_TYPE_STRING;
}

function serializeCustomFieldValue(value, type = inferCustomFieldType(value)) {
	if (type === CUSTOM_FIELD_TYPE_NULL) {
		return "";
	}
	if (type === CUSTOM_FIELD_TYPE_BOOLEAN) {
		return value ? "true" : "false";
	}
	if (type === CUSTOM_FIELD_TYPE_NUMBER) {
		return _.isNumber(value) ? String(value) : "";
	}
	if (type === CUSTOM_FIELD_TYPE_JSON) {
		try {
			return JSON.stringify(value, null, 2);
		} catch (err) {
			return "";
		}
	}
	return _.isString(value) ? value : `${value ?? ""}`;
}

function parseCustomFieldValue(rawValue, type) {
	if (type === CUSTOM_FIELD_TYPE_NULL) {
		return { valid: true, value: null, error: null };
	}
	if (type === CUSTOM_FIELD_TYPE_BOOLEAN) {
		const normalized = `${rawValue || ""}`.trim().toLowerCase();
		if (["true", "1", "yes"].includes(normalized)) {
			return { valid: true, value: true, error: null };
		}
		if (["false", "0", "no"].includes(normalized)) {
			return { valid: true, value: false, error: null };
		}
		return { valid: false, value: null, error: "Boolean fields must be true or false." };
	}
	if (type === CUSTOM_FIELD_TYPE_NUMBER) {
		const numericValue = Number(rawValue);
		if (_.isNaN(numericValue)) {
			return { valid: false, value: null, error: "Number fields must parse as a valid number." };
		}
		return { valid: true, value: numericValue, error: null };
	}
	if (type === CUSTOM_FIELD_TYPE_JSON) {
		try {
			return { valid: true, value: JSON.parse(rawValue || "null"), error: null };
		} catch (error) {
			return { valid: false, value: null, error: error?.message || "Invalid JSON." };
		}
	}
	return { valid: true, value: `${rawValue ?? ""}`, error: null };
}

function updatePickerFamilyCustomField(parsedContent, pickerId, fieldKey, value, keysToDelete = []) {
	return updatePickerFamilyEntries(parsedContent, pickerId, (picker, storageType) => {
		let nextPicker = _.cloneDeep(picker);
		if (storageType === PICKER_STORAGE_MODE_MAP && _.isArray(nextPicker)) {
			nextPicker = createMapPickerFamily(getPickerLabel(parsedContent, pickerId));
			nextPicker.items = _.cloneDeep(getPickerItemsValue(picker));
		}
		keysToDelete.forEach((key) => {
			delete nextPicker[key];
		});
		if (fieldKey) {
			nextPicker[fieldKey] = value;
		}
		return nextPicker;
	});
}

function deletePickerFamilyCustomField(parsedContent, pickerId, fieldKey) {
	return updatePickerFamilyCustomField(parsedContent, pickerId, null, null, [fieldKey]);
}

function renamePickerFamilyCustomField(parsedContent, pickerId, oldKey, newKey) {
	const sourcePicker = getArrayPickerEntry(parsedContent, pickerId) || getPickerEntry(parsedContent, pickerId) || {};
	const currentValue = _.get(sourcePicker, oldKey);
	return updatePickerFamilyCustomField(parsedContent, pickerId, newKey, _.cloneDeep(currentValue), [oldKey]);
}

function updatePickerOptionCustomField(parsedContent, pickerId, selectedOption, fieldKey, value, keysToDelete = []) {
	return updatePickerOptionPayload(parsedContent, pickerId, selectedOption, fieldKey ? { [fieldKey]: value } : {}, keysToDelete);
}

function deletePickerOptionCustomField(parsedContent, pickerId, selectedOption, fieldKey) {
	return updatePickerOptionCustomField(parsedContent, pickerId, selectedOption, null, null, [fieldKey]);
}

function renamePickerOptionCustomField(parsedContent, pickerId, selectedOption, oldKey, newKey) {
	const currentValue = _.get(selectedOption, oldKey);
	return updatePickerOptionCustomField(parsedContent, pickerId, selectedOption, newKey, _.cloneDeep(currentValue), [oldKey]);
}

function validatePickerDatasource(parsedContent) {
	const issues = [];
	if (!isPickerDatasourceDocument(parsedContent)) {
		return issues;
	}

	const arrayPickers = _.get(parsedContent, "pickers", []);
	const pickerIds = getPickerIds(parsedContent);
	const arrayIds = arrayPickers.map((picker) => _.get(picker, "id", "")).filter(Boolean);
	_.forEach(_.countBy(arrayIds), (count, pickerId) => {
		if (count > 1) {
			issues.push({ severity: "error", scope: "family", pickerId, message: `Array storage contains duplicate picker id "${pickerId}".` });
		}
	});

	pickerIds.forEach((pickerId) => {
		const label = getPickerLabel(parsedContent, pickerId);
		const storageMode = getPickerStorageMode(parsedContent, pickerId);
		if (!label || !`${label}`.trim()) {
			issues.push({ severity: "warning", scope: "family", pickerId, message: "Picker family is missing a label." });
		}
		if (!pickerId || !`${pickerId}`.trim()) {
			issues.push({ severity: "error", scope: "family", pickerId, message: "Picker family is missing an id." });
		}
		if (storageMode === PICKER_STORAGE_MODE_ARRAY && !getArrayPickerEntry(parsedContent, pickerId)) {
			issues.push({ severity: "error", scope: "family", pickerId, message: "Array storage mode is set but the array entry is missing." });
		}
		const options = getPickerOptions(parsedContent, pickerId);
		if (options.length === 0) {
			issues.push({ severity: "warning", scope: "family", pickerId, message: "Picker family has no options." });
		}

		const optionValues = options.map((option) => `${_.get(option, "value", "")}`.trim()).filter(Boolean);
		_.forEach(_.countBy(optionValues), (count, value) => {
			if (count > 1) {
				issues.push({ severity: "warning", scope: "family", pickerId, message: `Duplicate option value "${value}".` });
			}
		});

		options.forEach((option) => {
			const optionLabel = getOptionDisplayLabel(option);
			if (!`${_.get(option, "label", "")}`.trim()) {
				issues.push({ severity: "warning", scope: "option", pickerId, optionIdentity: option.__optionIdentity, message: `Option "${optionLabel}" is missing label.` });
			}
			if (_.isNil(_.get(option, "value")) || `${_.get(option, "value", "")}`.trim() === "") {
				issues.push({ severity: "warning", scope: "option", pickerId, optionIdentity: option.__optionIdentity, message: `Option "${optionLabel}" is missing value.` });
			}
			if (_.get(option, "imageDriveGuid") && !getCurrentImageUrl(option)) {
				issues.push({ severity: "info", scope: "option", pickerId, optionIdentity: option.__optionIdentity, message: `Option "${optionLabel}" has Drive image metadata but no resolved image URL.` });
			}
		});
	});

	return issues;
}

function inferVisualEditorMode(option) {
	const hasImage = !!getCurrentImageUrl(option);
	const hasSwatch = !!getCurrentSwatchColor(option);
	if (hasImage && hasSwatch) {
		return "both";
	}
	if (hasSwatch) {
		return "swatch";
	}
	return "image";
}

function getOptionDisplayLabel(option) {
	if (!option) {
		return "";
	}

	if (_.isString(option.label) && option.label !== "") {
		return option.label;
	}

	if (isHeaderOption(option)) {
		return "Untitled Header";
	}

	if (isSpacerOption(option)) {
		return "Untitled Spacer";
	}

	if (!_.isNil(option.value)) {
		return String(option.value);
	}

	return "Untitled Option";
}

function getCurrentDriveResource(option) {
	if (!option || !_.isString(option.imageDriveGuid) || option.imageDriveGuid === "") {
		return null;
	}

	return getDriveObject(option.imageDriveGuid);
}

function stripOrgIdFromDrivePath(path) {
	if (!_.isString(path) || path === "") {
		return "";
	}

	const orgId = getOrgId();
	return path.replace(`public/${orgId}/`, "public/").replace(`private/${orgId}/`, "private/");
}

function normalizeDriveFolderPath(path) {
	let normalizedInput = path;

	if (_.isArray(normalizedInput)) {
		normalizedInput = normalizedInput.join("/");
	}

	if (!_.isString(normalizedInput) || _.trim(normalizedInput) === "") {
		return {
			relativePath: "",
			fullPath: ""
		};
	}

	let relativePath = _.trim(normalizedInput);
	const orgId = getOrgId();

	if (relativePath.startsWith(`public/${orgId}/`) || relativePath.startsWith(`private/${orgId}/`)) {
		relativePath = stripOrgIdFromDrivePath(relativePath);
	}

	if (!relativePath.startsWith("public/") && !relativePath.startsWith("private/")) {
		relativePath = `public/${relativePath.replace(/^\/+/, "")}`;
	}

	if (!relativePath.endsWith("/")) {
		relativePath = `${relativePath}/`;
	}

	const fullPath = relativePath
		.replace(/^public\//, `public/${orgId}/`)
		.replace(/^private\//, `private/${orgId}/`);

	return {
		relativePath,
		fullPath
	};
}

function getFolderPathForOption(option) {
	const path = _.get(option, "imageDrivePath", "");
	if (!_.isString(path) || path === "") {
		return "";
	}

	const relativePath = stripOrgIdFromDrivePath(path);
	const segments = relativePath.split("/").filter(Boolean);
	if (segments.length <= 1) {
		return "";
	}

	return `${segments.slice(0, -1).join("/")}/`;
}

function isImageDriveFile(file) {
	if (!file || file.type !== "file") {
		return false;
	}

	return getMediaType(file.ext) === "image";
}

function getAssignedDriveGuid(option) {
	if (!option || !_.isString(option.imageDriveGuid) || option.imageDriveGuid === "") {
		return "";
	}

	return option.imageDriveGuid;
}

function getPickerLabel(parsedContent, pickerId) {
	const picker = getPickerEntry(parsedContent, pickerId);
	if (_.isPlainObject(picker) && _.isString(picker.label) && picker.label !== "") {
		return picker.label;
	}

	const arrayPicker = _.find(_.get(parsedContent, "pickers", []), (entry) => _.get(entry, "id") === pickerId);
	return _.get(arrayPicker, "label", pickerId);
}

function getPickerSummary(parsedContent, pickerId) {
	const options = getPickerOptions(parsedContent, pickerId);
	const total = options.length;
	const matched = options.filter((option) => hasVisualAssignment(option)).length;
	return {
		total,
		matched,
		unmatched: total - matched
	};
}

function normalizeTags(source) {
	if (_.isArray(source)) {
		return source
			.map((tag) => `${tag || ""}`.trim())
			.filter(Boolean);
	}

	if (_.isString(source)) {
		return source
			.split(",")
			.map((tag) => tag.trim())
			.filter(Boolean);
	}

	return [];
}

function mergeUniqueTags(tags = []) {
	return _.uniqBy(
		tags
			.map((tag) => `${tag || ""}`.trim())
			.filter(Boolean),
		(tag) => tag.toLowerCase()
	);
}

function cleanMetadataTitle(value) {
	return `${value || ""}`.trim().slice(0, MAX_METADATA_TITLE_CHARS);
}

function cleanMetadataDescription(value) {
	return `${value || ""}`.trim().slice(0, MAX_METADATA_DESCRIPTION_CHARS);
}

function cleanMetadataTranscript(value) {
	return `${value || ""}`.trim().slice(0, MAX_METADATA_TRANSCRIPT_CHARS);
}

function cleanMetadataTranscriptVtt(value) {
	return `${value || ""}`.trim().slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS);
}

const SortablePickerFamilyItem = SortableElement(({ item, active, onSelect, onDelete }) => ( // eslint-disable-line no-unused-vars
	<div
		style={{
			width: "100%",
			padding: "10px 12px",
			borderRadius: "8px",
			border: active ? "1px solid #3b82f6" : "1px solid #d7dee7",
			background: active ? "#eef5ff" : "#ffffff",
			marginBottom: "8px",
			color: "#253858"
		}}
	>
		<div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
			<div style={{ flex: 1, minWidth: 0, cursor: "pointer" }} onClick={onSelect}>
				<div style={{ fontWeight: 600, color: "#253858" }}>{item.label}</div>
				<div style={{ fontSize: "12px", color: "#5f6f82", marginTop: "4px" }}>{item.id}</div>
				<div style={{ fontSize: "12px", color: item.summary.unmatched > 0 ? "#9a6700" : "#3c763d", marginTop: "6px" }}>
					{item.summary.matched}/{item.summary.total} mapped
				</div>
				<div style={{ fontSize: "11px", color: "#7b8794", marginTop: "4px", textTransform: "capitalize" }}>
					{item.storageMode}
				</div>
			</div>
			<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
				<Button
					bsSize="xsmall"
					onClick={(event) => {
						event.preventDefault();
						event.stopPropagation();
						onDelete(item.id);
					}}
					onMouseDown={(event) => {
						event.preventDefault();
						event.stopPropagation();
					}}
					type="button"
				>
					<FontAwesomeIcon icon="trash" />
				</Button>
				<DragHandle />
			</div>
		</div>
	</div>
));

const SortablePickerFamilyList = SortableContainer(({ items, selectedPickerId, onSelect, onDelete }) => ( // eslint-disable-line no-unused-vars
	<div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
		{items.map((item, index) => (
			<SortablePickerFamilyItem
				key={item.id}
				index={index}
				item={item}
				active={item.id === selectedPickerId}
				onSelect={() => onSelect(item.id)}
				onDelete={onDelete}
			/>
		))}
	</div>
));

const SortablePickerOptionItem = SortableElement(({ option, active, imageFitMode, onSelect, onDelete }) => { // eslint-disable-line no-unused-vars
	const imageUrl = getCurrentImageUrl(option);
	const swatchColor = getCurrentSwatchColor(option);
	const structuralLabel = getStructuralOptionLabel(option);
	const isStructural = isStructuralOption(option);
	const cardBackground = active
		? "#eef5ff"
		: isStructural
			? "linear-gradient(135deg, #fbfcff 0%, #f6f8fc 100%)"
			: "#ffffff";
	const cardBorder = active
		? "1px solid #3b82f6"
		: isStructural
			? "1px dashed #c7d2e3"
			: "1px solid #d7dee7";
	return (
		<div
			style={{
				width: "100%",
				display: "flex",
				alignItems: "center",
				gap: "10px",
				textAlign: "left",
				padding: "10px 12px",
				borderRadius: "8px",
				border: cardBorder,
				background: cardBackground,
				marginBottom: "8px",
				color: "#253858"
			}}
		>
			<div
				style={{
					width: "52px",
					height: "52px",
					flex: "0 0 52px",
					borderRadius: "8px",
					background: "#f5f7fa",
					border: "1px solid #e3e8ef",
					overflow: "hidden",
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}}
			>
				{imageUrl ? (
					<img src={imageUrl} alt={getOptionDisplayLabel(option)} style={{ width: "100%", height: "100%", objectFit: imageFitMode, background: "#ffffff" }} />
				) : swatchColor ? (
					<div style={{ width: "100%", height: "100%", background: swatchColor }} />
				) : isSpacerOption(option) ? (
					<div style={{ width: "70%", borderTop: "3px dashed #9aa5b1" }} />
				) : isHeaderOption(option) ? (
					<div style={{ color: "#66758a", fontSize: "18px", fontWeight: 700, letterSpacing: "0.08em" }}>H</div>
				) : (
					<FontAwesomeIcon icon="image" style={{ color: "#9aa5b1", fontSize: "18px" }} />
				)}
			</div>
			<div style={{ flex: 1, minWidth: 0, cursor: "pointer" }} onClick={onSelect}>
				<div style={{ fontWeight: 600, color: "#253858" }}>{getOptionDisplayLabel(option)}</div>
				{structuralLabel && (
					<div style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em", color: "#6b7280", marginTop: "4px" }}>
						{structuralLabel}
					</div>
				)}
				<div style={{ fontSize: "12px", color: isStructural ? "#5f6f82" : getVisualAssignmentColor(option), marginTop: structuralLabel ? "2px" : "4px" }}>
					{getOptionStatusLine(option)}
				</div>
			</div>
			<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
				<Button
					bsSize="xsmall"
					onClick={(event) => {
						event.preventDefault();
						event.stopPropagation();
						onDelete(option.__optionIdentity);
					}}
					onMouseDown={(event) => {
						event.preventDefault();
						event.stopPropagation();
					}}
					type="button"
				>
					<FontAwesomeIcon icon="trash" />
				</Button>
				<DragHandle />
			</div>
		</div>
	);
});

const SortablePickerOptionList = SortableContainer(({ items, selectedOptionIdentity, imageFitMode, onSelect, onDelete }) => ( // eslint-disable-line no-unused-vars
	<div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
		{items.map((item, index) => (
			<SortablePickerOptionItem
				key={item.__optionIdentity}
				index={index}
				option={item}
				active={item.__optionIdentity === selectedOptionIdentity}
				imageFitMode={imageFitMode}
				onSelect={() => onSelect(item.__optionIdentity)}
				onDelete={onDelete}
			/>
		))}
	</div>
));

export default class PickerDatasourceEditor extends PureComponent {

	constructor(props) {
		super(props);
		this.editorRootRef = React.createRef();

		const rawContent = normalizeContent(props.content);
		const parseResult = tryParseJson(rawContent);
		const parsedContent = parseResult.parsed;
		const selectionState = resolveDocumentSelections(parsedContent);
		const selectedVisualTarget = selectionState.selectedVisualTarget;
		const validity = buildValidity(parseResult.valid, parseResult.error);

		this.lastEdit = rawContent;

		this.state = {
			rawContent,
			parsedContent,
			validity,
			activeTab: selectionState.mapperMode ? "mapper" : "raw",
			mapperMode: selectionState.mapperMode,
			genericMapperCandidates: selectionState.genericMapperCandidates,
			selectedPickerId: selectionState.selectedPickerId,
			selectedOptionIdentity: selectionState.selectedOptionIdentity,
			selectedGenericPath: selectionState.selectedGenericPath,
			selectedGenericRowIdentity: selectionState.selectedGenericRowIdentity,
			showAddFamily: false,
			newFamilyId: "",
			newFamilyLabel: "",
			newFamilyStorageMode: PICKER_STORAGE_MODE_BOTH,
			selectedDriveResourceGuid: selectedVisualTarget ? getAssignedDriveGuid(selectedVisualTarget) : "",
			optionVisualMode: inferVisualEditorMode(selectedVisualTarget),
			swatchInputValue: getCurrentSwatchColor(selectedVisualTarget),
			swatchPickerValue: normalizeHexColorForInput(getCurrentSwatchColor(selectedVisualTarget)),
			selectedOptionDetailsCollapsed: false,
			optionFilter: "",
			showUnmatchedOnly: false,
			showAddGenericEntity: false,
			newGenericEntityDraft: buildInitialAuthoringEntityDraft(_.find(selectionState.genericMapperCandidates, (candidate) => candidate.path === selectionState.selectedGenericPath) || null),
			newGenericEntityError: "",
			relatedEntityLinkSelections: {},
			imageFitMode: "cover",
			assignMode: "gallery",
			showFolderPicker: false,
			showImageEditorModal: false,
			imageEditorTarget: null,
			showMetadataModal: false,
			metadataGalleryItems: [],
			metadataEditorTarget: null,
			metadataEditorTitle: "",
			metadataEditorDescription: "",
			metadataEditorTranscript: "",
			metadataEditorTranscriptVtt: "",
			metadataEditorSecondaryTags: [],
			metadataEditorTagsInput: "",
			metadataEditorPrimaryTags: [],
			metadataEditorSaving: false,
			metadataLoadingSuggestions: false,
			metadataGeneratingField: "",
			metadataTranscriptProvider: TRANSCRIPT_PROVIDER_OPENAI,
			metadataTagsProvider: TAGS_PROVIDER_OPENAI,
			showRenameModal: false,
			renameTarget: null,
			renameFileName: "",
			renameSaving: false,
			galleryFolderPath: selectedVisualTarget ? getFolderPathForOption(selectedVisualTarget) : "",
			galleryFiles: [],
			galleryLoading: false,
			galleryError: "",
			familyCustomFieldDraftKeys: {},
			optionCustomFieldDraftKeys: {},
			newFamilyCustomFieldName: "",
			newFamilyCustomFieldKey: "",
			newFamilyCustomFieldType: CUSTOM_FIELD_TYPE_STRING,
			newFamilyCustomFieldValue: "",
			newOptionCustomFieldName: "",
			newOptionCustomFieldKey: "",
			newOptionCustomFieldType: CUSTOM_FIELD_TYPE_STRING,
			newOptionCustomFieldValue: "",
			showValidationPanel: true,
			optionValueAutoFormat: "dashed"
		};
	}

	componentDidMount() {
		this.emitEditorState(this.state.rawContent, this.state.validity);
		this.syncModalBodyOverflow();
		if (this.state.galleryFolderPath) {
			this.loadGalleryFiles(this.state.galleryFolderPath);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.activeTab !== this.state.activeTab) {
			this.syncModalBodyOverflow();
		}
		if (prevProps.content !== this.props.content) {
			const rawContent = normalizeContent(this.props.content);
			const parseResult = tryParseJson(rawContent);
			const parsedContent = parseResult.parsed;
			const selectionState = resolveDocumentSelections(parsedContent, this.state);
			const selectedVisualTarget = selectionState.selectedVisualTarget;
			const validity = buildValidity(parseResult.valid, parseResult.error);

			this.lastEdit = rawContent;

			this.setState({
				rawContent,
				parsedContent,
				validity,
				activeTab: selectionState.mapperMode ? "mapper" : "raw",
				mapperMode: selectionState.mapperMode,
				genericMapperCandidates: selectionState.genericMapperCandidates,
				selectedPickerId: selectionState.selectedPickerId,
				selectedOptionIdentity: selectionState.selectedOptionIdentity,
				selectedGenericPath: selectionState.selectedGenericPath,
				selectedGenericRowIdentity: selectionState.selectedGenericRowIdentity,
				showAddFamily: false,
				newFamilyId: "",
				newFamilyLabel: "",
				newFamilyStorageMode: PICKER_STORAGE_MODE_BOTH,
				selectedDriveResourceGuid: selectedVisualTarget ? getAssignedDriveGuid(selectedVisualTarget) : "",
				optionVisualMode: inferVisualEditorMode(selectedVisualTarget),
				swatchInputValue: getCurrentSwatchColor(selectedVisualTarget),
				swatchPickerValue: normalizeHexColorForInput(getCurrentSwatchColor(selectedVisualTarget)),
				selectedOptionDetailsCollapsed: false,
				optionFilter: "",
				showUnmatchedOnly: false,
				showAddGenericEntity: false,
				newGenericEntityDraft: buildInitialAuthoringEntityDraft(_.find(selectionState.genericMapperCandidates, (candidate) => candidate.path === selectionState.selectedGenericPath) || null),
				newGenericEntityError: "",
				relatedEntityLinkSelections: {},
				imageFitMode: "cover",
				assignMode: "gallery",
				showFolderPicker: false,
				showImageEditorModal: false,
				imageEditorTarget: null,
				showMetadataModal: false,
				metadataEditorTarget: null,
				metadataEditorTitle: "",
				metadataEditorDescription: "",
				metadataEditorTranscript: "",
				metadataEditorTranscriptVtt: "",
				metadataEditorSecondaryTags: [],
				metadataEditorTagsInput: "",
				metadataEditorPrimaryTags: [],
				metadataEditorSaving: false,
				metadataLoadingSuggestions: false,
				metadataGeneratingField: "",
				metadataTranscriptProvider: TRANSCRIPT_PROVIDER_OPENAI,
				metadataTagsProvider: TAGS_PROVIDER_OPENAI,
				showRenameModal: false,
				renameTarget: null,
				renameFileName: "",
				renameSaving: false,
				galleryFolderPath: selectedVisualTarget ? getFolderPathForOption(selectedVisualTarget) : "",
				galleryFiles: [],
				galleryLoading: false,
				galleryError: "",
				familyCustomFieldDraftKeys: {},
				optionCustomFieldDraftKeys: {},
				newFamilyCustomFieldName: "",
				newFamilyCustomFieldKey: "",
				newFamilyCustomFieldType: CUSTOM_FIELD_TYPE_STRING,
				newFamilyCustomFieldValue: "",
				newOptionCustomFieldName: "",
				newOptionCustomFieldKey: "",
				newOptionCustomFieldType: CUSTOM_FIELD_TYPE_STRING,
				newOptionCustomFieldValue: "",
				showValidationPanel: true
				}, () => {
					this.emitEditorState(rawContent, validity);
					if (selectedVisualTarget && getFolderPathForOption(selectedVisualTarget)) {
						this.loadGalleryFiles(getFolderPathForOption(selectedVisualTarget));
					}
				});
		}
	}

	componentWillUnmount() {
		this.restoreModalBodyOverflow();
	}

	getModalBodyContainer() {
		return this.editorRootRef.current ? this.editorRootRef.current.closest(".map-modal-body-container") : null;
	}

	syncModalBodyOverflow() {
		const modalBody = this.getModalBodyContainer();
		if (!modalBody) {
			return;
		}
		modalBody.style.overflowY = "hidden";
		modalBody.style.overflowX = "hidden";
	}

	restoreModalBodyOverflow() {
		const modalBody = this.getModalBodyContainer();
		if (!modalBody) {
			return;
		}
		modalBody.style.overflowY = "";
		modalBody.style.overflowX = "";
	}

	emitEditorState(rawContent, validity) {
		const { onChange, onValidityChange } = this.props;

		if (onChange && _.isFunction(onChange)) {
			onChange(rawContent);
		}

		if (onValidityChange && _.isFunction(onValidityChange)) {
			onValidityChange(validity);
		}
	}

	getContent() {
		return this.state.rawContent;
	}

	getValidity() {
		return this.state.validity;
	}

	setDocumentState(nextContent, selectionOverrides = {}, extraState = {}, afterSet = null) {
		const rawContent = JSON.stringify(nextContent, null, 4);
		const selectionState = resolveDocumentSelections(nextContent, this.state, selectionOverrides);
		const selectedVisualTarget = selectionState.selectedVisualTarget;
		const validity = buildValidity(true, null);

		this.lastEdit = rawContent;
		this.setState({
			rawContent,
			parsedContent: nextContent,
			validity,
			mapperMode: selectionState.mapperMode,
			genericMapperCandidates: selectionState.genericMapperCandidates,
			selectedPickerId: selectionState.selectedPickerId,
			selectedOptionIdentity: selectionState.selectedOptionIdentity,
			selectedGenericPath: selectionState.selectedGenericPath,
			selectedGenericRowIdentity: selectionState.selectedGenericRowIdentity,
			selectedDriveResourceGuid: selectedVisualTarget ? getAssignedDriveGuid(selectedVisualTarget) : "",
			optionVisualMode: inferVisualEditorMode(selectedVisualTarget),
			swatchInputValue: selectedVisualTarget ? getCurrentSwatchColor(selectedVisualTarget) : "",
				swatchPickerValue: normalizeHexColorForInput(selectedVisualTarget ? getCurrentSwatchColor(selectedVisualTarget) : ""),
				relatedEntityLinkSelections: {},
				familyCustomFieldDraftKeys: {},
			optionCustomFieldDraftKeys: {},
			...extraState
		}, () => {
			this.emitEditorState(rawContent, validity);
			if (_.isFunction(afterSet)) {
				afterSet();
			}
		});
	}

	handleRawChange = (value) => {
		this.lastEdit = value;
		const parseResult = tryParseJson(value);
		const validity = buildValidity(parseResult.valid, parseResult.error);
		const nextState = {
			rawContent: value,
			validity,
			parsedContent: parseResult.parsed
		};

		if (parseResult.valid) {
			const selectionState = resolveDocumentSelections(parseResult.parsed, this.state);
			const selectedVisualTarget = selectionState.selectedVisualTarget;
			nextState.mapperMode = selectionState.mapperMode;
			nextState.genericMapperCandidates = selectionState.genericMapperCandidates;
			nextState.selectedPickerId = selectionState.selectedPickerId;
			nextState.selectedOptionIdentity = selectionState.selectedOptionIdentity;
			nextState.selectedGenericPath = selectionState.selectedGenericPath;
			nextState.selectedGenericRowIdentity = selectionState.selectedGenericRowIdentity;
			nextState.selectedDriveResourceGuid = selectedVisualTarget ? getAssignedDriveGuid(selectedVisualTarget) : "";
			nextState.optionVisualMode = inferVisualEditorMode(selectedVisualTarget);
			nextState.swatchInputValue = selectedVisualTarget
				? getCurrentSwatchColor(selectedVisualTarget)
				: "";
			nextState.swatchPickerValue = normalizeHexColorForInput(nextState.swatchInputValue);

			if (this.state.activeTab === "mapper" && !selectionState.mapperMode) {
				nextState.activeTab = "raw";
			}
		}

		this.setState(nextState, () => this.emitEditorState(value, validity));
	}

	handleSelectTab = (activeTab) => {
		if (!activeTab) {
			return;
		}
		this.setState({ activeTab });
	}

	handleShowAddFamily = () => {
		const nextId = buildUniquePickerId(this.state.parsedContent, "new picker family", this.state.optionValueAutoFormat);
		this.setState({
			showAddFamily: true,
			newFamilyId: nextId,
			newFamilyLabel: _.startCase(nextId.replace(/_/g, " ")),
			newFamilyStorageMode: PICKER_STORAGE_MODE_BOTH
		});
	}

	handleHideAddFamily = () => {
		this.setState({
			showAddFamily: false,
			newFamilyId: "",
			newFamilyLabel: "",
			newFamilyStorageMode: PICKER_STORAGE_MODE_BOTH
		});
	}

	handleAddFamily = () => {
		const { parsedContent, newFamilyId, newFamilyLabel, newFamilyStorageMode, optionValueAutoFormat } = this.state;
		const nextId = buildUniquePickerId(parsedContent, newFamilyId || newFamilyLabel || "new picker family", optionValueAutoFormat);
		const nextLabel = `${newFamilyLabel || _.startCase(nextId.replace(/_/g, " "))}`.trim();
		const nextContent = addPickerFamily(parsedContent, {
			id: nextId,
			label: nextLabel,
			storageMode: newFamilyStorageMode || PICKER_STORAGE_MODE_BOTH
		});
		this.setDocumentState(nextContent, { selectedPickerId: nextId, selectedOptionIndex: 0 });
		this.setState({
			showAddFamily: false,
			newFamilyId: "",
			newFamilyLabel: "",
			newFamilyStorageMode: PICKER_STORAGE_MODE_BOTH
		});
	}

	handleDeleteFamily = (pickerId) => {
		if (!pickerId) {
			return;
		}
		const nextContent = deletePickerFamily(this.state.parsedContent, pickerId);
		this.setDocumentState(nextContent);
	}

	handleSortFamilies = ({ oldIndex, newIndex }) => {
		if (oldIndex === newIndex) {
			return;
		}
		const orderedIds = arrayMove(getPickerIds(this.state.parsedContent), oldIndex, newIndex);
		const nextContent = reorderPickerFamilies(this.state.parsedContent, orderedIds);
		this.setDocumentState(nextContent, { selectedPickerId: orderedIds[newIndex] });
	}

	handleAddOption = () => {
		const { parsedContent, selectedPickerId, optionValueAutoFormat } = this.state;
		if (!selectedPickerId) {
			return;
		}
		const currentOptions = getPickerOptions(parsedContent, selectedPickerId);
		const nextContent = addPickerOption(parsedContent, selectedPickerId, buildDefaultOption(currentOptions, optionValueAutoFormat));
		this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: currentOptions.length });
	}

	handleDeleteOption = (selectedOptionIdentityArg = null) => {
		const { parsedContent, selectedPickerId } = this.state;
		const selectedOptionIdentity = _.isString(selectedOptionIdentityArg) && selectedOptionIdentityArg !== ""
			? selectedOptionIdentityArg
			: this.state.selectedOptionIdentity;
		const selectedOption = selectedOptionIdentity
			? this.getSelectedPickerOptions().find((option) => option.__optionIdentity === selectedOptionIdentity)
			: this.getSelectedOption();
		if (!selectedPickerId || !selectedOption) {
			return;
		}
		const currentOptions = this.getSelectedPickerOptions();
		const currentIndex = currentOptions.findIndex((option) => option.__optionIdentity === selectedOption.__optionIdentity);
		const nextContent = deletePickerOption(parsedContent, selectedPickerId, selectedOption.__optionIdentity);
		this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: Math.max(0, currentIndex - 1) });
	}

	handleSortOptions = ({ oldIndex, newIndex }) => {
		const { parsedContent, selectedPickerId } = this.state;
		if (!selectedPickerId || oldIndex === newIndex) {
			return;
		}
		const visibleOptions = this.getFilteredOptions();
		const allOptions = this.getSelectedPickerOptions();
		const movedOption = visibleOptions[oldIndex];
		const targetOption = visibleOptions[newIndex];
		const actualOldIndex = allOptions.findIndex((option) => option.__optionIdentity === _.get(movedOption, "__optionIdentity"));
		const actualNewIndex = allOptions.findIndex((option) => option.__optionIdentity === _.get(targetOption, "__optionIdentity"));
		if (actualOldIndex < 0 || actualNewIndex < 0) {
			return;
		}
		const nextContent = reorderPickerOptions(parsedContent, selectedPickerId, actualOldIndex, actualNewIndex);
		this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: actualNewIndex });
	}

	handleSelectedFamilyLabelChange = (event) => {
		const { parsedContent, selectedPickerId, optionValueAutoFormat } = this.state;
		if (!selectedPickerId) {
			return;
		}
		const nextLabel = `${_.get(event, "target.value", "")}`;
		const previousLabel = getPickerLabel(parsedContent, selectedPickerId);
		let nextContent = updatePickerFamilyMeta(parsedContent, selectedPickerId, {
			label: nextLabel
		});
		let nextSelectedPickerId = selectedPickerId;
		if (isAutoGeneratedKeyForSource(selectedPickerId, previousLabel)) {
			const nextAutoId = buildUniquePickerId(nextContent, nextLabel || "new picker family", optionValueAutoFormat, [selectedPickerId]);
			if (nextAutoId && nextAutoId !== selectedPickerId) {
				nextContent = renamePickerFamilyId(nextContent, selectedPickerId, nextAutoId);
				nextSelectedPickerId = nextAutoId;
			}
		}
		this.setDocumentState(nextContent, { selectedPickerId: nextSelectedPickerId });
	}

	handleSelectedFamilyIdChange = (event) => {
		const { parsedContent, selectedPickerId, optionValueAutoFormat } = this.state;
		if (!selectedPickerId) {
			return;
		}
		const nextId = buildAutoCustomFieldKey(_.get(event, "target.value", ""), optionValueAutoFormat);
		if (!nextId || nextId === selectedPickerId) {
			return;
		}
		if (getPickerIds(parsedContent).includes(nextId)) {
			showError("Picker Family", `A picker family with id "${nextId}" already exists.`);
			return;
		}
		const nextContent = renamePickerFamilyId(parsedContent, selectedPickerId, nextId);
		this.setDocumentState(nextContent, { selectedPickerId: nextId });
	}

	handleSelectedFamilyStorageModeChange = (event) => {
		const { parsedContent, selectedPickerId } = this.state;
		if (!selectedPickerId) {
			return;
		}
		const nextContent = setPickerFamilyStorageMode(parsedContent, selectedPickerId, _.get(event, "target.value", PICKER_STORAGE_MODE_BOTH));
		this.setDocumentState(nextContent, { selectedPickerId });
	}

	handleSelectedOptionFieldChange = (field, value) => {
		const { parsedContent, selectedPickerId, optionValueAutoFormat } = this.state;
		const selectedOption = this.getSelectedOption();
		if (!selectedPickerId || !selectedOption) {
			return;
		}
		const nextIndex = selectedOption.__index;
		let nextContent = updatePickerOptionField(parsedContent, selectedPickerId, selectedOption, field, value);
		if (field === "label") {
			const previousLabel = _.get(selectedOption, "label", "");
			const currentValue = _.get(selectedOption, "value", "");
			const previousAutoValue = buildAutoOptionValue(previousLabel, optionValueAutoFormat);
			const nextAutoValue = buildAutoOptionValue(value, optionValueAutoFormat);
			if ((currentValue || "") === "" || currentValue === previousAutoValue) {
				nextContent = updatePickerOptionField(nextContent, selectedPickerId, selectedOption, "value", nextAutoValue);
			}
		}
		this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: nextIndex });
	}

	handleChangeOptionValueAutoFormat = (event) => {
		const nextFormat = normalizeOptionValueAutoFormat(_.get(event, "target.value", "dashed"));
		const previousFormat = normalizeOptionValueAutoFormat(this.state.optionValueAutoFormat);
		const { parsedContent, selectedPickerId } = this.state;
		const selectedOption = this.getSelectedOption();
		const selectedFamilyLabel = selectedPickerId ? getPickerLabel(parsedContent, selectedPickerId) : "";
		const nextFamilyAutoId = selectedPickerId
			? buildUniquePickerId(parsedContent, selectedFamilyLabel || "new picker family", nextFormat, [selectedPickerId])
			: "";
		const shouldAutoRenameFamilyId = !!selectedPickerId && isAutoGeneratedKeyForSource(selectedPickerId, selectedFamilyLabel) && nextFamilyAutoId && nextFamilyAutoId !== selectedPickerId;
		const previousFamilyAutoKey = buildAutoCustomFieldKey(this.state.newFamilyCustomFieldName, previousFormat);
		const nextFamilyAutoKey = buildAutoCustomFieldKey(this.state.newFamilyCustomFieldName, nextFormat);
		const previousOptionAutoKey = buildAutoCustomFieldKey(this.state.newOptionCustomFieldName, previousFormat);
		const nextOptionAutoKey = buildAutoCustomFieldKey(this.state.newOptionCustomFieldName, nextFormat);
		const nextFamilyCustomFieldKey = (this.state.newFamilyCustomFieldKey || "") === "" || this.state.newFamilyCustomFieldKey === previousFamilyAutoKey
			? nextFamilyAutoKey
			: this.state.newFamilyCustomFieldKey;
		const nextOptionCustomFieldKey = (this.state.newOptionCustomFieldKey || "") === "" || this.state.newOptionCustomFieldKey === previousOptionAutoKey
			? nextOptionAutoKey
			: this.state.newOptionCustomFieldKey;
		if (!selectedPickerId || !selectedOption) {
			let nextContent = parsedContent;
			let nextSelectedPickerId = selectedPickerId;
			if (shouldAutoRenameFamilyId) {
				nextContent = renamePickerFamilyId(parsedContent, selectedPickerId, nextFamilyAutoId);
				nextSelectedPickerId = nextFamilyAutoId;
			}
			this.setState({
				optionValueAutoFormat: nextFormat,
				newFamilyCustomFieldKey: nextFamilyCustomFieldKey,
				newOptionCustomFieldKey: nextOptionCustomFieldKey
			}, () => {
				if (shouldAutoRenameFamilyId) {
					this.setDocumentState(nextContent, { selectedPickerId: nextSelectedPickerId });
				}
			});
			return;
		}

		const label = _.get(selectedOption, "label", "");
		const currentValue = _.get(selectedOption, "value", "");
		const previousAutoValue = buildAutoOptionValue(label, previousFormat);
		const nextAutoValue = buildAutoOptionValue(label, nextFormat);
		let nextContent = parsedContent;
		let nextSelectedPickerId = selectedPickerId;
		if (shouldAutoRenameFamilyId) {
			nextContent = renamePickerFamilyId(nextContent, selectedPickerId, nextFamilyAutoId);
			nextSelectedPickerId = nextFamilyAutoId;
		}
		if ((currentValue || "") === "" || currentValue === previousAutoValue) {
			const nextIndex = selectedOption.__index;
			nextContent = updatePickerOptionField(nextContent, nextSelectedPickerId, selectedOption, "value", nextAutoValue);
			this.setState({
				optionValueAutoFormat: nextFormat,
				newFamilyCustomFieldKey: nextFamilyCustomFieldKey,
				newOptionCustomFieldKey: nextOptionCustomFieldKey
			}, () => {
				this.setDocumentState(nextContent, { selectedPickerId: nextSelectedPickerId, selectedOptionIndex: nextIndex });
			});
			return;
		}

		this.setState({
			optionValueAutoFormat: nextFormat,
			newFamilyCustomFieldKey: nextFamilyCustomFieldKey,
			newOptionCustomFieldKey: nextOptionCustomFieldKey
		}, () => {
			if (shouldAutoRenameFamilyId) {
				this.setDocumentState(nextContent, { selectedPickerId: nextSelectedPickerId });
			}
		});
	}

	handleNewFamilyCustomFieldNameChange = (event) => {
		const nextName = _.get(event, "target.value", "");
		const previousName = this.state.newFamilyCustomFieldName;
		const currentKey = this.state.newFamilyCustomFieldKey;
		const previousAutoKey = buildAutoCustomFieldKey(previousName, this.state.optionValueAutoFormat);
		const nextAutoKey = buildAutoCustomFieldKey(nextName, this.state.optionValueAutoFormat);
		this.setState({
			newFamilyCustomFieldName: nextName,
			newFamilyCustomFieldKey: (currentKey || "") === "" || currentKey === previousAutoKey ? nextAutoKey : currentKey
		});
	}

	handleNewFamilyCustomFieldKeyChange = (event) => {
		this.setState({ newFamilyCustomFieldKey: _.get(event, "target.value", "") });
	}

	handleNewOptionCustomFieldNameChange = (event) => {
		const nextName = _.get(event, "target.value", "");
		const previousName = this.state.newOptionCustomFieldName;
		const currentKey = this.state.newOptionCustomFieldKey;
		const previousAutoKey = buildAutoCustomFieldKey(previousName, this.state.optionValueAutoFormat);
		const nextAutoKey = buildAutoCustomFieldKey(nextName, this.state.optionValueAutoFormat);
		this.setState({
			newOptionCustomFieldName: nextName,
			newOptionCustomFieldKey: (currentKey || "") === "" || currentKey === previousAutoKey ? nextAutoKey : currentKey
		});
	}

	handleNewOptionCustomFieldKeyChange = (event) => {
		this.setState({ newOptionCustomFieldKey: _.get(event, "target.value", "") });
	}

	handleFamilyCustomFieldDraftChange = (fieldKey, event) => {
		this.setState({
			familyCustomFieldDraftKeys: {
				...this.state.familyCustomFieldDraftKeys,
				[fieldKey]: _.get(event, "target.value", "")
			}
		});
	}

	handleOptionCustomFieldDraftChange = (fieldKey, event) => {
		this.setState({
			optionCustomFieldDraftKeys: {
				...this.state.optionCustomFieldDraftKeys,
				[fieldKey]: _.get(event, "target.value", "")
			}
		});
	}

	handleDuplicateFamily = (pickerId) => {
		if (!pickerId) {
			return;
		}
		const { parsedContent } = this.state;
		const nextId = buildUniquePickerId(parsedContent, `${pickerId}_copy`);
		const nextLabel = `${getPickerLabel(parsedContent, pickerId)} Copy`;
		const nextContent = duplicatePickerFamily(parsedContent, pickerId, nextId, nextLabel);
		this.setDocumentState(nextContent, { selectedPickerId: nextId, selectedOptionIndex: 0 });
	}

	handleDuplicateOption = (selectedOptionIdentityArg = null) => {
		const { parsedContent, selectedPickerId } = this.state;
		const selectedOption = selectedOptionIdentityArg
			? this.getSelectedPickerOptions().find((option) => option.__optionIdentity === selectedOptionIdentityArg)
			: this.getSelectedOption();
		if (!selectedPickerId || !selectedOption) {
			return;
		}
		const currentOptions = this.getSelectedPickerOptions();
		const nextContent = duplicatePickerOption(parsedContent, selectedPickerId, selectedOption);
		this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: currentOptions.length });
	}

	handleAddFamilyCustomField = () => {
		const { parsedContent, selectedPickerId, newFamilyCustomFieldKey, newFamilyCustomFieldType, newFamilyCustomFieldValue, optionValueAutoFormat } = this.state;
		if (!selectedPickerId) {
			return;
		}
		const fieldKey = buildAutoCustomFieldKey(newFamilyCustomFieldKey, optionValueAutoFormat);
		if (!fieldKey) {
			showError("Custom Field", "Family custom field key is required.");
			return;
		}
		if (MANAGED_FAMILY_KEYS.includes(fieldKey)) {
			showError("Custom Field", `"${fieldKey}" is managed by the editor and cannot be added as a custom family field.`);
			return;
		}
		const familySource = getArrayPickerEntry(parsedContent, selectedPickerId) || getPickerEntry(parsedContent, selectedPickerId) || {};
		if (_.has(familySource, fieldKey)) {
			showError("Custom Field", `Family field "${fieldKey}" already exists.`);
			return;
		}
		const parsedValue = parseCustomFieldValue(newFamilyCustomFieldValue, newFamilyCustomFieldType);
		if (!parsedValue.valid) {
			showError("Custom Field", parsedValue.error || "Unable to parse family custom field value.");
			return;
		}
		const nextContent = updatePickerFamilyCustomField(parsedContent, selectedPickerId, fieldKey, parsedValue.value);
		this.setDocumentState(nextContent, { selectedPickerId });
		this.setState({
			newFamilyCustomFieldName: "",
			newFamilyCustomFieldKey: "",
			newFamilyCustomFieldType: CUSTOM_FIELD_TYPE_STRING,
			newFamilyCustomFieldValue: ""
		});
	}

	handleAddOptionCustomField = () => {
		const { parsedContent, selectedPickerId, newOptionCustomFieldKey, newOptionCustomFieldType, newOptionCustomFieldValue, optionValueAutoFormat } = this.state;
		const selectedOption = this.getSelectedOption();
		if (!selectedPickerId || !selectedOption) {
			return;
		}
		const fieldKey = buildAutoCustomFieldKey(newOptionCustomFieldKey, optionValueAutoFormat);
		if (!fieldKey) {
			showError("Custom Field", "Option custom field key is required.");
			return;
		}
		if (MANAGED_OPTION_KEYS.includes(fieldKey)) {
			showError("Custom Field", `"${fieldKey}" is managed by the editor and cannot be added as a custom option field.`);
			return;
		}
		if (_.has(selectedOption, fieldKey)) {
			showError("Custom Field", `Option field "${fieldKey}" already exists.`);
			return;
		}
		const parsedValue = parseCustomFieldValue(newOptionCustomFieldValue, newOptionCustomFieldType);
		if (!parsedValue.valid) {
			showError("Custom Field", parsedValue.error || "Unable to parse option custom field value.");
			return;
		}
		const nextContent = updatePickerOptionCustomField(parsedContent, selectedPickerId, selectedOption, fieldKey, parsedValue.value);
		this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: selectedOption.__index });
		this.setState({
			newOptionCustomFieldName: "",
			newOptionCustomFieldKey: "",
			newOptionCustomFieldType: CUSTOM_FIELD_TYPE_STRING,
			newOptionCustomFieldValue: ""
		});
	}

	handleFamilyCustomFieldValueChange = (fieldKey, type, rawValue) => {
		const { parsedContent, selectedPickerId } = this.state;
		if (!selectedPickerId) {
			return;
		}
		const parsedValue = parseCustomFieldValue(rawValue, type);
		if (!parsedValue.valid) {
			return;
		}
		const nextContent = updatePickerFamilyCustomField(parsedContent, selectedPickerId, fieldKey, parsedValue.value);
		this.setDocumentState(nextContent, { selectedPickerId });
	}

	handleOptionCustomFieldValueChange = (fieldKey, type, rawValue) => {
		const { parsedContent, selectedPickerId } = this.state;
		const selectedOption = this.getSelectedOption();
		if (!selectedPickerId || !selectedOption) {
			return;
		}
		const parsedValue = parseCustomFieldValue(rawValue, type);
		if (!parsedValue.valid) {
			return;
		}
		const nextContent = updatePickerOptionCustomField(parsedContent, selectedPickerId, selectedOption, fieldKey, parsedValue.value);
		this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: selectedOption.__index });
	}

	handleFamilyCustomFieldKeyBlur = (oldKey, event) => {
		const { parsedContent, selectedPickerId, optionValueAutoFormat } = this.state;
		if (!selectedPickerId) {
			return;
		}
		const nextKey = buildAutoCustomFieldKey(_.get(event, "target.value", ""), optionValueAutoFormat);
		if (!nextKey || nextKey === oldKey) {
			this.setState({
				familyCustomFieldDraftKeys: _.omit(this.state.familyCustomFieldDraftKeys, oldKey)
			});
			return;
		}
		if (MANAGED_FAMILY_KEYS.includes(nextKey)) {
			showError("Custom Field", `"${nextKey}" is reserved.`);
			return;
		}
		const familySource = getArrayPickerEntry(parsedContent, selectedPickerId) || getPickerEntry(parsedContent, selectedPickerId) || {};
		if (_.has(familySource, nextKey)) {
			showError("Custom Field", `Family field "${nextKey}" already exists.`);
			return;
		}
		const nextContent = renamePickerFamilyCustomField(parsedContent, selectedPickerId, oldKey, nextKey);
		this.setState({
			familyCustomFieldDraftKeys: _.omit(this.state.familyCustomFieldDraftKeys, oldKey)
		}, () => {
			this.setDocumentState(nextContent, { selectedPickerId });
		});
	}

	handleOptionCustomFieldKeyBlur = (oldKey, event) => {
		const { parsedContent, selectedPickerId, optionValueAutoFormat } = this.state;
		const selectedOption = this.getSelectedOption();
		if (!selectedPickerId || !selectedOption) {
			return;
		}
		const nextKey = buildAutoCustomFieldKey(_.get(event, "target.value", ""), optionValueAutoFormat);
		if (!nextKey || nextKey === oldKey) {
			this.setState({
				optionCustomFieldDraftKeys: _.omit(this.state.optionCustomFieldDraftKeys, oldKey)
			});
			return;
		}
		if (MANAGED_OPTION_KEYS.includes(nextKey)) {
			showError("Custom Field", `"${nextKey}" is reserved.`);
			return;
		}
		if (_.has(selectedOption, nextKey)) {
			showError("Custom Field", `Option field "${nextKey}" already exists.`);
			return;
		}
		const nextContent = renamePickerOptionCustomField(parsedContent, selectedPickerId, selectedOption, oldKey, nextKey);
		this.setState({
			optionCustomFieldDraftKeys: _.omit(this.state.optionCustomFieldDraftKeys, oldKey)
		}, () => {
			this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: selectedOption.__index });
		});
	}

	handleDeleteFamilyCustomField = (fieldKey) => {
		const { parsedContent, selectedPickerId } = this.state;
		if (!selectedPickerId) {
			return;
		}
		const nextContent = deletePickerFamilyCustomField(parsedContent, selectedPickerId, fieldKey);
		this.setDocumentState(nextContent, { selectedPickerId });
	}

	handleDeleteOptionCustomField = (fieldKey) => {
		const { parsedContent, selectedPickerId } = this.state;
		const selectedOption = this.getSelectedOption();
		if (!selectedPickerId || !selectedOption) {
			return;
		}
		const nextContent = deletePickerOptionCustomField(parsedContent, selectedPickerId, selectedOption, fieldKey);
		this.setDocumentState(nextContent, { selectedPickerId, selectedOptionIndex: selectedOption.__index });
	}

	handleSelectPicker = (selectedPickerId) => {
		const { parsedContent } = this.state;
		const options = getPickerOptions(parsedContent, selectedPickerId);
		const selectedOption = options[0] || null;
		const galleryFolderPath = this.state.galleryFolderPath || (selectedOption ? getFolderPathForOption(selectedOption) : "");
		this.setState({
			selectedPickerId,
			selectedOptionIdentity: selectedOption ? selectedOption.__optionIdentity : null,
			selectedDriveResourceGuid: selectedOption ? getAssignedDriveGuid(selectedOption) : "",
			optionVisualMode: inferVisualEditorMode(selectedOption),
			swatchInputValue: getCurrentSwatchColor(selectedOption),
			swatchPickerValue: normalizeHexColorForInput(getCurrentSwatchColor(selectedOption)),
			galleryFolderPath
		}, () => {
			if (galleryFolderPath && this.state.galleryFiles.length === 0) {
				this.loadGalleryFiles(galleryFolderPath);
			}
		});
	}

	handleSelectOption = (selectedOptionIdentity) => {
		this.setState((prevState) => {
			const selectedOption = this.getSelectedPickerOptions().find((option) => option.__optionIdentity === selectedOptionIdentity) || null;
			const nextState = { selectedOptionIdentity };
			nextState.selectedDriveResourceGuid = selectedOption ? getAssignedDriveGuid(selectedOption) : "";
			nextState.optionVisualMode = inferVisualEditorMode(selectedOption);
			nextState.swatchInputValue = getCurrentSwatchColor(selectedOption);
			nextState.swatchPickerValue = normalizeHexColorForInput(getCurrentSwatchColor(selectedOption));
			if ((!prevState.galleryFolderPath || prevState.galleryFolderPath === "") && selectedOption) {
				nextState.galleryFolderPath = getFolderPathForOption(selectedOption);
			}
			return nextState;
		}, () => {
			if (this.state.galleryFolderPath && this.state.galleryFiles.length === 0) {
				this.loadGalleryFiles(this.state.galleryFolderPath);
			}
		});
	}

	handleSelectGenericPath = (selectedGenericPath) => {
		const rows = selectedGenericPath ? getGenericDatasourceRows(this.state.parsedContent, selectedGenericPath).rows : [];
		const selectedGenericRow = rows[0] || null;
		const galleryFolderPath = this.state.galleryFolderPath || (selectedGenericRow ? getFolderPathForOption(selectedGenericRow) : "");
		const selectedGenericCandidate = this.state.genericMapperCandidates.find((candidate) => candidate.path === selectedGenericPath) || null;
			this.setState({
				selectedGenericPath,
				selectedGenericRowIdentity: selectedGenericRow ? selectedGenericRow.__rowIdentity : null,
				selectedDriveResourceGuid: selectedGenericRow ? getAssignedDriveGuid(selectedGenericRow) : "",
				optionVisualMode: inferVisualEditorMode(selectedGenericRow),
				swatchInputValue: getCurrentSwatchColor(selectedGenericRow),
				swatchPickerValue: normalizeHexColorForInput(getCurrentSwatchColor(selectedGenericRow)),
				galleryFolderPath,
				relatedEntityLinkSelections: {},
				showAddGenericEntity: false,
				newGenericEntityDraft: buildInitialAuthoringEntityDraft(selectedGenericCandidate),
				newGenericEntityError: ""
		}, () => {
			if (galleryFolderPath && this.state.galleryFiles.length === 0) {
				this.loadGalleryFiles(galleryFolderPath);
			}
		});
	}

	handleSelectGenericRow = (selectedGenericRowIdentity) => {
		this.setState((prevState) => {
			const selectedGenericRow = this.getSelectedGenericRows().find((row) => row.__rowIdentity === selectedGenericRowIdentity) || null;
			const nextState = { selectedGenericRowIdentity };
				nextState.selectedDriveResourceGuid = selectedGenericRow ? getAssignedDriveGuid(selectedGenericRow) : "";
				nextState.optionVisualMode = inferVisualEditorMode(selectedGenericRow);
				nextState.swatchInputValue = getCurrentSwatchColor(selectedGenericRow);
				nextState.swatchPickerValue = normalizeHexColorForInput(getCurrentSwatchColor(selectedGenericRow));
				nextState.relatedEntityLinkSelections = {};
				if ((!prevState.galleryFolderPath || prevState.galleryFolderPath === "") && selectedGenericRow) {
					nextState.galleryFolderPath = getFolderPathForOption(selectedGenericRow);
				}
			return nextState;
		}, () => {
			if (this.state.galleryFolderPath && this.state.galleryFiles.length === 0) {
				this.loadGalleryFiles(this.state.galleryFolderPath);
			}
		});
	}

	handleJumpToGenericRow = (selectedGenericPath, selectedGenericRowIdentity = null) => {
		const rows = selectedGenericPath ? getGenericDatasourceRows(this.state.parsedContent, selectedGenericPath).rows : [];
		const selectedGenericRow = selectedGenericRowIdentity
			? rows.find((row) => row.__rowIdentity === selectedGenericRowIdentity) || null
			: rows[0] || null;
		const galleryFolderPath = this.state.galleryFolderPath || (selectedGenericRow ? getFolderPathForOption(selectedGenericRow) : "");
			this.setState({
				selectedGenericPath,
				selectedGenericRowIdentity: selectedGenericRow ? selectedGenericRow.__rowIdentity : null,
				selectedDriveResourceGuid: selectedGenericRow ? getAssignedDriveGuid(selectedGenericRow) : "",
				optionVisualMode: inferVisualEditorMode(selectedGenericRow),
				swatchInputValue: getCurrentSwatchColor(selectedGenericRow),
				swatchPickerValue: normalizeHexColorForInput(getCurrentSwatchColor(selectedGenericRow)),
				galleryFolderPath,
				relatedEntityLinkSelections: {},
				showAddGenericEntity: false,
				newGenericEntityDraft: buildInitialAuthoringEntityDraft(this.state.genericMapperCandidates.find((candidate) => candidate.path === selectedGenericPath) || null),
				newGenericEntityError: ""
		}, () => {
			if (galleryFolderPath && this.state.galleryFiles.length === 0) {
				this.loadGalleryFiles(galleryFolderPath);
			}
		});
	}

	handleAddAuthoringCollection = (candidatePath) => {
		const candidate = AUTHORING_COLLECTION_CANDIDATES.find((item) => item.path === candidatePath) || null;
		const result = addAuthoringCollectionToDocument(this.state.parsedContent, candidate);
		if (result.error) {
			showError("Authoring Collection", result.error);
			return;
		}
		this.setDocumentState(result.content, {
			selectedGenericPath: result.path,
			selectedGenericRowIdentity: null
		});
	}

	handleShowAddRelatedEntity = (targetPath, draftOverrides = {}) => {
		const targetCandidate = AUTHORING_COLLECTION_CANDIDATES.find((candidate) => candidate.path === targetPath) || null;
		if (!targetCandidate) {
			showError("Authoring", "Unable to resolve the target collection for this child entity.");
			return;
		}

		let nextContent = this.state.parsedContent;
		const collectionKey = getAuthoringCollectionKeyFromPath(targetPath);
		if (!_.has(_.get(nextContent, "collections", {}), collectionKey)) {
			const addCollectionResult = addAuthoringCollectionToDocument(nextContent, targetCandidate);
			if (addCollectionResult.error) {
				showError("Authoring Collection", addCollectionResult.error);
				return;
			}
			nextContent = addCollectionResult.content;
		}

		const nextDraft = {
			...buildInitialAuthoringEntityDraft(targetCandidate),
			...draftOverrides
		};

		this.setDocumentState(
			nextContent,
			{ selectedGenericPath: targetPath },
			{
				showAddGenericEntity: true,
				newGenericEntityDraft: nextDraft,
				newGenericEntityError: ""
			}
		);
	}

	handleShowAddGenericEntity = () => {
		this.setState({
			showAddGenericEntity: true,
			newGenericEntityDraft: buildInitialAuthoringEntityDraft(this.getSelectedGenericCandidate()),
			newGenericEntityError: ""
		});
	}

	handleHideAddGenericEntity = () => {
		this.setState({
			showAddGenericEntity: false,
			newGenericEntityDraft: buildInitialAuthoringEntityDraft(this.getSelectedGenericCandidate()),
			newGenericEntityError: ""
		});
	}

	handleGenericEntityDraftFieldChange = (fieldKey, value) => {
		this.setState((prevState) => ({
			newGenericEntityDraft: {
				...prevState.newGenericEntityDraft,
				[fieldKey]: value
			},
			newGenericEntityError: ""
		}));
	}

	handleRelatedEntityLinkSelectionChange = (groupKey, value) => {
		this.setState((prevState) => ({
			relatedEntityLinkSelections: {
				...prevState.relatedEntityLinkSelections,
				[groupKey]: value
			}
		}));
	}

	handleLinkExistingSelectionOptionToGroup = (groupId, optionId) => {
		if (!groupId || !optionId) {
			return;
		}
		const selectedOption = _.get(this.state.parsedContent, ["collections", "selectionOptionsById", optionId]);
		if (!_.isPlainObject(selectedOption)) {
			showError("Selection Options", `Option "${optionId}" does not exist.`);
			return;
		}
		if (!_.has(this.state.parsedContent, ["collections", "selectionGroupsById", groupId])) {
			showError("Selection Groups", `Group "${groupId}" does not exist.`);
			return;
		}

		const nextContent = _.cloneDeep(this.state.parsedContent);
		const nextGroupIds = _.uniq([...getSelectionOptionGroupIds(selectedOption, nextContent), groupId]);
		updateSelectionOptionMemberships(nextContent, optionId, nextGroupIds, getSelectionOptionGroupIds(selectedOption, nextContent));

		this.setDocumentState(
			nextContent,
			{
				selectedGenericPath: "collections.selectionOptionsById",
				selectedGenericRowIdentity: optionId
			},
			{
				relatedEntityLinkSelections: {}
			}
		);
	}

	handleUnlinkSelectionOptionFromGroup = (groupId, optionId, selectionOverrides = {}) => {
		if (!groupId || !optionId) {
			return;
		}
		const selectedOption = _.get(this.state.parsedContent, ["collections", "selectionOptionsById", optionId]);
		if (!_.isPlainObject(selectedOption)) {
			showError("Selection Options", `Option "${optionId}" does not exist.`);
			return;
		}
		if (!_.has(this.state.parsedContent, ["collections", "selectionGroupsById", groupId])) {
			showError("Selection Groups", `Group "${groupId}" does not exist.`);
			return;
		}

		const nextContent = _.cloneDeep(this.state.parsedContent);
		const previousGroupIds = getSelectionOptionGroupIds(selectedOption, nextContent);
		const nextGroupIds = previousGroupIds.filter((existingGroupId) => existingGroupId !== groupId);
		updateSelectionOptionMemberships(nextContent, optionId, nextGroupIds, previousGroupIds);

		this.setDocumentState(
			nextContent,
			selectionOverrides,
			{
				relatedEntityLinkSelections: {}
			}
		);
	}

	handleAddGenericEntity = () => {
		const selectedGenericCandidate = this.getSelectedGenericCandidate();
		if (!selectedGenericCandidate || selectedGenericCandidate.visualStorage !== AUTHORING_VISUAL_STORAGE_MODE) {
			return;
		}
		const result = addAuthoringEntityToDocument(this.state.parsedContent, selectedGenericCandidate, this.state.newGenericEntityDraft);
		if (result.error) {
			this.setState({ newGenericEntityError: result.error });
			return;
		}
		this.setDocumentState(result.content, {
			selectedGenericPath: selectedGenericCandidate.path,
			selectedGenericRowIdentity: result.rowIdentity
		});
		this.setState({
			showAddGenericEntity: false,
			newGenericEntityDraft: buildInitialAuthoringEntityDraft(selectedGenericCandidate),
			newGenericEntityError: ""
		});
	}

	handleAssignImage = (resource) => {
		if (!resource) {
			return;
		}

		const { parsedContent, selectedPickerId, selectedGenericPath } = this.state;
		const selectedVisualTarget = this.getSelectedMapperVisualTarget();
		if (!parsedContent || !selectedVisualTarget) {
			return;
		}

		const imageUrl = getUrlForExternalResource(resource);
		const imagePayload = {
			image: imageUrl,
			imageDriveGuid: resource.guid || "",
			imageDrivePath: resource.path || "",
			imageDriveUrl: imageUrl
		};

		let nextContent = parsedContent;
		if (this.state.mapperMode === "generic") {
			const selectedGenericCandidate = this.getSelectedGenericCandidate();
			nextContent = updateMappedRowVisuals(
				parsedContent,
				selectedGenericPath,
				selectedVisualTarget,
				imagePayload,
				IMAGE_FIELD_KEYS,
				selectedGenericCandidate
			);
			this.setDocumentState(nextContent, {
				selectedGenericPath,
				selectedGenericRowIdentity: selectedVisualTarget.__rowIdentity
			});
		} else {
			if (!selectedPickerId) {
				return;
			}
			nextContent = updatePickerOptionPayload(parsedContent, selectedPickerId, selectedVisualTarget, imagePayload, IMAGE_FIELD_KEYS);
			this.setDocumentState(nextContent, {
				selectedPickerId,
				selectedOptionIdentity: selectedVisualTarget.__optionIdentity
			});
		}
		this.setState({
			selectedDriveResourceGuid: resource.guid || "",
			optionVisualMode: getCurrentSwatchColor(selectedVisualTarget) ? "both" : "image"
		});
	}

	handleClearImage = () => {
		const { parsedContent, selectedPickerId, selectedGenericPath } = this.state;
		const selectedVisualTarget = this.getSelectedMapperVisualTarget();
		if (!parsedContent || !selectedVisualTarget) {
			return;
		}

		let nextContent = parsedContent;
		if (this.state.mapperMode === "generic") {
			const selectedGenericCandidate = this.getSelectedGenericCandidate();
			nextContent = updateMappedRowVisuals(
				parsedContent,
				selectedGenericPath,
				selectedVisualTarget,
				{},
				IMAGE_FIELD_KEYS,
				selectedGenericCandidate
			);
			this.setDocumentState(nextContent, {
				selectedGenericPath,
				selectedGenericRowIdentity: selectedVisualTarget.__rowIdentity
			});
		} else {
			if (!selectedPickerId) {
				return;
			}
			nextContent = updatePickerOptionPayload(parsedContent, selectedPickerId, selectedVisualTarget, {}, IMAGE_FIELD_KEYS);
			this.setDocumentState(nextContent, {
				selectedPickerId,
				selectedOptionIdentity: selectedVisualTarget.__optionIdentity
			});
		}
		this.setState({
			selectedDriveResourceGuid: "",
			optionVisualMode: getCurrentSwatchColor(selectedVisualTarget) ? "swatch" : "image"
		});
	}

	handleSwatchInputChange = (event) => {
		const nextValue = `${_.get(event, "target.value", "")}`.trimStart();
		this.setState((prevState) => ({
			swatchInputValue: nextValue,
			swatchPickerValue: /^#[0-9a-fA-F]{3,6}$/.test(nextValue.trim()) ? normalizeHexColorForInput(nextValue) : prevState.swatchPickerValue
		}));
	}

	handleSwatchPickerChange = (event) => {
		const nextValue = `${_.get(event, "target.value", "")}`.trim();
		this.setState({
			swatchPickerValue: normalizeHexColorForInput(nextValue),
			swatchInputValue: nextValue
		});
	}

	handleAssignSwatch = () => {
		const { parsedContent, selectedPickerId, selectedGenericPath, swatchInputValue, swatchPickerValue } = this.state;
		const selectedVisualTarget = this.getSelectedMapperVisualTarget();
		if (!parsedContent || !selectedVisualTarget) {
			return;
		}

		const nextSwatchColor = `${swatchInputValue || ""}`.trim() || swatchPickerValue;
		if (!nextSwatchColor) {
			return;
		}

		let nextContent = parsedContent;
		if (this.state.mapperMode === "generic") {
			const selectedGenericCandidate = this.getSelectedGenericCandidate();
			nextContent = updateMappedRowVisuals(
				parsedContent,
				selectedGenericPath,
				selectedVisualTarget,
				{ swatchColor: nextSwatchColor },
				SWATCH_FIELD_KEYS,
				selectedGenericCandidate
			);
			this.setDocumentState(nextContent, {
				selectedGenericPath,
				selectedGenericRowIdentity: selectedVisualTarget.__rowIdentity
			});
		} else {
			if (!selectedPickerId) {
				return;
			}
			nextContent = updatePickerOptionPayload(
				parsedContent,
				selectedPickerId,
				selectedVisualTarget,
				{ swatchColor: nextSwatchColor },
				SWATCH_FIELD_KEYS
			);
			this.setDocumentState(nextContent, {
				selectedPickerId,
				selectedOptionIdentity: selectedVisualTarget.__optionIdentity
			});
		}
		this.setState({
			optionVisualMode: getCurrentImageUrl(selectedVisualTarget) ? "both" : "swatch",
			swatchInputValue: nextSwatchColor,
			swatchPickerValue: normalizeHexColorForInput(nextSwatchColor)
		});
	}

	handleClearSwatch = () => {
		const { parsedContent, selectedPickerId, selectedGenericPath } = this.state;
		const selectedVisualTarget = this.getSelectedMapperVisualTarget();
		if (!parsedContent || !selectedVisualTarget) {
			return;
		}

		let nextContent = parsedContent;
		if (this.state.mapperMode === "generic") {
			const selectedGenericCandidate = this.getSelectedGenericCandidate();
			nextContent = updateMappedRowVisuals(
				parsedContent,
				selectedGenericPath,
				selectedVisualTarget,
				{},
				SWATCH_FIELD_KEYS,
				selectedGenericCandidate
			);
			this.setDocumentState(nextContent, {
				selectedGenericPath,
				selectedGenericRowIdentity: selectedVisualTarget.__rowIdentity
			});
		} else {
			if (!selectedPickerId) {
				return;
			}
			nextContent = updatePickerOptionPayload(parsedContent, selectedPickerId, selectedVisualTarget, {}, SWATCH_FIELD_KEYS);
			this.setDocumentState(nextContent, {
				selectedPickerId,
				selectedOptionIdentity: selectedVisualTarget.__optionIdentity
			});
		}
		this.setState({
			optionVisualMode: getCurrentImageUrl(selectedVisualTarget) ? "image" : "swatch",
			swatchInputValue: "",
			swatchPickerValue: "#cccccc"
		});
	}

	handleSelectDriveResource = (resource) => {
		this.setState({
			selectedDriveResourceGuid: _.get(resource, "guid", "")
		});
	}

	handleAssignSelectedDriveResource = () => {
		const resource = this.getSelectedDriveResource();
		if (!resource || resource.type !== "file") {
			return;
		}

		this.handleAssignImage(resource);
	}

	handleShowImageEditorModal = () => {
		const resource = this.getSelectedDriveResource();
		if (!resource || !isImageDriveFile(resource)) {
			showError("Edit Image", "Select a Drive image before opening the image editor.");
			return;
		}

		this.setState({
			showImageEditorModal: true,
			imageEditorTarget: resource
		});
	}

	handleHideImageEditorModal = () => {
		this.setState({
			showImageEditorModal: false,
			imageEditorTarget: null
		});
	}

	handleCreateEditedImage = async ({ blob, imageName, overwriteImage = false, overwriteTargetPath = "", mimeType = "" }) => {
		const target = this.state.imageEditorTarget;
		const selectedVisualTarget = this.getSelectedMapperVisualTarget();
		const assignedGuid = getAssignedDriveGuid(selectedVisualTarget);
		if (!blob || !target || target.type !== "file") {
			const error = new Error("Unable to save edited image.");
			showError("Edit Image", error.message);
			throw error;
		}

		const resolvedMimeType = `${mimeType || blob.type || "image/png"}`.trim() || "image/png";
		const fallbackFileName = resolvedMimeType === "image/jpeg" ? "image-edited.jpg" : "image-edited.png";
		const safeFileName = `${imageName || fallbackFileName}`.trim() || fallbackFileName;
		const file = new File([blob], safeFileName, { type: resolvedMimeType });
		const replaceExistingTarget = overwriteImage ? (overwriteTargetPath || target.path || "") : "";
		const targetPath = replaceExistingTarget || (target.path ? target.path.split("/").slice(0, -1).join("/") : "");

		if (!targetPath) {
			const error = new Error("Unable to determine the destination path for the edited image.");
			showError("Edit Image", error.message);
			throw error;
		}

		const uploadResponse = await uploadFile(targetPath, file, "image", !!replaceExistingTarget, {
			fileName: safeFileName,
			notOptimized: true
		});

		let uploadedResource = null;
		if (uploadResponse && uploadResponse.guid) {
			uploadedResource = getDriveObject(uploadResponse.guid);
		}
		if (!uploadedResource && uploadResponse && uploadResponse.path) {
			const fallbackGuid = _.get(target, "guid", "");
			uploadedResource = getDriveObject(fallbackGuid) || null;
		}

		if (uploadedResource) {
			setActiveTreeCursorForDriveGuid(uploadedResource.guid);
		}

		await this.loadGalleryFiles();

		if (uploadedResource && overwriteImage && assignedGuid && assignedGuid === uploadedResource.guid) {
			this.handleAssignImage(uploadedResource);
		} else if (uploadedResource) {
			this.setState({
				selectedDriveResourceGuid: uploadedResource.guid
			});
		}

		this.setState({
			showImageEditorModal: false,
			imageEditorTarget: null
		});

		return uploadResponse;
	}

	handleShowMetadataModal = () => {
		const resource = this.getSelectedDriveResource();
		if (!resource || resource.type !== "file") {
			showError("Metadata", "Select a Drive file before editing metadata.");
			return;
		}
		this.openMetadataModalForResource(resource);
	}

	buildMetadataEditorStateForResource = (resource, options = {}) => {
		const metaData = resource && resource.metaData && typeof resource.metaData === "object" ? resource.metaData : {};
		const primaryTags = mergeUniqueTags(normalizeTags(metaData.tags));
		const secondaryTags = mergeUniqueTags([
			...normalizeTags(metaData.rekognitionTags),
			...normalizeTags(metaData.openAiTags),
			...normalizeTags(metaData.labels),
			...normalizeTags(resource?.labels)
		]).filter((tag) => !primaryTags.map((entry) => entry.toLowerCase()).includes(tag.toLowerCase()));

		return {
			metadataEditorTitle: cleanMetadataTitle(metaData.title || ""),
			metadataEditorDescription: cleanMetadataDescription(metaData.description || ""),
			metadataEditorTranscript: cleanMetadataTranscript(metaData.transcript || ""),
			metadataEditorTranscriptVtt: cleanMetadataTranscriptVtt(metaData.transcriptVtt || ""),
			metadataEditorTagsInput: "",
			metadataEditorPrimaryTags: primaryTags,
			metadataEditorSecondaryTags: secondaryTags,
			metadataEditorSaving: false,
			metadataLoadingSuggestions: options.loadSuggestions !== false,
			metadataGeneratingField: "",
			metadataTranscriptProvider: TRANSCRIPT_PROVIDER_OPENAI,
			metadataTagsProvider: TAGS_PROVIDER_OPENAI
		};
	}

	openMetadataModalForResource = async (selectedResource) => {
		let resource = selectedResource;
		if (_.get(selectedResource, "guid")) {
			try {
				await refreshCredentials();
				const latestDriveItem = await getDriveItemByGuid(selectedResource.guid);
				if (latestDriveItem) {
					resource = {
						...selectedResource,
						...latestDriveItem
					};
				}
			} catch (err) {
				console.warn("Unable to refresh latest Drive item before opening metadata editor", err);
			}
		}

		const metadataGalleryItems = this.state.showMetadataModal && Array.isArray(this.state.metadataGalleryItems) && this.state.metadataGalleryItems.length > 0
			? this.state.metadataGalleryItems
			: this.buildMetadataGalleryItemsForResource(resource);

		this.setState({
			showMetadataModal: true,
			metadataGalleryItems,
			metadataEditorTarget: resource,
			selectedDriveResourceGuid: resource.guid || this.state.selectedDriveResourceGuid,
			...this.buildMetadataEditorStateForResource(resource)
		}, () => {
			this.loadAlgoliaSuggestionsForMetadata(resource);
		});
	}

	handleHideMetadataModal = () => {
		this.setState({
			showMetadataModal: false,
			metadataGalleryItems: [],
			metadataEditorTarget: null,
			metadataEditorTitle: "",
			metadataEditorDescription: "",
			metadataEditorTranscript: "",
			metadataEditorTranscriptVtt: "",
			metadataEditorSecondaryTags: [],
			metadataEditorTagsInput: "",
			metadataEditorPrimaryTags: [],
			metadataEditorSaving: false,
			metadataLoadingSuggestions: false,
			metadataGeneratingField: "",
			metadataTranscriptProvider: TRANSCRIPT_PROVIDER_OPENAI,
			metadataTagsProvider: TAGS_PROVIDER_OPENAI
		});
	}

	buildMetadataGalleryItemsForResource = (target = this.state.metadataEditorTarget) => {
		if (!target) {
			return [];
		}

		if (this.getMetadataResourceMediaType(target) !== "image") {
			return [];
		}

		const imageFiles = (this.state.galleryFiles || [])
			.filter((file) => this.getMetadataResourceMediaType(file) === "image");
		const targetKey = target?.guid || target?.path || target?.fullPath || target?.name;
		const hasTarget = !!targetKey && imageFiles.some((file) => (file.guid || file.path || file.fullPath || file.name) === targetKey);
		const galleryFiles = hasTarget ? imageFiles : [...imageFiles, target];

		return galleryFiles
			.map((file) => ({
				key: file.guid || file.path || file.fullPath || file.name,
				name: file.name || file.path || file.fullPath || "image",
				url: getUrlForExternalResource(file),
				type: "image",
				resource: file
			}));
	}

	getMetadataGalleryItems = () => {
		if (this.state.showMetadataModal && Array.isArray(this.state.metadataGalleryItems) && this.state.metadataGalleryItems.length > 0) {
			return this.state.metadataGalleryItems;
		}

		return this.buildMetadataGalleryItemsForResource(this.state.metadataEditorTarget);
	}

	getMetadataGalleryIndex = (galleryItems = this.getMetadataGalleryItems()) => {
		const target = this.state.metadataEditorTarget;
		if (!target || !Array.isArray(galleryItems) || galleryItems.length === 0) {
			return -1;
		}
		const targetKey = target.guid || target.path || target.fullPath || target.name;
		return galleryItems.findIndex((item) => {
			const resource = item.resource || item;
			return (resource.guid || resource.path || resource.fullPath || resource.name) === targetKey;
		});
	}

	handleMetadataGallerySelect = (item) => {
		const itemResource = item && (item.resource || item);
		if (!itemResource || itemResource.type !== "file") {
			return;
		}
		const resource = itemResource.guid ? (getDriveObject(itemResource.guid) || itemResource) : itemResource;
		this.openMetadataModalForResource(resource);
	}

	handleSaveMetadataAndNavigate = async (offset = 1) => {
		const galleryItems = this.getMetadataGalleryItems();
		const currentIndex = this.getMetadataGalleryIndex(galleryItems);
		if (galleryItems.length === 0 || currentIndex < 0) {
			await this.handleSaveMetadata();
			return;
		}
		const nextIndex = (currentIndex + offset + galleryItems.length) % galleryItems.length;
		const savedResource = await this.handleSaveMetadata({ closeModal: false, showSuccess: false });
		if (savedResource) {
			this.handleMetadataGallerySelect(galleryItems[nextIndex]);
		}
	}

	normalizePathForLookup = (path = "") => {
		if (!_.isString(path) || path.trim() === "") {
			return "";
		}

		return path
			.trim()
			.replace(/^s3:\/\//, "")
			.replace(/^assets-ambifi-com\//, "")
			.replace(/^(public|private)\/[^/]+\//, "$1/");
	}

	extractTagsFromAlgoliaHit = (hit) => {
		if (!hit || typeof hit !== "object") {
			return [];
		}

		return mergeUniqueTags([
			...normalizeTags(hit.labels),
			...normalizeTags(hit.tags),
			...normalizeTags(_.get(hit, "metaData.tags", [])),
			...normalizeTags(_.get(hit, "metaData.rekognitionTags", [])),
			...normalizeTags(_.get(hit, "metaData.openAiTags", []))
		]);
	}

	extractMetadataFromAlgoliaHit = (hit) => {
		if (!hit || typeof hit !== "object") {
			return { tags: [], title: "", description: "", transcript: "", transcriptVtt: "" };
		}

		return {
			tags: this.extractTagsFromAlgoliaHit(hit),
			title: cleanMetadataTitle(_.get(hit, "metaData.title", "") || hit.title || ""),
			description: cleanMetadataDescription(_.get(hit, "metaData.description", "") || hit.description || ""),
			transcript: cleanMetadataTranscript(_.get(hit, "metaData.transcript", "") || hit.transcript || ""),
			transcriptVtt: cleanMetadataTranscriptVtt(_.get(hit, "metaData.transcriptVtt", "") || hit.transcriptVtt || "")
		};
	}

	fetchAlgoliaTagSuggestions = async (node) => {
		const orgId = getOrgId();
		const indexName = `prod_DRIVE_org_${orgId}`;
		const index = getClient2().initIndex(indexName);
		const attributesToRetrieve = ["objectID", "guid", "path", "labels", "tags", "metaData", "title", "description", "transcript", "transcriptVtt"];
		const normalizedNodePath = this.normalizePathForLookup(node.path || node.fullPath);

		if (node.guid) {
			try {
				const byObjectId = await index.getObject(node.guid, { attributesToRetrieve });
				const meta = this.extractMetadataFromAlgoliaHit(byObjectId);
				if (meta.tags.length > 0 || meta.title || meta.description || meta.transcript || meta.transcriptVtt) {
					return meta;
				}
			} catch (_err) {
				// expected when objectID is not guid
			}
		}

		const searchTerm = `${node.name || ""}`.trim();
		const result = await index.search(searchTerm || "", {
			hitsPerPage: 75,
			attributesToRetrieve
		});
		const hits = Array.isArray(_.get(result, "hits")) ? result.hits : [];
		if (!hits.length) {
			return { tags: [], title: "", description: "", transcript: "", transcriptVtt: "" };
		}

		const matchedHit = hits.find((hit) => {
			const sameGuid = !!node.guid && (hit.guid === node.guid || hit.objectID === node.guid);
			const hitPath = this.normalizePathForLookup(hit.path);
			const samePath = !!normalizedNodePath && !!hitPath && hitPath === normalizedNodePath;
			return sameGuid || samePath;
		}) || hits[0];

		return this.extractMetadataFromAlgoliaHit(matchedHit);
	}

	loadAlgoliaSuggestionsForMetadata = async (node) => {
		try {
			const algoliaMeta = await this.fetchAlgoliaTagSuggestions(node);
			const algoliaTags = _.get(algoliaMeta, "tags", []);
			this.setState((prevState) => {
				if (!prevState.showMetadataModal) {
					return null;
				}
				const currentKey = prevState.metadataEditorTarget?.guid || prevState.metadataEditorTarget?.path || prevState.metadataEditorTarget?.fullPath || prevState.metadataEditorTarget?.name;
				const nodeKey = node?.guid || node?.path || node?.fullPath || node?.name;
				if (currentKey && nodeKey && currentKey !== nodeKey) {
					return null;
				}

				const primarySet = new Set((prevState.metadataEditorPrimaryTags || []).map((tag) => `${tag}`.toLowerCase()));
				const mergedSecondary = mergeUniqueTags([
					...(prevState.metadataEditorSecondaryTags || []),
					...(algoliaTags || [])
				]).filter((tag) => !primarySet.has(`${tag}`.toLowerCase()));

				const updates = {
					metadataEditorSecondaryTags: mergedSecondary,
					metadataLoadingSuggestions: false
				};

				if (!prevState.metadataEditorTitle && algoliaMeta?.title) {
					updates.metadataEditorTitle = algoliaMeta.title;
				}
				if (!prevState.metadataEditorDescription && algoliaMeta?.description) {
					updates.metadataEditorDescription = algoliaMeta.description;
				}
				if (!prevState.metadataEditorTranscript && algoliaMeta?.transcript) {
					updates.metadataEditorTranscript = algoliaMeta.transcript;
				}
				if (!prevState.metadataEditorTranscriptVtt && algoliaMeta?.transcriptVtt) {
					updates.metadataEditorTranscriptVtt = algoliaMeta.transcriptVtt;
				}

				return updates;
			});
		} catch (err) {
			console.warn("Unable to load Algolia tag suggestions for selected picker Drive item:", err?.message || err);
			this.setState({ metadataLoadingSuggestions: false });
		}
	}

	isMetadataGenerationInProgress = (field = "") => {
		const current = `${this.state.metadataGeneratingField || ""}`;
		return field ? current === field : current !== "";
	}

	handleMetadataTitleChange = (event) => {
		this.setState({
			metadataEditorTitle: cleanMetadataTitle(event?.target?.value || "")
		});
	}

	handleMetadataDescriptionChange = (event) => {
		this.setState({
			metadataEditorDescription: cleanMetadataDescription(event?.target?.value || "")
		});
	}

	handleMetadataTranscriptChange = (event) => {
		this.setState({
			metadataEditorTranscript: cleanMetadataTranscript(event?.target?.value || "")
		});
	}

	handleMetadataTranscriptVttChange = (event) => {
		this.setState({
			metadataEditorTranscriptVtt: cleanMetadataTranscriptVtt(event?.target?.value || "")
		});
	}

	handleMetadataTagsInputChange = (event) => {
		this.setState({ metadataEditorTagsInput: event?.target?.value || "" });
	}

	handleAddMetadataInputTags = () => {
		const inputTags = normalizeTags(this.state.metadataEditorTagsInput);
		if (!inputTags.length) {
			return;
		}

		this.setState((prevState) => ({
			metadataEditorPrimaryTags: mergeUniqueTags([...(prevState.metadataEditorPrimaryTags || []), ...inputTags]),
			metadataEditorTagsInput: ""
		}));
	}

	handleRemoveMetadataPrimaryTag = (tagToRemove) => {
		this.setState((prevState) => ({
			metadataEditorPrimaryTags: (prevState.metadataEditorPrimaryTags || []).filter((tag) => tag.toLowerCase() !== `${tagToRemove || ""}`.toLowerCase())
		}));
	}

	handlePromoteMetadataSecondaryTag = (tagToPromote) => {
		this.setState((prevState) => ({
			metadataEditorPrimaryTags: mergeUniqueTags([
				...(prevState.metadataEditorPrimaryTags || []),
				tagToPromote
			]),
			metadataEditorSecondaryTags: (prevState.metadataEditorSecondaryTags || []).filter((tag) => {
				return `${tag}`.toLowerCase() !== `${tagToPromote}`.toLowerCase();
			})
		}));
	}

	handlePromoteAllMetadataSecondaryTags = () => {
		this.setState((prevState) => ({
			metadataEditorPrimaryTags: mergeUniqueTags([
				...(prevState.metadataEditorPrimaryTags || []),
				...(prevState.metadataEditorSecondaryTags || [])
			]),
			metadataEditorSecondaryTags: []
		}));
	}

	handleMetadataTranscriptProviderChange = (event) => {
		this.setState({ metadataTranscriptProvider: event?.target?.value || TRANSCRIPT_PROVIDER_OPENAI });
	}

	handleMetadataTagsProviderChange = (event) => {
		this.setState({ metadataTagsProvider: event?.target?.value || TAGS_PROVIDER_OPENAI });
	}

	getMetadataResourcePath = (resource = null) => {
		const target = resource || this.state.metadataEditorTarget || this.getSelectedDriveResource();
		if (!target) {
			return "";
		}
		if (Array.isArray(target.path)) {
			return target.path.join("/");
		}
		if (_.isString(target.path) && target.path !== "") {
			return target.path;
		}
		if (_.isString(target.fullPath) && target.fullPath !== "") {
			return target.fullPath;
		}
		if (_.isArray(target._path)) {
			return target._path.join("/");
		}
		return "";
	}

	getMetadataResourceMediaType = (resource = null) => {
		const target = resource || this.state.metadataEditorTarget || this.getSelectedDriveResource();
		if (!target) {
			return "file";
		}
		const metaType = `${_.get(target, "metaData.type", "")}`.trim().toLowerCase();
		if (["image", "video", "audio", "pdf"].includes(metaType)) {
			return metaType;
		}
		const contentType = `${target.contentType || target.mimeType || _.get(target, "metaData.contentType", "") || _.get(target, "metaData.mimeType", "")}`.trim().toLowerCase();
		if (contentType.startsWith("image/")) {
			return "image";
		}
		if (contentType.startsWith("video/")) {
			return "video";
		}
		if (contentType.startsWith("audio/")) {
			return "audio";
		}
		if (contentType === "application/pdf") {
			return "pdf";
		}
		if (_.isString(target.ext) && target.ext.trim() !== "") {
			try {
				return getMediaType(target.ext) || "file";
			} catch (_err) {
				return "file";
			}
		}
		return "file";
	}

	getMetadataResourceS3Key = (resource = null) => {
		const path = this.getMetadataResourcePath(resource);
		if (!path) {
			return "";
		}
		const pathParts = path.trim().replace(/^\/+/, "").split("/").filter(Boolean);
		if (pathParts.length < 2) {
			return path;
		}
		const rootSegment = pathParts[0];
		if (rootSegment !== "private" && rootSegment !== "public") {
			return path;
		}
		const hasOrgSegment = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pathParts[1] || "");
		if (!hasOrgSegment) {
			const orgId = getOrgId();
			if (orgId) {
				pathParts.splice(1, 0, orgId);
			}
		}
		return pathParts.join("/");
	}

	extractResponsesText = (payload) => {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		if (typeof payload.output_text === "string" && payload.output_text.trim() !== "") {
			return payload.output_text;
		}
		if (payload.response && typeof payload.response.output_text === "string" && payload.response.output_text.trim() !== "") {
			return payload.response.output_text;
		}
		if (typeof payload.text === "string" && payload.text.trim() !== "") {
			return payload.text;
		}
		const readOutputArray = (arr) => {
			if (!Array.isArray(arr)) {
				return "";
			}
			const parts = [];
			arr.forEach((entry) => {
				if (!entry) {
					return;
				}
				if (entry.type === "message" && Array.isArray(entry.content)) {
					entry.content.forEach((contentPart) => {
						if (typeof contentPart?.text === "string" && contentPart.text.trim() !== "") {
							parts.push(contentPart.text);
						} else if (typeof contentPart?.value === "string" && contentPart.value.trim() !== "") {
							parts.push(contentPart.value);
						}
					});
					return;
				}
				if (typeof entry.text === "string" && entry.text.trim() !== "") {
					parts.push(entry.text);
				}
			});
			return parts.join("").trim();
		};
		return readOutputArray(payload.output || payload.response?.output);
	}

	runMetadataResponsesPrompt = async (promptText = "") => {
		const requestBody = {
			model: "gpt-5.4",
			input: [
				{
					role: "user",
					content: [{ type: "input_text", text: promptText }]
				}
			]
		};
		const payload = await getResponsesCreateLambda(JSON.stringify(requestBody), { showAlert: false });
		return this.extractResponsesText(payload);
	}

	buildMetadataGenerationContext = () => {
		const target = this.state.metadataEditorTarget || this.getSelectedDriveResource();
		const title = cleanMetadataTitle(this.state.metadataEditorTitle || "");
		const description = cleanMetadataDescription(this.state.metadataEditorDescription || "");
		const transcript = cleanMetadataTranscript(this.state.metadataEditorTranscript || "");
		const transcriptVtt = cleanMetadataTranscriptVtt(this.state.metadataEditorTranscriptVtt || "");
		const tags = mergeUniqueTags(this.state.metadataEditorPrimaryTags || []);
		const mediaType = this.getMetadataResourceMediaType(target);
		const path = this.getMetadataResourcePath(target);
		const contextParts = [
			`File name: ${target?.name || "(unknown)"}`,
			`Media type: ${mediaType}`,
			`Path: ${path || "(unknown)"}`,
			`Current title: ${title || "(none)"}`,
			`Current description: ${description || "(none)"}`,
			`Current transcript available: ${transcript ? "yes" : "no"}`,
			`Current timed transcript (VTT) available: ${transcriptVtt ? "yes" : "no"}`,
			`Current tags: ${tags.length ? tags.join(", ") : "(none)"}`
		];
		if (transcript) {
			const snippet = transcript.length > 2000 ? `${transcript.slice(0, 2000)}\n\n[Transcript truncated.]` : transcript;
			contextParts.push(`Transcript snippet:\n${snippet}`);
		}
		return contextParts.join("\n");
	}

	buildMetadataImageContextHints = (resource = null) => {
		const target = resource || this.state.metadataEditorTarget || this.getSelectedDriveResource();
		const fileName = `${target?.name || ""}`.trim();
		const rawPath = `${this.getMetadataResourcePath(target) || ""}`.trim();
		const pathParts = rawPath
			.split("/")
			.map((part) => part.trim())
			.filter(Boolean)
			.filter((part, index) => {
				if ((part === "public" || part === "private") && index === 0) {
					return false;
				}
				return !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(part);
			});
		const folderParts = fileName
			? pathParts.filter((part) => part.toLowerCase() !== fileName.toLowerCase())
			: pathParts;
		const contextualFolderHints = folderParts.slice(-4);
		const contextParts = [];

		if (fileName) {
			contextParts.push(`File name hint: ${fileName}`);
		}
		if (rawPath) {
			contextParts.push(`Drive path hint: ${rawPath}`);
		}
		if (contextualFolderHints.length > 0) {
			contextParts.push(`Useful folder context: ${contextualFolderHints.join(" | ")}`);
		}

		return contextParts.join("\n");
	}

	cleanGeneratedTagCandidate = (value) => {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/^[-*•]\s+/, "")
			.replace(/^\d+\.\s+/, "")
			.replace(/^tags?\s*:\s*/i, "")
			.replace(/^["'`]+|["'`]+$/g, "")
			.replace(/\s+/g, " ")
			.trim();
		cleaned = cleaned.replace(/[;,.\-:]+$/g, "").trim();
		if (!cleaned || cleaned.length > 80) {
			return "";
		}
		return cleaned;
	}

	parseGeneratedTags = (responseText = "") => {
		if (typeof responseText !== "string" || responseText.trim() === "") {
			return [];
		}
		const tags = [];
		const addTags = (entries = []) => {
			entries.forEach((entry) => {
				const cleaned = this.cleanGeneratedTagCandidate(entry);
				if (cleaned) {
					tags.push(cleaned);
				}
			});
		};
		const normalizedText = responseText
			.replace(/\r\n/g, "\n")
			.replace(/```[a-zA-Z0-9_-]*\n?/g, "")
			.replace(/```/g, "")
			.trim();
		const lines = normalizedText.split("\n").map((line) => line.trim()).filter(Boolean);
		for (let i = 0; i < Math.min(lines.length, 12); i++) {
			const line = lines[i].replace(/^assistant:\s*/i, "").replace(/^tags?\s*:\s*/i, "");
			if (line.indexOf(",") > -1) {
				addTags(line.split(","));
				if (tags.length >= 3) {
					break;
				}
			}
		}
		if (!tags.length && lines.length) {
			addTags(lines[0].split(","));
		}
		return mergeUniqueTags(tags).slice(0, 25);
	}

	extractAwsTranscribeText = (payload) => {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		const directText = payload.text || payload.transcript || payload.output_text || payload.content || payload?.results?.transcripts?.[0]?.transcript || "";
		if (typeof directText === "string" && directText.trim() !== "") {
			return directText.trim();
		}
		return this.extractResponsesText(payload);
	}

	extractAwsTranscribeVtt = (payload) => {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return /-->/m.test(payload) ? payload : "";
		}
		const candidates = [payload.vtt, payload.transcriptVtt, payload.transcript_vtt, payload.output_vtt, payload.outputVtt, payload.text];
		for (let i = 0; i < candidates.length; i++) {
			const candidate = candidates[i];
			if (typeof candidate === "string" && /-->/m.test(candidate)) {
				return candidate;
			}
		}
		return "";
	}

	extractTranscriptFromVtt = (vttValue = "") => {
		const normalized = `${vttValue || ""}`.replace(/\r\n/g, "\n");
		if (!normalized.trim()) {
			return "";
		}
		const lines = normalized
			.split("\n")
			.map((line) => line.trim())
			.filter((line) => line !== "")
			.filter((line) => !/^WEBVTT$/i.test(line))
			.filter((line) => !/^NOTE\b/i.test(line))
			.filter((line) => !/^\d+$/.test(line))
			.filter((line) => !/^\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}\s+-->\s+\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}/.test(line));
		return lines.join(" ").replace(/\s+/g, " ").trim();
	}

	extractTagsFromRekognitionPayload = (payload) => {
		if (!payload) {
			return [];
		}
		if (typeof payload === "string") {
			return mergeUniqueTags(normalizeTags(payload));
		}
		const tags = [];
		const addTag = (value) => {
			const normalized = this.cleanGeneratedTagCandidate(`${value || ""}`);
			if (normalized) {
				tags.push(normalized);
			}
		};
		normalizeTags(payload.tags || []).forEach(addTag);
		normalizeTags(payload.rekognitionTags || []).forEach(addTag);
		normalizeTags(payload.openAiTags || []).forEach(addTag);
		(Array.isArray(payload.labels) ? payload.labels : []).forEach((labelEntry) => {
			if (typeof labelEntry === "string") {
				addTag(labelEntry);
			} else if (labelEntry && typeof labelEntry === "object") {
				addTag(labelEntry.Name || labelEntry.name);
			}
		});
		(Array.isArray(payload.Labels) ? payload.Labels : []).forEach((labelEntry) => {
			if (labelEntry && typeof labelEntry === "object") {
				addTag(labelEntry.Name || labelEntry.name);
			}
		});
		return mergeUniqueTags(tags).slice(0, 25);
	}

	handleGenerateMetadataTitle = async () => {
		const target = this.state.metadataEditorTarget || this.getSelectedDriveResource();
		if (!target) {
			showError("Metadata", "Select a file before generating a title.");
			return;
		}
		this.setState({ metadataGeneratingField: "title" });
		try {
			const prompt = [
				"You are generating metadata for a Drive asset.",
				"Return only a concise title (no label, no quotes, no markdown), max 120 characters.",
				"",
				this.buildMetadataGenerationContext()
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const title = cleanMetadataTitle(responseText);
			if (!title) {
				throw new Error("Generation returned an empty title.");
			}
			this.setState({ metadataEditorTitle: title });
		} catch (err) {
			showError("Generate Title", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	handleGenerateMetadataDescription = async () => {
		const target = this.state.metadataEditorTarget || this.getSelectedDriveResource();
		if (!target) {
			showError("Metadata", "Select a file before generating a description.");
			return;
		}
		this.setState({ metadataGeneratingField: "description" });
		try {
			const mediaType = this.getMetadataResourceMediaType(target);
			let responseText = "";

			if (mediaType === "image") {
				const s3Key = this.getMetadataResourceS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected image.");
				}
				const imageContextHints = this.buildMetadataImageContextHints(target);
				responseText = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: [
						"Describe this specific image in one concise searchable description for asset metadata.",
						"Use the image itself as the primary evidence.",
						"Use file name and Drive path only as secondary context when they provide useful identifiers such as community, model, room, or lot ID.",
						"Do not invent details that are not visible in the image or clearly supported by the path context.",
						"Return only the description, max 600 characters.",
						"",
						imageContextHints
					].filter(Boolean).join("\n")
				}));
			} else {
				const prompt = [
					"You are generating metadata for a Drive asset.",
					"Return only one concise description for search/discovery, max 600 characters.",
					"No markdown, no headings, no source citations.",
					"",
					this.buildMetadataGenerationContext()
				].join("\n");
				responseText = await this.runMetadataResponsesPrompt(prompt);
			}

			const description = cleanMetadataDescription(responseText);
			if (!description) {
				throw new Error("Generation returned an empty description.");
			}
			this.setState({ metadataEditorDescription: description });
		} catch (err) {
			showError("Generate Description", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	handleGenerateMetadataTranscript = async () => {
		const target = this.state.metadataEditorTarget || this.getSelectedDriveResource();
		const { metadataTranscriptProvider } = this.state;
		if (!target) {
			showError("Metadata", "Select a file before generating transcript/content text.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcript" });
		try {
			const mediaType = this.getMetadataResourceMediaType(target);
			const s3Key = this.getMetadataResourceS3Key(target);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				if (mediaType !== "audio" && mediaType !== "video") {
					throw new Error("AWS Transcribe generation is only supported for audio/video files.");
				}
				const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					response_format: "text"
				}), { showAlert: false });
				let transcriptText = cleanMetadataTranscript(this.extractAwsTranscribeText(awsResponse));
				const transcriptVtt = cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
				if (!transcriptText && transcriptVtt) {
					transcriptText = cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
				}
				if (!transcriptText) {
					throw new Error("AWS Transcribe returned empty transcript.");
				}
				this.setState({
					metadataEditorTranscript: transcriptText,
					...(transcriptVtt ? { metadataEditorTranscriptVtt: transcriptVtt } : {})
				});
				return;
			}

			let transcriptText = "";
			if (mediaType === "audio" || mediaType === "video") {
				const response = await getAudioTranscriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: `Transcribe this ${mediaType} into plain text with useful section breaks.`
				}), { showAlert: false });
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "image") {
				const response = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: "Describe this image in plain text for accessibility and search."
				}));
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "pdf") {
				const response = await getPdfResponsesLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					model: "gpt-5.4",
					prompt: "Summarize this selected PDF into clean, practical sections for searchable content metadata."
				}), { showAlert: false });
				transcriptText = this.extractResponsesText(response);
			} else {
				const prompt = [
					"You are generating a long-form content text field for a Drive asset.",
					"For non-audio/video files, produce a concise content representation based on available metadata.",
					"No markdown tables. No source citations.",
					"",
					this.buildMetadataGenerationContext()
				].join("\n");
				transcriptText = await this.runMetadataResponsesPrompt(prompt);
			}

			const cleanedTranscript = cleanMetadataTranscript(transcriptText);
			if (!cleanedTranscript) {
				throw new Error("Generation returned empty transcript/content text.");
			}
			this.setState({ metadataEditorTranscript: cleanedTranscript });
		} catch (err) {
			showError("Generate Transcript", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	handleGenerateMetadataTranscriptVtt = async () => {
		const target = this.state.metadataEditorTarget || this.getSelectedDriveResource();
		const { metadataTranscriptProvider } = this.state;
		if (!target) {
			showError("Generate VTT", "Select a file before generating timed transcript.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcriptVtt" });
		try {
			const mediaType = this.getMetadataResourceMediaType(target);
			if (mediaType !== "audio" && mediaType !== "video") {
				throw new Error("Timed transcript (VTT) is currently only supported for audio/video files.");
			}

			const s3Key = this.getMetadataResourceS3Key(target);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					response_format: "vtt"
				}), { showAlert: false });
				let vttText = cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
				if (!vttText) {
					vttText = cleanMetadataTranscriptVtt(this.extractAwsTranscribeText(awsResponse));
				}
				if (!vttText || !/-->/m.test(vttText)) {
					throw new Error("AWS Transcribe did not return valid VTT timestamp cues.");
				}
				this.setState({ metadataEditorTranscriptVtt: vttText });
				return;
			}

			const response = await getAudioTranscriptionsLambda(JSON.stringify({
				bucket: env.s3.assetsBucket,
				key: s3Key,
				fileName: target.name || "",
				mediaType,
				model: "whisper-1",
				response_format: "vtt"
			}), { showAlert: false });
			const rawVtt = this.extractResponsesText(response);
			if (!/-->/m.test(`${rawVtt || ""}`)) {
				throw new Error("VTT output did not include timestamp cues.");
			}
			const cleanedVtt = cleanMetadataTranscriptVtt(rawVtt);
			if (!cleanedVtt) {
				throw new Error("Generation returned empty VTT content.");
			}
			this.setState({ metadataEditorTranscriptVtt: cleanedVtt });
		} catch (err) {
			showError("Generate VTT", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	handleGenerateMetadataTags = async () => {
		const target = this.state.metadataEditorTarget || this.getSelectedDriveResource();
		const { metadataTagsProvider } = this.state;
		if (!target) {
			showError("Metadata", "Select a file before generating tags.");
			return;
		}

		this.setState({ metadataGeneratingField: "tags" });
		try {
			if (metadataTagsProvider === TAGS_PROVIDER_REKOGNITION) {
				const s3Key = this.getMetadataResourceS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}
				const rekognitionResponse = await getRekognitionTagsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					maxLabels: 25,
					minConfidence: 70
				}), { showAlert: false });
				const generatedTags = this.extractTagsFromRekognitionPayload(rekognitionResponse);
				if (!generatedTags.length) {
					throw new Error("No Rekognition tags generated.");
				}
				this.setState((prev) => ({
					metadataEditorPrimaryTags: mergeUniqueTags([...(prev.metadataEditorPrimaryTags || []), ...generatedTags])
				}));
				return;
			}

			const prompt = [
				"You are generating searchable tags for a Drive asset.",
				"Return only one comma-separated line of tags (no bullets, no explanations).",
				"Use short phrases. Max 15 tags.",
				"",
				this.buildMetadataGenerationContext()
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const generatedTags = this.parseGeneratedTags(responseText);
			if (!generatedTags.length) {
				throw new Error("Generation returned no tags.");
			}
			this.setState((prev) => ({
				metadataEditorPrimaryTags: mergeUniqueTags([...(prev.metadataEditorPrimaryTags || []), ...generatedTags])
			}));
		} catch (err) {
			showError("Generate Tags", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	handleSaveMetadata = async (options = {}) => {
		const closeModal = options.closeModal !== false;
		const showSavedMessage = options.showSuccess !== false;
		const { metadataEditorTarget } = this.state;
		if (!metadataEditorTarget || metadataEditorTarget.type !== "file") {
			showError("Metadata", "Select a file to save metadata.");
			return null;
		}

		const path = metadataEditorTarget.path || metadataEditorTarget.fullPath;
		if (!path) {
			showError("Metadata", "Unable to save metadata because file path is missing.");
			return null;
		}

		const metaData = metadataEditorTarget.metaData && typeof metadataEditorTarget.metaData === "object"
			? _.cloneDeep(metadataEditorTarget.metaData)
			: {};

		metaData.tags = mergeUniqueTags(this.state.metadataEditorPrimaryTags || []);

		const title = cleanMetadataTitle(this.state.metadataEditorTitle);
		const description = cleanMetadataDescription(this.state.metadataEditorDescription);
		const transcript = cleanMetadataTranscript(this.state.metadataEditorTranscript);
		const transcriptVtt = cleanMetadataTranscriptVtt(this.state.metadataEditorTranscriptVtt);

		if (title) { metaData.title = title; } else { delete metaData.title; }
		if (description) { metaData.description = description; } else { delete metaData.description; }
		if (transcript) { metaData.transcript = transcript; } else { delete metaData.transcript; }
		if (transcriptVtt) { metaData.transcriptVtt = transcriptVtt; } else { delete metaData.transcriptVtt; }

		this.setState({ metadataEditorSaving: true });

		try {
			await refreshCredentials();
			await request
				.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId: getOrgId(),
					path: getFullObjectPath(path),
					metaData
				}));

			await listDriveForSelectedFolderSilently();
			setActiveTreeCursorForDriveGuid(metadataEditorTarget.guid);
			await this.loadGalleryFiles();

			const refreshedTarget = getDriveObject(metadataEditorTarget.guid) || {
				...metadataEditorTarget,
				metaData
			};

			if (showSavedMessage) {
				showSuccess("Metadata", "Metadata saved.");
			}

			const nextState = {
				metadataEditorSaving: false,
				metadataGeneratingField: "",
				imageEditorTarget: refreshedTarget,
				selectedDriveResourceGuid: refreshedTarget.guid || ""
			};
			if (closeModal) {
				Object.assign(nextState, {
					showMetadataModal: false,
					metadataGalleryItems: [],
					metadataEditorTarget: null,
					metadataEditorTitle: "",
					metadataEditorDescription: "",
					metadataEditorTranscript: "",
					metadataEditorTranscriptVtt: "",
					metadataEditorSecondaryTags: [],
					metadataEditorTagsInput: "",
					metadataEditorPrimaryTags: [],
					metadataTranscriptProvider: TRANSCRIPT_PROVIDER_OPENAI,
					metadataTagsProvider: TAGS_PROVIDER_OPENAI
				});
			} else {
				Object.assign(nextState, {
					metadataEditorTarget: refreshedTarget
				});
			}
			this.setState(nextState);
			return refreshedTarget;
		} catch (err) {
			console.error(err);
			showError("Metadata", `Failed to save metadata: ${err?.message || err}`);
			this.setState({ metadataEditorSaving: false });
			return null;
		}
	}

	handleShowFolderPicker = () => {
		this.setState({ showFolderPicker: true });
	}

	handleHideFolderPicker = () => {
		this.setState({ showFolderPicker: false });
	}

	handleSelectGalleryFolder = (folder) => {
		if (!folder) {
			this.handleHideFolderPicker();
			return;
		}

		const folderPath = (_.isString(folder.fullPath) && folder.fullPath !== "")
			? folder.fullPath
			: folder.path || "";
		const normalized = normalizeDriveFolderPath(folderPath);

		this.setState({
			showFolderPicker: false,
			galleryFolderPath: normalized.relativePath
		}, () => {
			if (normalized.relativePath) {
				this.loadGalleryFiles(normalized.relativePath);
			}
		});
	}

	loadGalleryFiles = async (folderPathArg = this.state.galleryFolderPath) => {
		const normalized = normalizeDriveFolderPath(folderPathArg);
		if (!normalized.relativePath || !normalized.fullPath) {
			this.setState({
				galleryFolderPath: normalized.relativePath,
				galleryFiles: [],
				galleryError: ""
			});
			return;
		}

		this.setState({
			galleryFolderPath: normalized.relativePath,
			galleryLoading: true,
			galleryError: ""
		});

		try {
			await refreshCredentials();
			const folderFiles = await fetchAllFileObjectsForFolder(normalized.fullPath);
			const galleryFiles = _.sortBy((folderFiles || []).filter(isImageDriveFile), (file) => (file.name || "").toLowerCase());
			this.setState((prevState) => {
				const selectedVisualTarget = this.getSelectedMapperVisualTarget();
				const assignedGuid = getAssignedDriveGuid(selectedVisualTarget);
				const selectedGuidInFolder = galleryFiles.find((file) => file.guid === prevState.selectedDriveResourceGuid)
					? prevState.selectedDriveResourceGuid
					: "";
				const assignedGuidInFolder = galleryFiles.find((file) => file.guid === assignedGuid)
					? assignedGuid
					: "";
				return {
					galleryFiles,
					galleryLoading: false,
					galleryError: "",
					selectedDriveResourceGuid: selectedGuidInFolder || assignedGuidInFolder || prevState.selectedDriveResourceGuid || ""
				};
			});
		} catch (error) {
			console.error(error);
			this.setState({
				galleryFiles: [],
				galleryLoading: false,
				galleryError: _.get(error, "message", String(error))
			});
		}
	}

	getSelectedPickerOptions() {
		const { parsedContent, selectedPickerId } = this.state;
		if (!parsedContent || !selectedPickerId) {
			return [];
		}

		return getPickerOptions(parsedContent, selectedPickerId);
	}

	getSelectedOption() {
		const { selectedOptionIdentity } = this.state;
		return this.getSelectedPickerOptions().find((option) => option.__optionIdentity === selectedOptionIdentity) || null;
	}

	getSelectedGenericCandidate() {
		const { genericMapperCandidates, selectedGenericPath } = this.state;
		return _.find(genericMapperCandidates, (candidate) => candidate.path === selectedGenericPath) || null;
	}

	getSelectedGenericRows() {
		const { parsedContent, selectedGenericPath } = this.state;
		if (!parsedContent || !selectedGenericPath) {
			return [];
		}
		return getGenericDatasourceRows(parsedContent, selectedGenericPath).rows;
	}

	getSelectedGenericRow() {
		const { selectedGenericRowIdentity } = this.state;
		return this.getSelectedGenericRows().find((row) => row.__rowIdentity === selectedGenericRowIdentity) || null;
	}

	getSelectedMapperVisualTarget() {
		return this.state.mapperMode === "generic" ? this.getSelectedGenericRow() : this.getSelectedOption();
	}

	getSelectedDriveResource() {
		const { selectedDriveResourceGuid, galleryFiles } = this.state;
		if (selectedDriveResourceGuid) {
			const galleryMatch = galleryFiles.find((file) => file.guid === selectedDriveResourceGuid) || null;
			const canonicalDriveObject = getDriveObject(selectedDriveResourceGuid) || null;
			if (canonicalDriveObject && galleryMatch) {
				return {
					...galleryMatch,
					...canonicalDriveObject
				};
			}
			return canonicalDriveObject || galleryMatch || null;
		}

		return getCurrentDriveResource(this.getSelectedMapperVisualTarget());
	}

	handleShowRenameModal = () => {
		const resource = this.getSelectedDriveResource();
		if (!resource || resource.type !== "file") {
			showError("Rename File", "Select a Drive file before renaming.");
			return;
		}

		this.setState({
			showRenameModal: true,
			renameTarget: resource,
			renameFileName: resource.name || "",
			renameSaving: false
		});
	}

	handleHideRenameModal = () => {
		this.setState({
			showRenameModal: false,
			renameTarget: null,
			renameFileName: "",
			renameSaving: false
		});
	}

	handleRenameFileNameChange = (event) => {
		this.setState({
			renameFileName: event?.target?.value || ""
		});
	}

	handleSaveRename = async () => {
		const { renameTarget, renameFileName } = this.state;
		const selectedOption = this.getSelectedOption();
		const assignedGuid = getAssignedDriveGuid(selectedOption);
		const nextFileName = `${renameFileName || ""}`.trim();

		if (!renameTarget || renameTarget.type !== "file") {
			showError("Rename File", "Select a Drive file before renaming.");
			return;
		}
		if (!nextFileName) {
			showError("Rename File", "File name cannot be empty.");
			return;
		}
		if (!_.isArray(renameTarget._path) || renameTarget._path.length === 0) {
			showError("Rename File", "Unable to determine the current Drive path for this file.");
			return;
		}

		const destinationPath = [..._.dropRight(renameTarget._path), nextFileName].join("/");
		this.setState({ renameSaving: true });

		try {
			const movedCursor = await moveFile(renameTarget.guid, destinationPath);
			await this.loadGalleryFiles();

			const refreshedTarget = getDriveObject(renameTarget.guid) || movedCursor || getDriveObject(renameTarget.guid) || null;
			if (refreshedTarget && assignedGuid && assignedGuid === refreshedTarget.guid) {
				this.handleAssignImage(refreshedTarget);
			}

			this.setState({
				showRenameModal: false,
				renameTarget: null,
				renameFileName: "",
				renameSaving: false,
				selectedDriveResourceGuid: _.get(refreshedTarget, "guid", renameTarget.guid || "")
			});
		} catch (err) {
			console.error(err);
			showError("Rename File", `Failed to rename file: ${err?.message || err}`);
			this.setState({ renameSaving: false });
		}
	}

	getFilteredOptions() {
		const { optionFilter, showUnmatchedOnly } = this.state;
		const normalizedFilter = _.trim((optionFilter || "").toLowerCase());

		return this.getSelectedPickerOptions().filter((option) => {
			if (showUnmatchedOnly && hasVisualAssignment(option)) {
				return false;
			}

			if (!normalizedFilter) {
				return true;
			}

			const haystack = `${getOptionDisplayLabel(option)} ${_.get(option, "value", "")}`.toLowerCase();
			return haystack.includes(normalizedFilter);
		});
	}

	getFilteredGenericRows() {
		const { optionFilter, showUnmatchedOnly } = this.state;
		const normalizedFilter = _.trim((optionFilter || "").toLowerCase());
		const candidate = this.getSelectedGenericCandidate();

		return this.getSelectedGenericRows().filter((row) => {
			if (showUnmatchedOnly && hasVisualAssignment(row)) {
				return false;
			}

			if (!normalizedFilter) {
				return true;
			}

			const haystack = `${getGenericRowDisplayLabel(row, candidate)} ${getGenericRowValueLabel(row, candidate)} ${_.get(row, "__mapKey", "")}`.toLowerCase();
			return haystack.includes(normalizedFilter);
		});
	}

	renderCustomFieldEditorRows = (fields, scope = "option") => {
		if (!fields.length) {
			return <div style={{ color: "#5f6f82", fontStyle: "italic" }}>No custom fields yet.</div>;
		}

		return fields.map(({ key, value }) => {
			const type = inferCustomFieldType(value);
			const isJson = type === CUSTOM_FIELD_TYPE_JSON;
			const serializedValue = serializeCustomFieldValue(value, type);
			const keyDrafts = scope === "family" ? this.state.familyCustomFieldDraftKeys : this.state.optionCustomFieldDraftKeys;
			const keyInputValue = _.has(keyDrafts, key) ? keyDrafts[key] : key;
			const formattedKeyPreview = buildAutoCustomFieldKey(keyInputValue, this.state.optionValueAutoFormat);
			const showFormattedKeyPreview = !!keyInputValue && formattedKeyPreview !== keyInputValue;
			return (
				<div
					key={`${scope}-${key}`}
					style={{ display: "grid", gridTemplateColumns: "1.1fr 120px 1.6fr 40px", gap: "8px", alignItems: "start", marginBottom: "8px" }}
				>
					<div>
						<FormControl
							key={`${scope}-key-${key}`}
							type="text"
							value={keyInputValue}
							onChange={(event) => {
								if (scope === "family") {
									this.handleFamilyCustomFieldDraftChange(key, event);
								} else {
									this.handleOptionCustomFieldDraftChange(key, event);
								}
							}}
							onBlur={(event) => {
								if (scope === "family") {
									this.handleFamilyCustomFieldKeyBlur(key, event);
								} else {
									this.handleOptionCustomFieldKeyBlur(key, event);
								}
							}}
						/>
						{showFormattedKeyPreview && (
							<div style={{ marginTop: "4px", fontSize: "11px", color: "#7b8794" }}>
								Saves as <code>{formattedKeyPreview}</code>
							</div>
						)}
					</div>
					<FormControl
						componentClass="select"
						value={type}
						onChange={(event) => {
							const nextType = _.get(event, "target.value", CUSTOM_FIELD_TYPE_STRING);
							const rawValue = nextType === CUSTOM_FIELD_TYPE_JSON
								? serializeCustomFieldValue(value, CUSTOM_FIELD_TYPE_JSON)
								: serializeCustomFieldValue(value, nextType);
							if (scope === "family") {
								this.handleFamilyCustomFieldValueChange(key, nextType, rawValue);
							} else {
								this.handleOptionCustomFieldValueChange(key, nextType, rawValue);
							}
						}}
					>
						{CUSTOM_FIELD_TYPES.map((fieldType) => (
							<option key={fieldType} value={fieldType}>{fieldType}</option>
						))}
					</FormControl>
					<FormControl
						key={`${scope}-value-${key}-${type}`}
						componentClass={isJson ? "textarea" : "input"}
						type={isJson ? undefined : "text"}
						defaultValue={serializedValue}
						style={isJson ? { minHeight: "84px", fontFamily: "monospace" } : undefined}
						onBlur={(event) => {
							if (scope === "family") {
								this.handleFamilyCustomFieldValueChange(key, type, _.get(event, "target.value", ""));
							} else {
								this.handleOptionCustomFieldValueChange(key, type, _.get(event, "target.value", ""));
							}
						}}
					/>
					<Button
						bsSize="small"
						onClick={() => {
							if (scope === "family") {
								this.handleDeleteFamilyCustomField(key);
							} else {
								this.handleDeleteOptionCustomField(key);
							}
						}}
					>
						<FontAwesomeIcon icon="trash" />
					</Button>
				</div>
			);
		});
	}

	renderValidationPanel = (issues, selectedPickerId, selectedOptionIdentity) => {
		const scopedIssues = issues.filter((issue) => {
			if (!selectedPickerId) {
				return true;
			}
			if (issue.pickerId !== selectedPickerId) {
				return false;
			}
			if (!selectedOptionIdentity) {
				return true;
			}
			if (!issue.optionIdentity) {
				return true;
			}
			return issue.optionIdentity === selectedOptionIdentity;
		});
		const counts = _.countBy(issues, "severity");

		return (
			<div style={{ marginTop: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd" }}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
					<div style={{ fontWeight: 600 }}>Validation</div>
					<Button bsSize="small" onClick={() => this.setState({ showValidationPanel: !this.state.showValidationPanel })}>
						<FontAwesomeIcon icon={this.state.showValidationPanel ? "chevron-up" : "chevron-down"} /> {this.state.showValidationPanel ? "Hide" : "Show"}
					</Button>
				</div>
				<div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: this.state.showValidationPanel ? "10px" : 0 }}>
					<div style={{ fontSize: "12px", color: "#5f6f82" }}><b>{issues.length}</b> total</div>
					<div style={{ fontSize: "12px", color: "#8a1f11" }}><b>{counts.error || 0}</b> errors</div>
					<div style={{ fontSize: "12px", color: "#9a6700" }}><b>{counts.warning || 0}</b> warnings</div>
					<div style={{ fontSize: "12px", color: "#5f6f82" }}><b>{counts.info || 0}</b> info</div>
				</div>
				{this.state.showValidationPanel && (
					scopedIssues.length > 0 ? (
						<div style={{ maxHeight: "220px", overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
							{scopedIssues.map((issue, index) => {
								const color = issue.severity === "error" ? "#8a1f11" : issue.severity === "warning" ? "#9a6700" : "#5f6f82";
								return (
									<div
										key={`${issue.scope}-${issue.pickerId || "global"}-${issue.optionIdentity || index}-${index}`}
										style={{ padding: "8px 0", borderTop: index === 0 ? "none" : "1px solid #edf1f5" }}
									>
										<div style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color, marginBottom: "3px" }}>{issue.severity}</div>
										<div style={{ fontSize: "12px", color: "#253858" }}>{issue.message}</div>
									</div>
								);
							})}
						</div>
					) : (
						<div style={{ color: "#3c763d", fontSize: "12px" }}>No validation issues for the current selection.</div>
					)
				)}
			</div>
		);
	}

	renderAuthoringEntityCreator(selectedCandidate) {
		const { showAddGenericEntity, newGenericEntityDraft, newGenericEntityError } = this.state;
		if (!selectedCandidate || selectedCandidate.visualStorage !== AUTHORING_VISUAL_STORAGE_MODE) {
			return null;
		}
		const fieldConfigs = getAuthoringEntityFieldConfigs(selectedCandidate);
		if (_.isEmpty(fieldConfigs)) {
			return null;
		}

		return (
			<div style={{ marginBottom: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #d7dee7", background: "#fafbfd" }}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", marginBottom: showAddGenericEntity ? "10px" : 0 }}>
					<div style={{ fontWeight: 600 }}>Authoring</div>
					{showAddGenericEntity ? (
						<div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
							<Button bsStyle="primary" bsSize="small" onClick={this.handleAddGenericEntity}>
								<FontAwesomeIcon icon="plus" /> Create Entity
							</Button>
							<Button bsSize="small" onClick={this.handleHideAddGenericEntity}>
								<FontAwesomeIcon icon="times" /> Cancel
							</Button>
						</div>
					) : (
						<Button bsStyle="primary" bsSize="small" onClick={this.handleShowAddGenericEntity}>
							<FontAwesomeIcon icon="plus" /> Add Entity
						</Button>
					)}
				</div>
					{showAddGenericEntity ? (
						<>
							<div style={{ fontSize: "12px", color: "#5f6f82", marginBottom: "10px" }}>
								{selectedCandidate.path === "collections.selectionOptionsById"
									? "Create the reusable option here. Use Selection Group IDs to seed one or more parent groups, or link this option into additional groups later from the parent group panel."
									: "Create the core entity here. Use Raw JSON for advanced fields or relationship cleanup."}
							</div>
							<div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "10px" }}>
								{fieldConfigs.map((field) => (
									<div key={`new-entity-field-${field.key}`}>
									<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px", color: "#5f6f82" }}>
										{field.label}{field.required ? " *" : ""}
									</div>
										{field.type === "boolean" ? (
											<label style={{ display: "flex", alignItems: "center", gap: "6px", minHeight: "34px", marginBottom: 0 }}>
												<input
													type="checkbox"
													checked={!!newGenericEntityDraft[field.key]}
													onChange={(e) => this.handleGenericEntityDraftFieldChange(field.key, e.target.checked)}
												/>
												<span>{field.label}</span>
											</label>
										) : field.type === "multiValue" ? (
											<FormControl
												componentClass="textarea"
												value={_.get(newGenericEntityDraft, field.key, "")}
												placeholder={field.placeholder || ""}
												style={{ minHeight: "58px" }}
												onChange={(e) => this.handleGenericEntityDraftFieldChange(field.key, e.target.value)}
											/>
										) : (
											<FormControl
												type="text"
												value={_.get(newGenericEntityDraft, field.key, "")}
											placeholder={field.placeholder || ""}
											onChange={(e) => this.handleGenericEntityDraftFieldChange(field.key, e.target.value)}
										/>
									)}
								</div>
							))}
						</div>
						{newGenericEntityError && (
							<div style={{ marginTop: "10px", color: "#8a1f11", fontSize: "12px" }}>
								{newGenericEntityError}
							</div>
						)}
					</>
				) : (
					<div style={{ fontSize: "12px", color: "#5f6f82" }}>
						Collections stay empty until you create canonical entities.
					</div>
				)}
			</div>
		);
	}

	renderAuthoringCollectionCreator() {
		const { parsedContent } = this.state;
		const availableCollections = getAvailableAuthoringCollectionCandidates(parsedContent);
		if (_.isEmpty(availableCollections)) {
			return null;
		}

		return (
			<div style={{ marginBottom: "12px", padding: "10px 12px", borderRadius: "8px", border: "1px solid #d7dee7", background: "#fafbfd" }}>
				<div style={{ fontWeight: 600, marginBottom: "6px" }}>Add Collection</div>
				<div style={{ fontSize: "12px", color: "#5f6f82", marginBottom: "10px" }}>
					Start blank and add only the canonical collections you need for this datasource.
				</div>
				<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
					{availableCollections.map((candidate) => (
						<Button
							key={`add-collection-${candidate.path}`}
							bsSize="small"
							onClick={() => this.handleAddAuthoringCollection(candidate.path)}
							style={{ textAlign: "left" }}
						>
							<FontAwesomeIcon icon="plus" /> {candidate.displayLabel}
						</Button>
					))}
				</div>
			</div>
		);
	}

	renderAuthoringRelatedEntities(selectedCandidate, selectedRow) {
		const relatedGroups = getAuthoringRelatedEntityGroups(this.state.parsedContent, selectedCandidate, selectedRow);
		if (_.isEmpty(relatedGroups)) {
			return null;
		}

		return (
			<div style={{ marginBottom: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd" }}>
				<div style={{ fontWeight: 600, marginBottom: "8px" }}>Related Entities</div>
				{relatedGroups.map((group) => (
					<div key={`related-entities-${group.title}-${group.path}`} style={{ marginBottom: "12px" }}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", marginBottom: "4px" }}>
							<div style={{ fontSize: "12px", fontWeight: 700, color: "#253858" }}>{group.title}</div>
							{group.addAction && (
								<Button
									bsSize="xsmall"
									bsStyle="primary"
									onClick={() => this.handleShowAddRelatedEntity(group.addAction.targetPath, group.addAction.draftOverrides)}
								>
									<FontAwesomeIcon icon="plus" /> {group.addAction.label}
								</Button>
							)}
						</div>
							{group.description && (
								<div style={{ fontSize: "12px", color: "#5f6f82", marginBottom: "8px" }}>{group.description}</div>
							)}
							{group.linkAction && _.isArray(group.linkAction.options) && group.linkAction.options.length > 0 && (
								<div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "8px" }}>
									<FormControl
										componentClass="select"
										value={_.get(this.state.relatedEntityLinkSelections, group.linkAction.parentId, "")}
										onChange={(e) => this.handleRelatedEntityLinkSelectionChange(group.linkAction.parentId, _.get(e, "target.value", ""))}
									>
										<option value="">Select existing option...</option>
										{group.linkAction.options.map((option) => (
											<option key={`link-option-${group.linkAction.parentId}-${option.id}`} value={option.id}>
												{option.label}{option.description ? ` (${option.description})` : ""}
											</option>
										))}
									</FormControl>
									<Button
										bsSize="xsmall"
										onClick={() => this.handleLinkExistingSelectionOptionToGroup(group.linkAction.parentId, _.get(this.state.relatedEntityLinkSelections, group.linkAction.parentId, ""))}
										disabled={!_.get(this.state.relatedEntityLinkSelections, group.linkAction.parentId, "")}
									>
										<FontAwesomeIcon icon="link" /> {group.linkAction.label}
									</Button>
								</div>
							)}
								{group.rows.length > 0 ? (
									<div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
										{group.rows.map((row) => {
											const rowLabel = getGenericRowDisplayLabel(row);
											return (
												<div
													key={`related-row-${group.path}-${row.__rowIdentity}`}
													style={{
														position: "relative",
														display: "inline-flex",
														alignItems: "stretch",
														minHeight: "34px",
														borderRadius: "999px",
														border: "1px solid #d7dee7",
														background: "#ffffff",
														boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)"
													}}
												>
													<button
														type="button"
														onClick={() => this.handleJumpToGenericRow(group.path, row.__rowIdentity)}
														style={{
															border: "none",
															background: "transparent",
															padding: group.unlinkAction ? "7px 34px 7px 12px" : "7px 12px",
															fontSize: "12px",
															fontWeight: 600,
															color: "#253858",
															cursor: "pointer",
															borderRadius: "999px",
															lineHeight: 1.2
														}}
														title={`Open ${rowLabel}`}
													>
														{rowLabel}
													</button>
													{group.unlinkAction && (
														<button
															type="button"
															onClick={(event) => {
																event.preventDefault();
																event.stopPropagation();
																this.handleUnlinkSelectionOptionFromGroup(
																	group.unlinkAction.fixedGroupId || row.__rowId,
																	group.unlinkAction.fixedOptionId || row.__rowId,
																	group.unlinkAction.keepSelection || {}
																);
															}}
															aria-label={`${group.unlinkAction.label} ${rowLabel}`}
															title={`${group.unlinkAction.label} ${rowLabel}`}
															style={{
																position: "absolute",
																top: "4px",
																right: "4px",
																width: "20px",
																height: "20px",
																borderRadius: "999px",
																border: "none",
																background: "#f5f7fa",
																color: "#5f6f82",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																cursor: "pointer",
																padding: 0
															}}
														>
															<FontAwesomeIcon icon="times" />
														</button>
													)}
												</div>
											);
										})}
									</div>
								) : (
								<div style={{ fontSize: "12px", color: "#7b8794", fontStyle: "italic" }}>
									{group.linkAction && _.isArray(group.linkAction.options) && group.linkAction.options.length > 0
										? "No linked entities yet. You can create a new one or link an existing one."
										: "No linked entities yet."}
								</div>
							)}
						</div>
					))}
				</div>
		);
	}

	renderPickerList() {
		const { parsedContent, selectedPickerId, showAddFamily, newFamilyId, newFamilyLabel, newFamilyStorageMode } = this.state;
		const pickerIds = getPickerIds(parsedContent);
		const pickerItems = pickerIds.map((pickerId) => ({
			id: pickerId,
			label: getPickerLabel(parsedContent, pickerId),
			summary: getPickerSummary(parsedContent, pickerId),
			storageMode: getPickerStorageMode(parsedContent, pickerId)
		}));

		return (
			<div style={{
				width: "24%",
				minWidth: "240px",
				borderRight: "1px solid #e3e8ef",
				paddingRight: "12px",
				height: "100%",
				minHeight: 0,
				display: "flex",
				flexDirection: "column"
			}}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", marginBottom: "10px" }}>
					<div style={{ fontWeight: 700 }}>Picker Families</div>
					<div style={{ display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "flex-end" }}>
						<Button bsSize="small" onClick={showAddFamily ? this.handleHideAddFamily : this.handleShowAddFamily}>
							<FontAwesomeIcon icon={showAddFamily ? "times" : "plus"} /> {showAddFamily ? "Cancel" : "Add"}
						</Button>
						<Button bsSize="small" onClick={() => this.handleDuplicateFamily(selectedPickerId)} disabled={!selectedPickerId}>
							<FontAwesomeIcon icon="clone" /> Duplicate
						</Button>
						<Button bsSize="small" onClick={() => this.handleDeleteFamily(selectedPickerId)} disabled={!selectedPickerId}>
							<FontAwesomeIcon icon="trash" /> Delete
						</Button>
					</div>
				</div>
				{showAddFamily && (
					<div style={{ marginBottom: "10px", padding: "10px", border: "1px solid #d7dee7", borderRadius: "8px", background: "#fafbfd" }}>
						<FormGroup style={{ marginBottom: "8px" }}>
							<ControlLabel style={{ fontSize: "12px", marginBottom: "4px" }}>Picker ID</ControlLabel>
							<FormControl type="text" value={newFamilyId} onChange={(e) => this.setState({ newFamilyId: e.target.value })} />
						</FormGroup>
						<FormGroup style={{ marginBottom: "8px" }}>
							<ControlLabel style={{ fontSize: "12px", marginBottom: "4px" }}>Label</ControlLabel>
							<FormControl type="text" value={newFamilyLabel} onChange={(e) => this.setState({ newFamilyLabel: e.target.value })} />
						</FormGroup>
						<FormGroup style={{ marginBottom: "8px" }}>
							<ControlLabel style={{ fontSize: "12px", marginBottom: "4px" }}>Storage Mode</ControlLabel>
							<FormControl componentClass="select" value={newFamilyStorageMode} onChange={(e) => this.setState({ newFamilyStorageMode: e.target.value })}>
								<option value={PICKER_STORAGE_MODE_BOTH}>Both</option>
								<option value={PICKER_STORAGE_MODE_ARRAY}>Array</option>
								<option value={PICKER_STORAGE_MODE_MAP}>Map</option>
							</FormControl>
						</FormGroup>
						<Button bsStyle="primary" bsSize="small" onClick={this.handleAddFamily}>
							<FontAwesomeIcon icon="plus" /> Create Family
						</Button>
					</div>
				)}
				<SortablePickerFamilyList
					items={pickerItems}
					selectedPickerId={selectedPickerId}
					onSelect={this.handleSelectPicker}
					onDelete={this.handleDeleteFamily}
					onSortEnd={this.handleSortFamilies}
					lockAxis="y"
					useDragHandle
					helperClass="sortable-helper"
				/>
			</div>
		);
	}

	renderOptionList() {
		const filteredOptions = this.getFilteredOptions();
		const { optionFilter, showUnmatchedOnly, selectedOptionIdentity, imageFitMode } = this.state;
		const selectedOption = this.getSelectedOption();
		const selectedImageUrl = getCurrentImageUrl(selectedOption);
		const selectedSwatchColor = getCurrentSwatchColor(selectedOption);

		return (
			<div style={{
				width: "32%",
				minWidth: "280px",
				borderRight: "1px solid #e3e8ef",
				padding: "0 12px",
				height: "100%",
				minHeight: 0,
				display: "flex",
				flexDirection: "column"
			}}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px", gap: "10px" }}>
					<div style={{ fontWeight: 700 }}>Options</div>
					<div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap", justifyContent: "flex-end" }}>
						<Button onClick={this.handleAddOption} bsSize="small">
							<FontAwesomeIcon icon="plus" /> Add Option
						</Button>
						<Button onClick={() => this.handleDuplicateOption()} disabled={!selectedOption} bsSize="small">
							<FontAwesomeIcon icon="clone" /> Duplicate
						</Button>
						<Button onClick={() => this.handleDeleteOption()} disabled={!selectedOption} bsSize="small">
							<FontAwesomeIcon icon="trash" /> Delete
						</Button>
						<Button onClick={this.handleClearImage} disabled={!selectedImageUrl} bsSize="small">
							<FontAwesomeIcon icon="ban" /> Clear Image
						</Button>
						<Button onClick={this.handleClearSwatch} disabled={!selectedSwatchColor} bsSize="small">
							<FontAwesomeIcon icon="ban" /> Clear Swatch
						</Button>
						<label style={{ fontSize: "12px", fontWeight: 400, marginBottom: 0, display: "flex", alignItems: "center", gap: "6px" }}>
							<input
								type="checkbox"
								checked={showUnmatchedOnly}
								onChange={(e) => this.setState({ showUnmatchedOnly: e.target.checked })}
							/>
							Unmatched only
						</label>
					</div>
				</div>
				<FormControl
					type="text"
					value={optionFilter}
					placeholder="Filter options..."
					onChange={(e) => this.setState({ optionFilter: e.target.value })}
					style={{ marginBottom: "10px" }}
				/>
				{filteredOptions.length > 0 ? (
					<SortablePickerOptionList
						items={filteredOptions}
						selectedOptionIdentity={selectedOptionIdentity}
						imageFitMode={imageFitMode}
						onSelect={this.handleSelectOption}
						onDelete={this.handleDeleteOption}
						onSortEnd={this.handleSortOptions}
						lockAxis="y"
						useDragHandle
						helperClass="sortable-helper"
					/>
				) : (
					<div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
						<div style={{ color: "#5f6f82", fontStyle: "italic", padding: "10px 0" }}>No options match the current filter.</div>
					</div>
				)}
			</div>
		);
	}

	renderGenericPathList() {
		const { parsedContent, genericMapperCandidates, selectedGenericPath } = this.state;
		const isAuthoringDatasource = isCanonicalAuthoringDatasourceDocument(parsedContent);
		const compileTargets = _.isPlainObject(_.get(parsedContent, "compileTargets")) ? _.values(parsedContent.compileTargets) : [];

		return (
			<div style={{
				width: "24%",
				minWidth: "240px",
				borderRight: "1px solid #e3e8ef",
				paddingRight: "12px",
				height: "100%",
				minHeight: 0,
				display: "flex",
				flexDirection: "column"
			}}>
				<div style={{ marginBottom: "10px" }}>
					<div style={{ fontWeight: 700, marginBottom: "4px" }}>Datasource Collections</div>
					<div style={{ fontSize: "12px", color: "#5f6f82" }}>
						{isAuthoringDatasource
							? "Choose a canonical collection to attach visuals directly to stable entities. Compiled picker and community outputs are generated from this authoring file."
							: "Choose a collection path to map visual fields inline. The source rows stay generated; visuals are stored in an overlay section."}
					</div>
				</div>
				{isAuthoringDatasource && compileTargets.length > 0 && (
					<div style={{ marginBottom: "12px", padding: "10px 12px", borderRadius: "8px", border: "1px solid #d7dee7", background: "#fafbfd" }}>
						<div style={{ fontWeight: 600, marginBottom: "6px" }}>Compile Targets</div>
						{compileTargets.map((target) => (
							<div key={target.id || target.outputPath} style={{ fontSize: "12px", color: "#5f6f82", marginBottom: "4px" }}>
								<b>{target.id || target.kind}</b>: <code>{target.outputPath || "(unset)"}</code>
							</div>
						))}
					</div>
				)}
				{isAuthoringDatasource && this.renderAuthoringCollectionCreator()}
				<div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
					{genericMapperCandidates.length > 0 ? genericMapperCandidates.map((candidate) => {
						const summary = getGenericCandidateSummary(parsedContent, candidate.path);
						const active = candidate.path === selectedGenericPath;
						const isEmptyCollection = summary.total === 0;
						return (
							<button
								key={`generic-path-${candidate.path || "root"}`}
								type="button"
								onClick={() => this.handleSelectGenericPath(candidate.path)}
								style={{
									width: "100%",
									padding: "10px 12px",
									borderRadius: "8px",
									border: active ? "1px solid #3b82f6" : "1px solid #d7dee7",
									background: active ? "#eef5ff" : "#ffffff",
									marginBottom: "8px",
									color: "#253858",
									textAlign: "left"
								}}
							>
								<div style={{ fontWeight: 600 }}>{getDatasourcePathCandidateDisplay(candidate)}</div>
								{candidate.description && (
									<div style={{ fontSize: "12px", color: "#5f6f82", marginTop: "6px" }}>{candidate.description}</div>
								)}
								<div style={{ fontSize: "12px", color: isEmptyCollection ? "#7b8794" : summary.unmatched > 0 ? "#9a6700" : "#3c763d", marginTop: "6px" }}>
									{isEmptyCollection ? "Empty collection" : `${summary.matched}/${summary.total} mapped`}
								</div>
								<div style={{ fontSize: "11px", color: "#7b8794", marginTop: "4px" }}>
									{candidate.visualStorage === AUTHORING_VISUAL_STORAGE_MODE ? "Entity key" : "Row key"}: <code>{candidate.rowIdKey}</code>
								</div>
							</button>
						);
					}) : (
						<div style={{ color: "#5f6f82", fontStyle: "italic", padding: "10px 0" }}>
							{isAuthoringDatasource
								? "No collections have been added yet."
								: "No generic row collections with stable ids were detected in this JSON file."}
						</div>
					)}
				</div>
			</div>
		);
	}

	renderGenericRowList() {
		const filteredRows = this.getFilteredGenericRows();
		const allRows = this.getSelectedGenericRows();
		const { optionFilter, showUnmatchedOnly, selectedGenericRowIdentity } = this.state;
		const selectedRow = this.getSelectedGenericRow();
		const selectedImageUrl = getCurrentImageUrl(selectedRow);
		const selectedSwatchColor = getCurrentSwatchColor(selectedRow);
		const selectedCandidate = this.getSelectedGenericCandidate();
		const entityLabel = selectedCandidate?.visualStorage === AUTHORING_VISUAL_STORAGE_MODE ? "Entities" : "Rows";

		return (
			<div style={{
				width: "32%",
				minWidth: "280px",
				borderRight: "1px solid #e3e8ef",
				padding: "0 12px",
				height: "100%",
				minHeight: 0,
				display: "flex",
				flexDirection: "column"
			}}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px", gap: "10px" }}>
					<div>
						<div style={{ fontWeight: 700 }}>{entityLabel}</div>
						<div style={{ fontSize: "12px", color: "#5f6f82", marginTop: "4px" }}>
							{selectedCandidate ? `${selectedCandidate.rowCount} ${selectedCandidate.visualStorage === AUTHORING_VISUAL_STORAGE_MODE ? "entities" : "rows"}` : "Select a collection"}
						</div>
					</div>
					<div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap", justifyContent: "flex-end" }}>
						<Button onClick={this.handleClearImage} disabled={!selectedImageUrl} bsSize="small">
							<FontAwesomeIcon icon="ban" /> Clear Image
						</Button>
						<Button onClick={this.handleClearSwatch} disabled={!selectedSwatchColor} bsSize="small">
							<FontAwesomeIcon icon="ban" /> Clear Swatch
						</Button>
						<label style={{ fontSize: "12px", fontWeight: 400, marginBottom: 0, display: "flex", alignItems: "center", gap: "6px" }}>
							<input
								type="checkbox"
								checked={showUnmatchedOnly}
								onChange={(e) => this.setState({ showUnmatchedOnly: e.target.checked })}
							/>
							Unmatched only
						</label>
					</div>
				</div>
				{this.renderAuthoringEntityCreator(selectedCandidate)}
				<FormControl
					type="text"
					value={optionFilter}
					placeholder="Filter rows..."
					onChange={(e) => this.setState({ optionFilter: e.target.value })}
					style={{ marginBottom: "10px" }}
				/>
				<div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
					{filteredRows.length > 0 ? filteredRows.map((row) => {
						const active = row.__rowIdentity === selectedGenericRowIdentity;
						const displayLabel = getGenericRowDisplayLabel(row, selectedCandidate);
						const valueLabel = getGenericRowValueLabel(row, selectedCandidate);
						return (
							<button
								key={row.__rowIdentity}
								type="button"
								onClick={() => this.handleSelectGenericRow(row.__rowIdentity)}
								style={{
									width: "100%",
									padding: "10px 12px",
									borderRadius: "8px",
									border: active ? "1px solid #3b82f6" : "1px solid #d7dee7",
									background: active ? "#eef5ff" : "#ffffff",
									marginBottom: "8px",
									color: "#253858",
									textAlign: "left"
								}}
							>
								<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
									{getCurrentImageUrl(row) ? (
										<div style={{ width: "42px", height: "42px", borderRadius: "8px", overflow: "hidden", border: "1px solid #d7dee7", background: "#fff", flex: "0 0 42px" }}>
											<img src={getCurrentImageUrl(row)} alt={displayLabel} style={{ width: "100%", height: "100%", objectFit: this.state.imageFitMode }} />
										</div>
									) : (
										<div style={{
											width: "42px",
											height: "42px",
											borderRadius: "8px",
											border: "1px solid #d7dee7",
											background: getCurrentSwatchColor(row) || "#f5f7fa",
											color: getCurrentSwatchColor(row) ? "transparent" : "#7b8794",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											flex: "0 0 42px"
										}}>
											{getCurrentSwatchColor(row) ? "." : <FontAwesomeIcon icon="image" />}
										</div>
									)}
									<div style={{ minWidth: 0, flex: 1 }}>
										<div style={{ fontWeight: 600, color: "#253858", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{displayLabel}</div>
										<div style={{ fontSize: "12px", color: "#5f6f82", marginTop: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
											{valueLabel || row.__rowIdentity}
										</div>
										{row.__mapKey && (
											<div style={{ fontSize: "11px", color: "#7b8794", marginTop: "4px" }}>
												Group: <code>{row.__mapKey}</code>
											</div>
										)}
										<div style={{ fontSize: "11px", color: getVisualAssignmentColor(row), marginTop: "6px" }}>
											{getVisualAssignmentLabel(row)}
										</div>
									</div>
								</div>
							</button>
						);
						}) : (
							<div style={{ color: "#5f6f82", fontStyle: "italic", padding: "10px 0" }}>
								{selectedCandidate && allRows.length === 0 && !optionFilter && !showUnmatchedOnly
									? selectedCandidate.visualStorage === AUTHORING_VISUAL_STORAGE_MODE
										? "No entities exist in this collection yet."
										: "No rows exist in this collection yet."
									: "No rows match the current filter."}
							</div>
						)}
				</div>
			</div>
		);
	}

	renderGenericSelectedRowPanel() {
		const selectedRow = this.getSelectedGenericRow();
		const selectedCandidate = this.getSelectedGenericCandidate();
		const isSelectionGroupEntity = selectedCandidate?.path === "collections.selectionGroupsById";
		const selectedImageUrl = getCurrentImageUrl(selectedRow);
		const selectedSwatchColor = getCurrentSwatchColor(selectedRow);
		const currentDriveResource = getCurrentDriveResource(selectedRow);
		const selectedDriveResource = this.getSelectedDriveResource();
		const selectedDriveResourceIsAssigned = !!(
			selectedDriveResource &&
			currentDriveResource &&
			selectedDriveResource.guid === currentDriveResource.guid
		);
		const {
			assignMode,
			galleryFolderPath,
			galleryFiles,
			galleryLoading,
			galleryError,
			imageFitMode,
			selectedOptionDetailsCollapsed,
			optionVisualMode,
			swatchInputValue,
			swatchPickerValue
		} = this.state;

		if (!selectedCandidate) {
			return (
				<div style={{ flex: 1, minHeight: 0, paddingLeft: "12px", height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
					<div style={{ color: "#5f6f82", fontStyle: "italic" }}>Select a datasource collection to start mapping visuals.</div>
				</div>
			);
		}

		if (!selectedRow) {
			return (
				<div style={{ flex: 1, minHeight: 0, paddingLeft: "12px", height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
					<div style={{ color: "#5f6f82", fontStyle: "italic" }}>
						{selectedCandidate.visualStorage === AUTHORING_VISUAL_STORAGE_MODE
							? "Select an entity to assign images or swatches."
							: "Select a row to assign images or swatches."}
					</div>
				</div>
			);
		}

		return (
			<div style={{ flex: 1, minHeight: 0, paddingLeft: "12px", height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
				<div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "10px", marginBottom: "12px", flex: "0 0 auto" }}>
					<div style={{ minWidth: 0 }}>
						<div style={{ fontSize: "22px", fontWeight: 700 }}>{getGenericRowDisplayLabel(selectedRow, selectedCandidate)}</div>
						<div style={{ color: "#5f6f82", marginTop: "4px" }}>{getGenericRowValueLabel(selectedRow, selectedCandidate) || selectedRow.__rowIdentity}</div>
						<div style={{ fontSize: "12px", color: "#7b8794", marginTop: "6px" }}>
							Source: <code>{selectedCandidate.path || "(root)"}</code>
							{selectedRow.__mapKey ? <> • Group: <code>{selectedRow.__mapKey}</code></> : null}
						</div>
					</div>
					<Button bsSize="small" onClick={() => this.setState({ selectedOptionDetailsCollapsed: !selectedOptionDetailsCollapsed })}>
						<FontAwesomeIcon icon={selectedOptionDetailsCollapsed ? "chevron-down" : "chevron-up"} /> {selectedOptionDetailsCollapsed ? "Expand" : "Collapse"}
					</Button>
				</div>
				<div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
					{this.renderAuthoringRelatedEntities(selectedCandidate, selectedRow)}
					{isSelectionGroupEntity && (
						<div style={{ marginBottom: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #f5d18b", background: "#fff8eb", color: "#7a5700", fontSize: "12px", lineHeight: 1.5 }}>
							<b>Selection Group note:</b> this entity defines the picker family. The actual one-to-many visual choices live on the linked <b>Selection Options</b> below.
						</div>
					)}
					<div style={{ marginBottom: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd" }}>
						<div style={{ fontWeight: 600, marginBottom: "8px" }}>Path Metadata</div>
						<div style={{ fontSize: "12px", color: "#5f6f82", lineHeight: 1.6 }}>
							<div><b>Collection:</b> <code>{selectedCandidate.path || "(root)"}</code></div>
							<div><b>{selectedCandidate.visualStorage === AUTHORING_VISUAL_STORAGE_MODE ? "Entity key" : "Row key"}:</b> <code>{selectedCandidate.rowIdKey}</code></div>
							<div><b>Label key:</b> <code>{selectedCandidate.labelKey || "(derived)"}</code></div>
							<div><b>Value key:</b> <code>{selectedCandidate.valueKey || "(derived)"}</code></div>
						</div>
					</div>
					{!selectedOptionDetailsCollapsed && (
						<>
							<div style={{
								height: "240px",
								border: "1px solid #d7dee7",
								borderRadius: "12px",
								background: "#f5f7fa",
								overflow: "hidden",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								marginBottom: "12px",
								flex: "0 0 auto"
							}}>
								{selectedImageUrl ? (
									<img src={selectedImageUrl} alt={getGenericRowDisplayLabel(selectedRow, selectedCandidate)} style={{ width: "100%", height: "100%", objectFit: imageFitMode, background: "#ffffff" }} />
								) : selectedSwatchColor ? (
									<div style={{ width: "100%", height: "100%", background: selectedSwatchColor }} />
								) : (
									<div style={{ textAlign: "center", color: "#7b8794" }}>
										<FontAwesomeIcon icon="image" style={{ fontSize: "28px", marginBottom: "8px" }} />
										<div>No visual assigned</div>
									</div>
								)}
							</div>
							<div style={{ marginBottom: "12px", color: "#5f6f82", fontSize: "12px" }}>
								<div><b>Current URL:</b> {selectedImageUrl || "None"}</div>
								<div style={{ marginTop: "4px" }}><b>Drive Path:</b> {_.get(selectedRow, "imageDrivePath", "None")}</div>
								<div style={{ marginTop: "4px" }}><b>Swatch:</b> {selectedSwatchColor || "None"}</div>
							</div>
						</>
					)}
					{(optionVisualMode === "swatch" || optionVisualMode === "both") && (
						<div style={{
							marginBottom: "12px",
							padding: "12px",
							borderRadius: "10px",
							border: "1px solid #e3e8ef",
							background: "#fafbfd"
						}}>
							<div style={{ fontWeight: 600, marginBottom: "8px" }}>Assign Swatch</div>
							<div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
								<div
									style={{
										width: "48px",
										height: "48px",
										borderRadius: "10px",
										border: "1px solid #d7dee7",
										background: swatchInputValue || swatchPickerValue || "#ffffff",
										flex: "0 0 48px"
									}}
								/>
								<input
									type="color"
									value={swatchPickerValue}
									onChange={this.handleSwatchPickerChange}
									style={{ width: "52px", height: "40px", padding: "0", border: "none", background: "transparent", cursor: "pointer" }}
								/>
								<FormControl
									type="text"
									value={swatchInputValue}
									placeholder="#c8bea9 or lightgray"
									onChange={this.handleSwatchInputChange}
								/>
							</div>
							<div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
								<Button bsStyle="primary" bsSize="small" onClick={this.handleAssignSwatch}>
									<FontAwesomeIcon icon="tint" /> Apply Swatch
								</Button>
								<Button bsSize="small" onClick={this.handleClearSwatch} disabled={!selectedSwatchColor}>
									<FontAwesomeIcon icon="ban" /> Clear Swatch
								</Button>
							</div>
						</div>
					)}
					{(optionVisualMode === "image" || optionVisualMode === "both") && (
						<div style={{
							marginBottom: "12px",
							padding: "12px",
							borderRadius: "10px",
							border: "1px solid #e3e8ef",
							background: "#fafbfd"
						}}>
							<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", marginBottom: "8px" }}>
								<div style={{ fontWeight: 600 }}>Assign From Drive</div>
								<div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", justifyContent: "flex-end" }}>
									<Button
										bsSize="small"
										bsStyle="primary"
										onClick={this.handleAssignSelectedDriveResource}
										disabled={!selectedDriveResource || selectedDriveResource.type !== "file"}
									>
										<FontAwesomeIcon icon="check" /> Assign Selected
									</Button>
									<Button
										bsSize="small"
										onClick={this.handleShowImageEditorModal}
										disabled={!selectedDriveResource || !isImageDriveFile(selectedDriveResource)}
									>
										<FontAwesomeIcon icon="image" /> Edit Image
									</Button>
									<Button
										bsSize="small"
										onClick={this.handleShowMetadataModal}
										disabled={!selectedDriveResource}
									>
										<FontAwesomeIcon icon="tags" /> Metadata
									</Button>
									<Button
										bsSize="small"
										onClick={this.handleShowRenameModal}
										disabled={!selectedDriveResource}
									>
										<FontAwesomeIcon icon="pencil-alt" /> Rename
									</Button>
									<Button
										bsStyle={assignMode === "gallery" ? "primary" : "default"}
										bsSize="small"
										onClick={() => this.setState({ assignMode: "gallery" })}
									>
										<FontAwesomeIcon icon="images" /> Gallery
									</Button>
									<Button
										bsStyle={assignMode === "picker" ? "primary" : "default"}
										bsSize="small"
										onClick={() => this.setState({ assignMode: "picker" })}
									>
										<FontAwesomeIcon icon={["far", "folder-open"]} /> Picker
									</Button>
								</div>
							</div>
							{assignMode === "picker" && (
								<div style={{ minHeight: "520px" }}>
									<InlineFilePicker
										modal
										value={currentDriveResource}
										accept="image/*"
										onFileSelected={this.handleAssignImage}
									/>
								</div>
							)}
							{assignMode === "gallery" && (
								<div>
									<div style={{ marginBottom: "10px" }}>
										<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "6px", color: "#5f6f82" }}>Folder Path</div>
										<InputGroup>
											<FormControl
												type="text"
												value={galleryFolderPath}
												placeholder="public/picker-assets/color-location/"
												onChange={(e) => this.setState({ galleryFolderPath: e.target.value })}
												onKeyDown={(e) => {
													if (e.key === "Enter") {
														this.loadGalleryFiles();
													}
												}}
											/>
											<InputGroup.Button>
												<Button onClick={() => this.loadGalleryFiles()} disabled={galleryLoading}>
													<FontAwesomeIcon icon="sync" /> {galleryLoading ? "Loading..." : "Load"}
												</Button>
												<Button onClick={this.handleShowFolderPicker}>
													<FontAwesomeIcon icon={["far", "folder-open"]} /> Browse Folder
												</Button>
											</InputGroup.Button>
										</InputGroup>
										<div style={{ fontSize: "12px", color: "#7b8794", marginTop: "6px" }}>
											Use Drive-style paths like <code>public/picker-assets/color-location/</code>. Click a tile to select it, then assign or edit it.
										</div>
										{selectedDriveResource && (
											<div style={{ marginTop: "8px", fontSize: "12px", color: "#5f6f82" }}>
												<b>Selected asset:</b> {selectedDriveResource.name || selectedDriveResource.path || selectedDriveResource.guid}
												{selectedDriveResourceIsAssigned ? " (currently assigned)" : ""}
											</div>
										)}
									</div>
									{galleryError && (
										<div style={{ marginBottom: "10px", padding: "10px 12px", borderRadius: "8px", border: "1px solid #f2c6c2", background: "#fff4f4", color: "#8a1f11" }}>
											{galleryError}
										</div>
									)}
									<div style={{
										display: "grid",
										gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))",
										gap: "10px",
										paddingTop: "4px"
									}}>
										{galleryFiles.map((file) => {
											const url = getUrlForExternalResource(file);
											const active = selectedDriveResource && file.guid === selectedDriveResource.guid;
											const assigned = selectedRow && file.guid === _.get(selectedRow, "imageDriveGuid");
											return (
												<button
													key={file.guid || file.path}
													type="button"
													onClick={() => this.handleSelectDriveResource(file)}
													onDoubleClick={() => this.handleAssignImage(file)}
													style={{
														border: active ? "2px solid #3b82f6" : "1px solid #d7dee7",
														borderRadius: "10px",
														background: "#ffffff",
														padding: "8px",
														textAlign: "left",
														color: "#253858"
													}}
												>
													<div style={{
														height: "84px",
														borderRadius: "8px",
														border: "1px solid #e3e8ef",
														overflow: "hidden",
														background: "#f5f7fa",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														marginBottom: "8px"
													}}>
														{url ? <img src={url} alt={file.name} style={{ width: "100%", height: "100%", objectFit: imageFitMode, background: "#ffffff" }} /> : <FontAwesomeIcon icon="image" />}
													</div>
													<div style={{ fontSize: "12px", lineHeight: 1.3, wordBreak: "break-word" }}>{file.name}</div>
													{assigned && (
														<div style={{ fontSize: "11px", lineHeight: 1.3, color: "#3c763d", marginTop: "4px", fontWeight: 600 }}>
															Assigned
														</div>
													)}
												</button>
											);
										})}
									</div>
									{!galleryLoading && galleryFiles.length === 0 && !galleryError && (
										<div style={{ color: "#5f6f82", fontStyle: "italic", paddingTop: "8px" }}>
											No image files found in this folder.
										</div>
									)}
								</div>
							)}
						</div>
					)}
					<div style={{ padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd", color: "#5f6f82", fontSize: "12px" }}>
						{selectedCandidate.visualStorage === AUTHORING_VISUAL_STORAGE_MODE
							? <>Writes visual fields directly onto canonical entities in <code>{selectedCandidate.path}</code>. Re-run compile to propagate them into picker and community runtime datasources.</>
							: <>Writes visual fields into an inline <code>_visualsByPath</code> overlay keyed by collection path and stable row id.</>}
					</div>
				</div>
			</div>
		);
	}

	renderSelectedOptionPanel() {
		const { selectedPickerId } = this.state;
		const selectedOption = this.getSelectedOption();
		const selectedArrayPicker = selectedPickerId ? getArrayPickerEntry(this.state.parsedContent, selectedPickerId) : null;
		const selectedImageUrl = getCurrentImageUrl(selectedOption);
		const selectedSwatchColor = getCurrentSwatchColor(selectedOption);
		const currentDriveResource = getCurrentDriveResource(selectedOption);
		const selectedDriveResource = this.getSelectedDriveResource();
		const selectedDriveResourceIsAssigned = !!(
			selectedDriveResource &&
			currentDriveResource &&
			selectedDriveResource.guid === currentDriveResource.guid
		);
		const {
			assignMode,
			galleryFolderPath,
			galleryFiles,
			galleryLoading,
			galleryError,
			imageFitMode,
			selectedOptionDetailsCollapsed,
			optionVisualMode,
			swatchInputValue,
			swatchPickerValue,
			newFamilyCustomFieldName,
			newFamilyCustomFieldKey,
			newFamilyCustomFieldType,
			newFamilyCustomFieldValue,
			newOptionCustomFieldName,
			newOptionCustomFieldKey,
			newOptionCustomFieldType,
			newOptionCustomFieldValue,
			optionValueAutoFormat
		} = this.state;
		const selectedFamilySource = selectedArrayPicker || getPickerEntry(this.state.parsedContent, selectedPickerId) || {};
		const familyCustomFields = getCustomFieldEntries(selectedFamilySource, MANAGED_FAMILY_KEYS);
		const optionCustomFields = selectedOption ? getCustomFieldEntries(selectedOption, MANAGED_OPTION_KEYS) : [];
		const validationIssues = validatePickerDatasource(this.state.parsedContent);

		if (!selectedPickerId) {
			return (
				<div style={{ flex: 1, minHeight: 0, paddingLeft: "12px", height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
					<div style={{ color: "#5f6f82", fontStyle: "italic" }}>Select or create a picker family to start editing.</div>
				</div>
			);
		}

		return (
			<div style={{ flex: 1, minWidth: 0, minHeight: 0, height: "100%", paddingLeft: "12px", display: "flex", flexDirection: "column", overflow: "hidden" }}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", marginBottom: "10px" }}>
					<div style={{ fontWeight: 700 }}>Selected Option</div>
					<div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", justifyContent: "flex-end" }}>
						<Button
							bsStyle="default"
							bsSize="small"
							onClick={() => this.setState({ selectedOptionDetailsCollapsed: !selectedOptionDetailsCollapsed })}
						>
							<FontAwesomeIcon icon={selectedOptionDetailsCollapsed ? "chevron-down" : "chevron-up"} /> {selectedOptionDetailsCollapsed ? "Expand Details" : "Collapse Details"}
						</Button>
						<div style={{ fontSize: "12px", fontWeight: 600, color: "#5f6f82" }}>Visual</div>
						<Button
							bsStyle={optionVisualMode === "swatch" ? "primary" : "default"}
							bsSize="small"
							onClick={() => this.setState({ optionVisualMode: "swatch" })}
						>
							Swatch
						</Button>
						<Button
							bsStyle={optionVisualMode === "image" ? "primary" : "default"}
							bsSize="small"
							onClick={() => this.setState({ optionVisualMode: "image" })}
						>
							Image
						</Button>
						<Button
							bsStyle={optionVisualMode === "both" ? "primary" : "default"}
							bsSize="small"
							onClick={() => this.setState({ optionVisualMode: "both" })}
						>
							Both
						</Button>
						<div style={{ fontSize: "12px", fontWeight: 600, color: "#5f6f82" }}>Fit</div>
						<Button
							bsStyle={imageFitMode === "cover" ? "primary" : "default"}
							bsSize="small"
							onClick={() => this.setState({ imageFitMode: "cover" })}
						>
							Cover
						</Button>
						<Button
							bsStyle={imageFitMode === "contain" ? "primary" : "default"}
							bsSize="small"
							onClick={() => this.setState({ imageFitMode: "contain" })}
						>
							Contain
						</Button>
					</div>
				</div>
				<div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
					<div style={{ marginBottom: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd" }}>
						<div style={{ fontWeight: 600, marginBottom: "10px" }}>Family Settings</div>
						<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
							<div>
								<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px", color: "#5f6f82" }}>Label</div>
								<FormControl
									type="text"
									value={selectedPickerId ? getPickerLabel(this.state.parsedContent, selectedPickerId) : ""}
									onChange={this.handleSelectedFamilyLabelChange}
								/>
							</div>
							<div>
								<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px", color: "#5f6f82" }}>ID</div>
								<FormControl
									key={`family-id-${selectedPickerId}`}
									type="text"
									defaultValue={selectedPickerId || ""}
									onBlur={this.handleSelectedFamilyIdChange}
								/>
							</div>
							<div>
								<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px", color: "#5f6f82" }}>Storage Mode</div>
								<FormControl componentClass="select" value={selectedPickerId ? getPickerStorageMode(this.state.parsedContent, selectedPickerId) : PICKER_STORAGE_MODE_BOTH} onChange={this.handleSelectedFamilyStorageModeChange}>
									<option value={PICKER_STORAGE_MODE_BOTH}>Both</option>
									<option value={PICKER_STORAGE_MODE_ARRAY}>Array</option>
									<option value={PICKER_STORAGE_MODE_MAP}>Map</option>
								</FormControl>
							</div>
						</div>
					<div style={{ fontSize: "12px", color: "#7b8794" }}>
						Array storage drives <code>pickers[]</code>. Map storage drives <code>pickersById</code>. Legacy <code>column</code> metadata is preserved if present, but new families do not require it.
					</div>
					<div style={{ marginTop: "10px" }}>
						<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px", color: "#5f6f82" }}>Auto-Format</div>
						<div style={{ fontSize: "12px", color: "#7b8794", marginBottom: "6px" }}>
							Used for option value generation and custom field key normalization when adding or renaming fields.
						</div>
						<FormControl
							componentClass="select"
							value={optionValueAutoFormat}
							onChange={this.handleChangeOptionValueAutoFormat}
							style={{ width: "240px", maxWidth: "100%" }}
						>
							{OPTION_VALUE_AUTO_FORMATS.map((formatOption) => (
								<option key={`editor-auto-format-${formatOption.value}`} value={formatOption.value}>{formatOption.label}</option>
							))}
						</FormControl>
					</div>
					</div>
					<div style={{ marginBottom: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd" }}>
						<div style={{ fontWeight: 600, marginBottom: "10px" }}>Family Custom Fields</div>
						{this.renderCustomFieldEditorRows(familyCustomFields, "family")}
						<div style={{ display: "grid", gridTemplateColumns: "1.3fr 120px 1.4fr auto", gap: "8px", alignItems: "start", marginTop: "10px" }}>
							<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
								<FormControl
									type="text"
									value={newFamilyCustomFieldName}
									placeholder="Field name"
									onChange={this.handleNewFamilyCustomFieldNameChange}
								/>
								<FormControl
									type="text"
									value={newFamilyCustomFieldKey}
									placeholder="fieldKey"
									onChange={this.handleNewFamilyCustomFieldKeyChange}
								/>
							</div>
							<FormControl
								componentClass="select"
								value={newFamilyCustomFieldType}
								onChange={(e) => this.setState({ newFamilyCustomFieldType: e.target.value })}
							>
								{CUSTOM_FIELD_TYPES.map((fieldType) => (
									<option key={fieldType} value={fieldType}>{fieldType}</option>
								))}
							</FormControl>
							<FormControl
								componentClass={newFamilyCustomFieldType === CUSTOM_FIELD_TYPE_JSON ? "textarea" : "input"}
								type={newFamilyCustomFieldType === CUSTOM_FIELD_TYPE_JSON ? undefined : "text"}
								value={newFamilyCustomFieldValue}
								placeholder={newFamilyCustomFieldType === CUSTOM_FIELD_TYPE_JSON ? "{\n  \"key\": \"value\"\n}" : "value"}
								onChange={(e) => this.setState({ newFamilyCustomFieldValue: e.target.value })}
								style={newFamilyCustomFieldType === CUSTOM_FIELD_TYPE_JSON ? { minHeight: "84px", fontFamily: "monospace" } : undefined}
							/>
							<Button bsStyle="primary" bsSize="small" onClick={this.handleAddFamilyCustomField}>
								<FontAwesomeIcon icon="plus" /> Add
							</Button>
						</div>
					</div>
					<div style={{ marginBottom: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd" }}>
						<div style={{ fontWeight: 600, marginBottom: "10px" }}>Option Fields</div>
						{selectedOption ? (
							<>
								<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
									<div>
										<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px", color: "#5f6f82" }}>Label</div>
										<FormControl
											type="text"
											value={_.get(selectedOption, "label", "")}
											onChange={(e) => this.handleSelectedOptionFieldChange("label", e.target.value)}
										/>
									</div>
									<div>
										<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px", color: "#5f6f82" }}>Value</div>
										<FormControl
											type="text"
											value={_.get(selectedOption, "value", "")}
											onChange={(e) => this.handleSelectedOptionFieldChange("value", e.target.value)}
										/>
									</div>
								</div>
								<div style={{ display: "flex", gap: "14px", flexWrap: "wrap" }}>
									<label style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: 0 }}>
										<input type="checkbox" checked={!!_.get(selectedOption, "isSelectable", false)} onChange={(e) => this.handleSelectedOptionFieldChange("isSelectable", e.target.checked)} />
										Selectable
									</label>
								<label style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: 0 }}>
										<input type="checkbox" checked={!!_.get(selectedOption, "isBold", false)} onChange={(e) => this.handleSelectedOptionFieldChange("isBold", e.target.checked)} />
										Bold
									</label>
									<label style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: 0 }}>
										<input type="checkbox" checked={!!_.get(selectedOption, "isHeader", false)} onChange={(e) => this.handleSelectedOptionFieldChange("isHeader", e.target.checked)} />
										Render as Header Row
									</label>
									<label style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: 0 }}>
										<input type="checkbox" checked={!!_.get(selectedOption, "isSpacer", false)} onChange={(e) => this.handleSelectedOptionFieldChange("isSpacer", e.target.checked)} />
										Render as Spacer Row
									</label>
								</div>
							</>
						) : (
							<div style={{ color: "#5f6f82", fontStyle: "italic" }}>No options yet. Use <b>Add Option</b> in the center pane.</div>
						)}
					</div>
					<div style={{ marginBottom: "12px", padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd" }}>
						<div style={{ fontWeight: 600, marginBottom: "10px" }}>Option Custom Fields</div>
						{selectedOption ? this.renderCustomFieldEditorRows(optionCustomFields, "option") : (
							<div style={{ color: "#5f6f82", fontStyle: "italic" }}>Select or create an option to edit custom fields.</div>
						)}
						{selectedOption && (
							<div style={{ display: "grid", gridTemplateColumns: "1.3fr 120px 1.4fr auto", gap: "8px", alignItems: "start", marginTop: "10px" }}>
								<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
									<FormControl
										type="text"
										value={newOptionCustomFieldName}
										placeholder="Field name"
										onChange={this.handleNewOptionCustomFieldNameChange}
									/>
									<FormControl
										type="text"
										value={newOptionCustomFieldKey}
										placeholder="fieldKey"
										onChange={this.handleNewOptionCustomFieldKeyChange}
									/>
								</div>
								<FormControl
									componentClass="select"
									value={newOptionCustomFieldType}
									onChange={(e) => this.setState({ newOptionCustomFieldType: e.target.value })}
								>
									{CUSTOM_FIELD_TYPES.map((fieldType) => (
										<option key={fieldType} value={fieldType}>{fieldType}</option>
									))}
								</FormControl>
								<FormControl
									componentClass={newOptionCustomFieldType === CUSTOM_FIELD_TYPE_JSON ? "textarea" : "input"}
									type={newOptionCustomFieldType === CUSTOM_FIELD_TYPE_JSON ? undefined : "text"}
									value={newOptionCustomFieldValue}
									placeholder={newOptionCustomFieldType === CUSTOM_FIELD_TYPE_JSON ? "{\n  \"key\": \"value\"\n}" : "value"}
									onChange={(e) => this.setState({ newOptionCustomFieldValue: e.target.value })}
									style={newOptionCustomFieldType === CUSTOM_FIELD_TYPE_JSON ? { minHeight: "84px", fontFamily: "monospace" } : undefined}
								/>
								<Button bsStyle="primary" bsSize="small" onClick={this.handleAddOptionCustomField}>
									<FontAwesomeIcon icon="plus" /> Add
								</Button>
							</div>
						)}
					</div>
					{selectedOption && !selectedOptionDetailsCollapsed && (
						<>
							<div style={{ marginBottom: "12px" }}>
								<div style={{ fontSize: "22px", fontWeight: 700 }}>{getOptionDisplayLabel(selectedOption)}</div>
								<div style={{ color: "#5f6f82", marginTop: "4px" }}>{_.get(selectedOption, "value", "")}</div>
							</div>
							<div style={{
								height: "240px",
								border: "1px solid #d7dee7",
								borderRadius: "12px",
								background: "#f5f7fa",
								overflow: "hidden",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								marginBottom: "12px",
								flex: "0 0 auto"
							}}>
								{selectedImageUrl ? (
									<img src={selectedImageUrl} alt={getOptionDisplayLabel(selectedOption)} style={{ width: "100%", height: "100%", objectFit: imageFitMode, background: "#ffffff" }} />
								) : selectedSwatchColor ? (
									<div style={{ width: "100%", height: "100%", background: selectedSwatchColor }} />
								) : (
									<div style={{ textAlign: "center", color: "#7b8794" }}>
										<FontAwesomeIcon icon="image" style={{ fontSize: "28px", marginBottom: "8px" }} />
										<div>No image assigned</div>
									</div>
								)}
							</div>
							<div style={{ marginBottom: "12px", color: "#5f6f82", fontSize: "12px" }}>
								<div><b>Current URL:</b> {selectedImageUrl || "None"}</div>
								<div style={{ marginTop: "4px" }}><b>Drive Path:</b> {_.get(selectedOption, "imageDrivePath", "None")}</div>
								<div style={{ marginTop: "4px" }}><b>Swatch:</b> {selectedSwatchColor || "None"}</div>
							</div>
						</>
					)}
					{selectedOption && (optionVisualMode === "swatch" || optionVisualMode === "both") && (
						<div style={{
							marginBottom: "12px",
							padding: "12px",
							borderRadius: "10px",
							border: "1px solid #e3e8ef",
							background: "#fafbfd"
						}}>
							<div style={{ fontWeight: 600, marginBottom: "8px" }}>Assign Swatch</div>
							<div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
								<div
									style={{
										width: "48px",
										height: "48px",
										borderRadius: "10px",
										border: "1px solid #d7dee7",
										background: swatchInputValue || swatchPickerValue || "#ffffff",
										flex: "0 0 48px"
									}}
								/>
								<input
									type="color"
									value={swatchPickerValue}
									onChange={this.handleSwatchPickerChange}
									style={{ width: "52px", height: "40px", padding: "0", border: "none", background: "transparent", cursor: "pointer" }}
								/>
								<FormControl
									type="text"
									value={swatchInputValue}
									placeholder="#c8bea9 or lightgray"
									onChange={this.handleSwatchInputChange}
								/>
							</div>
							<div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
								<Button bsStyle="primary" bsSize="small" onClick={this.handleAssignSwatch}>
									<FontAwesomeIcon icon="tint" /> Apply Swatch
								</Button>
								<Button bsSize="small" onClick={this.handleClearSwatch} disabled={!selectedSwatchColor}>
									<FontAwesomeIcon icon="ban" /> Clear Swatch
								</Button>
							</div>
							<div style={{ fontSize: "12px", color: "#7b8794", marginTop: "8px" }}>
								Writes the canonical <code>swatchColor</code> field. CSS color names and hex values are supported.
							</div>
						</div>
					)}
					{selectedOption && (optionVisualMode === "image" || optionVisualMode === "both") && (
						<div style={{
							marginBottom: "12px",
							padding: "12px",
							borderRadius: "10px",
							border: "1px solid #e3e8ef",
							background: "#fafbfd"
						}}>
							<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", marginBottom: "8px" }}>
								<div style={{ fontWeight: 600 }}>Assign From Drive</div>
								<div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", justifyContent: "flex-end" }}>
									<Button
										bsSize="small"
										bsStyle="primary"
										onClick={this.handleAssignSelectedDriveResource}
										disabled={!selectedDriveResource || selectedDriveResource.type !== "file"}
									>
										<FontAwesomeIcon icon="check" /> Assign Selected
									</Button>
									<Button
										bsSize="small"
										onClick={this.handleShowImageEditorModal}
										disabled={!selectedDriveResource || !isImageDriveFile(selectedDriveResource)}
									>
										<FontAwesomeIcon icon="image" /> Edit Image
									</Button>
									<Button
										bsSize="small"
										onClick={this.handleShowMetadataModal}
										disabled={!selectedDriveResource}
									>
										<FontAwesomeIcon icon="tags" /> Metadata
									</Button>
									<Button
										bsSize="small"
										onClick={this.handleShowRenameModal}
										disabled={!selectedDriveResource}
									>
										<FontAwesomeIcon icon="pencil-alt" /> Rename
									</Button>
									<Button
										bsStyle={assignMode === "gallery" ? "primary" : "default"}
										bsSize="small"
										onClick={() => this.setState({ assignMode: "gallery" })}
									>
										<FontAwesomeIcon icon="images" /> Gallery
									</Button>
									<Button
										bsStyle={assignMode === "picker" ? "primary" : "default"}
										bsSize="small"
										onClick={() => this.setState({ assignMode: "picker" })}
									>
										<FontAwesomeIcon icon={["far", "folder-open"]} /> Picker
									</Button>
								</div>
							</div>
							{assignMode === "picker" && (
								<div style={{ minHeight: "520px" }}>
									<InlineFilePicker
										modal
										value={currentDriveResource}
										accept="image/*"
										onFileSelected={this.handleAssignImage}
									/>
								</div>
							)}
							{assignMode === "gallery" && (
								<div>
									<div style={{ marginBottom: "10px" }}>
										<div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "6px", color: "#5f6f82" }}>Folder Path</div>
										<InputGroup>
											<FormControl
												type="text"
												value={galleryFolderPath}
												placeholder="public/picker-assets/color-location/"
												onChange={(e) => this.setState({ galleryFolderPath: e.target.value })}
												onKeyDown={(e) => {
													if (e.key === "Enter") {
														this.loadGalleryFiles();
													}
												}}
											/>
											<InputGroup.Button>
												<Button onClick={() => this.loadGalleryFiles()} disabled={galleryLoading}>
													<FontAwesomeIcon icon="sync" /> {galleryLoading ? "Loading..." : "Load"}
												</Button>
												<Button onClick={this.handleShowFolderPicker}>
													<FontAwesomeIcon icon={["far", "folder-open"]} /> Browse Folder
												</Button>
											</InputGroup.Button>
										</InputGroup>
										<div style={{ fontSize: "12px", color: "#7b8794", marginTop: "6px" }}>
											Use Drive-style paths like <code>public/picker-assets/color-location/</code>. Click a tile to select it, then assign or edit it.
										</div>
										{selectedDriveResource && (
											<div style={{ marginTop: "8px", fontSize: "12px", color: "#5f6f82" }}>
												<b>Selected asset:</b> {selectedDriveResource.name || selectedDriveResource.path || selectedDriveResource.guid}
												{selectedDriveResourceIsAssigned ? " (currently assigned)" : ""}
											</div>
										)}
									</div>
									{galleryError && (
										<div style={{ marginBottom: "10px", padding: "10px 12px", borderRadius: "8px", border: "1px solid #f2c6c2", background: "#fff4f4", color: "#8a1f11" }}>
											{galleryError}
										</div>
									)}
									<div style={{
										display: "grid",
										gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))",
										gap: "10px",
										paddingTop: "4px"
									}}>
										{galleryFiles.map((file) => {
											const url = getUrlForExternalResource(file);
											const active = selectedDriveResource && file.guid === selectedDriveResource.guid;
											const assigned = selectedOption && file.guid === _.get(selectedOption, "imageDriveGuid");
											return (
												<button
													key={file.guid || file.path}
													type="button"
													onClick={() => this.handleSelectDriveResource(file)}
													onDoubleClick={() => this.handleAssignImage(file)}
													style={{
														border: active ? "2px solid #3b82f6" : "1px solid #d7dee7",
														borderRadius: "10px",
														background: "#ffffff",
														padding: "8px",
														textAlign: "left",
														color: "#253858"
													}}
												>
													<div style={{
														height: "84px",
														borderRadius: "8px",
														border: "1px solid #e3e8ef",
														overflow: "hidden",
														background: "#f5f7fa",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														marginBottom: "8px"
													}}>
														{url ? <img src={url} alt={file.name} style={{ width: "100%", height: "100%", objectFit: imageFitMode, background: "#ffffff" }} /> : <FontAwesomeIcon icon="image" />}
													</div>
													<div style={{ fontSize: "12px", lineHeight: 1.3, wordBreak: "break-word" }}>{file.name}</div>
													{assigned && (
														<div style={{ fontSize: "11px", lineHeight: 1.3, color: "#3c763d", marginTop: "4px", fontWeight: 600 }}>
															Assigned
														</div>
													)}
												</button>
											);
										})}
									</div>
									{!galleryLoading && galleryFiles.length === 0 && !galleryError && (
										<div style={{ color: "#5f6f82", fontStyle: "italic", paddingTop: "8px" }}>
											No image files found in this folder.
										</div>
									)}
								</div>
							)}
						</div>
					)}
					{this.renderValidationPanel(validationIssues, selectedPickerId, _.get(selectedOption, "__optionIdentity", null))}
					<div style={{ padding: "12px", borderRadius: "10px", border: "1px solid #e3e8ef", background: "#fafbfd", color: "#5f6f82", fontSize: "12px" }}>
						Saves visual fields to both <code>pickersById</code> and <code>pickers[]</code>, recalculates <code>allKeys</code> / <code>commonKeys</code>, and preserves family order.
					</div>
				</div>
			</div>
		);
	}

	renderMapper() {
		const { parsedContent, validity, mapperMode } = this.state;

		if (!validity.valid) {
			return (
				<div style={{ padding: "16px", color: "#8a1f11" }}>
					<div style={{ fontWeight: 700, marginBottom: "8px" }}>Mapper unavailable</div>
					<div>The JSON is currently invalid. Fix the raw JSON first.</div>
				</div>
			);
		}

		if (mapperMode === "picker") {
			return (
				<div style={{ display: "flex", minHeight: "70vh", height: "70vh", overflow: "hidden", alignItems: "stretch" }}>
					{this.renderPickerList()}
					{this.renderOptionList()}
					{this.renderSelectedOptionPanel()}
				</div>
			);
		}

		if (mapperMode === "generic") {
			return (
				<div style={{ display: "flex", minHeight: "70vh", height: "70vh", overflow: "hidden", alignItems: "stretch" }}>
					{this.renderGenericPathList()}
					{this.renderGenericRowList()}
					{this.renderGenericSelectedRowPanel()}
				</div>
			);
		}

		if (!isPickerDatasourceDocument(parsedContent)) {
			return (
				<div style={{ padding: "16px", color: "#5f6f82" }}>
					<div style={{ fontWeight: 700, marginBottom: "8px", color: "#253858" }}>Mapper unavailable</div>
					<div>This JSON document does not expose a supported picker datasource, canonical authoring datasource, or generic row collection with stable ids. The mapper activates when the file contains <code>pickersById</code>/<code>pickers</code>, canonical <code>collections.*ById</code>, or generic collections such as arrays and map-of-arrays with row ids.</div>
				</div>
			);
		}
	}

	renderRawEditor() {
		const { rawContent, validity } = this.state;

		return (
			<div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
				{validity && !validity.valid && (
					<div style={{ marginBottom: "10px", padding: "10px 12px", borderRadius: "8px", border: "1px solid #f2c6c2", background: "#fff4f4", color: "#8a1f11" }}>
						<b>Invalid JSON:</b> {_.get(validity, "error.message", "Unknown parse error")}
					</div>
				)}
				<div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", border: "1px solid #d7dee7", borderRadius: "8px" }}>
					<JsonEditor
						content={rawContent}
						onChange={this.handleRawChange}
						onValidityChange={(validityState) => {
							this.setState({ validity: validityState }, () => this.emitEditorState(this.state.rawContent, validityState));
						}}
					/>
				</div>
			</div>
		);
	}

	render() {
		const { activeTab, mapperMode } = this.state;
		const canUseMapper = !!mapperMode;
		const isAuthoringDatasource = isCanonicalAuthoringDatasourceDocument(this.state.parsedContent);

		return (
			<div ref={this.editorRootRef} className="picker-datasource-editor-shell">
				<div style={{ marginBottom: "12px", color: "#5f6f82" }}>
					{mapperMode === "picker"
						? "Use Mapper for fast image assignment on picker datasource options, or Raw JSON for direct edits."
						: isAuthoringDatasource
							? "Use Mapper to attach visuals directly to canonical authoring entities. Compile targets define which runtime datasources are generated from this file."
						: mapperMode === "generic"
							? "Use Mapper to attach inline overlay visuals to generic datasource rows, or Raw JSON for direct edits."
							: "This document does not expose a supported picker or generic datasource mapper shape, so only Raw JSON editing is available."}
				</div>
				<Tabs
					className="picker-datasource-editor-tabs"
					id="picker-datasource-editor-tabs"
					activeKey={activeTab}
					onSelect={this.handleSelectTab}
					animation={false}
					mountOnEnter
					unmountOnExit
				>
					<Tab
						eventKey="mapper"
						title={<span><FontAwesomeIcon icon="image" /> Mapper</span>}
						disabled={!canUseMapper}
					>
						<div className="picker-datasource-editor-tab-panel">
							{this.renderMapper()}
						</div>
					</Tab>
					<Tab
						eventKey="raw"
						title={<span><FontAwesomeIcon icon="code" /> Raw JSON</span>}
					>
						<div className="picker-datasource-editor-tab-panel">
							{this.renderRawEditor()}
						</div>
					</Tab>
				</Tabs>
				<Modal
					open={this.state.showFolderPicker}
					onClose={this.handleHideFolderPicker}
					classNames={{ modal: "custom-modal templates" }}
					closeButton
				>
					<div style={{ height: "100%", display: "flex", flexDirection: "column", minWidth: "70vw", minHeight: "70vh" }}>
						<div style={{ flex: 0 }}>
							<h3>Select Source Folder</h3>
							<div style={{ color: "#5f6f82", marginBottom: "12px" }}>
								Select a folder and click <b>OK</b> to use it as the gallery source.
							</div>
							<hr />
						</div>
						<div style={{ flex: 1, minHeight: 0 }}>
							<DriveWrapper
								inline
								modal
								hideActionBar
								folderOnly
								okCancel
								onOk={this.handleSelectGalleryFolder}
								onCancel={this.handleHideFolderPicker}
							/>
						</div>
					</div>
				</Modal>
				{this.state.showImageEditorModal && this.state.imageEditorTarget && (
					<ImageEditorModal
						open={this.state.showImageEditorModal}
						onClose={this.handleHideImageEditorModal}
						onCreate={this.handleCreateEditedImage}
						imageUrl={getUrlForExternalResource(this.state.imageEditorTarget)}
						driveObjectGuid={this.state.imageEditorTarget.guid}
						imageLabel={this.state.imageEditorTarget.name}
						defaultBaseName={`${this.state.imageEditorTarget.name || "image-edited"}`.replace(/\.[^/.]+$/, "")}
						originalImageName={this.state.imageEditorTarget.name}
						overwriteTargetPath={this.state.imageEditorTarget.path || ""}
					/>
				)}
				<DriveMetadataEditorModal
					open={this.state.showMetadataModal}
					onClose={this.handleHideMetadataModal}
					targetName={this.state.metadataEditorTarget?.name || "selected file"}
					previewUrl={this.state.metadataEditorTarget ? getUrlForExternalResource(this.state.metadataEditorTarget) : ""}
					previewType={this.getMetadataResourceMediaType(this.state.metadataEditorTarget)}
					galleryItems={this.getMetadataGalleryItems()}
					galleryIndex={this.getMetadataGalleryIndex()}
					saving={this.state.metadataEditorSaving}
					metadataGeneratingField={this.state.metadataGeneratingField}
					title={this.state.metadataEditorTitle}
					description={this.state.metadataEditorDescription}
					transcript={this.state.metadataEditorTranscript}
					transcriptVtt={this.state.metadataEditorTranscriptVtt}
					primaryTags={this.state.metadataEditorPrimaryTags}
					secondaryTags={this.state.metadataEditorSecondaryTags}
					tagsInput={this.state.metadataEditorTagsInput}
					transcriptProvider={this.state.metadataTranscriptProvider}
					tagsProvider={this.state.metadataTagsProvider}
					onTitleChange={this.handleMetadataTitleChange}
					onDescriptionChange={this.handleMetadataDescriptionChange}
					onTranscriptChange={this.handleMetadataTranscriptChange}
					onTranscriptVttChange={this.handleMetadataTranscriptVttChange}
					onTagsInputChange={this.handleMetadataTagsInputChange}
					onAddTags={this.handleAddMetadataInputTags}
					onRemovePrimaryTag={this.handleRemoveMetadataPrimaryTag}
					onPromoteSecondaryTag={this.handlePromoteMetadataSecondaryTag}
					onPromoteAllSecondaryTags={this.handlePromoteAllMetadataSecondaryTags}
					onGallerySelect={this.handleMetadataGallerySelect}
					onTranscriptProviderChange={this.handleMetadataTranscriptProviderChange}
					onTagsProviderChange={this.handleMetadataTagsProviderChange}
					onGenerateTitle={this.handleGenerateMetadataTitle}
					onGenerateDescription={this.handleGenerateMetadataDescription}
					onGenerateTranscript={this.handleGenerateMetadataTranscript}
					onGenerateTranscriptVtt={this.handleGenerateMetadataTranscriptVtt}
					onGenerateTags={this.handleGenerateMetadataTags}
					onSaveAndPrevious={() => this.handleSaveMetadataAndNavigate(-1)}
					onSaveAndNext={() => this.handleSaveMetadataAndNavigate(1)}
					onSave={this.handleSaveMetadata}
				/>
				<Modal
					open={this.state.showRenameModal}
					onClose={this.state.renameSaving ? () => {} : this.handleHideRenameModal}
					classNames={{ modal: "custom-modal" }}
					closeButton
				>
					<div>
						<h4>Rename File</h4>
						<hr />
						<div className="map-modal-body-container">
							<div style={{ marginBottom: "10px", color: "#5f6f82" }}>
								Rename <b>{this.state.renameTarget?.name || "selected file"}</b>.
							</div>
							<FormGroup controlId="picker-drive-rename">
								<ControlLabel>File Name</ControlLabel>
								<FormControl
									type="text"
									value={this.state.renameFileName}
									onChange={this.handleRenameFileNameChange}
									placeholder="Enter new file name"
								/>
							</FormGroup>
						</div>
						<div className="modal-footer-container">
							<Button onClick={this.handleHideRenameModal} style={{ marginRight: "10px" }} disabled={this.state.renameSaving}>
								Cancel
							</Button>
							<Button
								bsStyle="primary"
								onClick={this.handleSaveRename}
								disabled={this.state.renameSaving || _.isEmpty(_.trim(this.state.renameFileName || ""))}
							>
								<FontAwesomeIcon icon={this.state.renameSaving ? "spinner" : "save"} spin={this.state.renameSaving} /> {this.state.renameSaving ? "Saving..." : "Rename"}
							</Button>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}
